/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable radix */
/* eslint-disable react/sort-comp */
/* eslint-disable prettier/prettier */
// Libraries
import React, { Component, Suspense } from "react";
import styled from "styled-components";
import { MapInteractionCSS } from "react-map-interaction";
import i18n from 'i18next';
import Base64Downloader, {
  triggerBase64Download,
} from "common-base64-downloader-react";
import axios from "axios";
import axiosRetry from "axios-retry";
import html2canvas from "html2canvas";
// import * as Sentry from '@sentry/react';
import moment from "moment/moment";
import Bowser from "bowser";
import "./css-animations/sideLog-animation.css";

// Constants
import { Height, ThreeSixtyOutlined } from "@material-ui/icons";
// import { asDynamicObservableObject } from 'mobx/dist/internal';
import { Howl, Howler } from "howler";
import { getLanguages } from './i18n';
import themeStyles from "./Constants/theme";
import fetchConfig from "./Constants/fetch";
import { centerContentBoard, centerContentProjectSheet } from "./Constants/styles";
// Utilities
import {
  filterTasksFromData,
  filterRelationshipsFromData,
  checkDirection,
  progressAnimationCoords,
  checkReverseDirection,
  logSummary,
  sendUserLoginData,
  createNewGame,
} from "./utils/global";

// Assets
import background from "./assets/images/background.png";
// Sounds

import toggleProjectSound from "./assets/sounds/BUTTONS.wav";
import stepsSound from "./assets/sounds/step.wav";
import moneySound from "./assets/sounds/CoinsDrop.wav";
import assistantSound from "./assets/sounds/assistantSound.mp3";
import dragTaksSound from "./assets/sounds/taskdrag.mp3";
import errorSound from "./assets/sounds/error.wav";
import soundForFlipAndCards from "./assets/sounds/FlipCard.wav";

// Components
import {
  TopBar,
  Tile,
  SideBar,
  Modal,
  NetworkErrorPopUp,
  BrowserErrorPopUp,
  RestoreGamePopUp,
  TaskPopUp,
  ResourcesPopUp,
  ToolTipPopUp,
  LeftSideIcons,
  GeneralInfoGateControl,
  GameDefinitions,
  Gates,
  GameLog,
  Trivia,
  Tutorial,
  ExecuteTaskPopUp,
  MilestoneModal,
  StartGamePopUp,
  BeginTurnPopUp,
  AfterMilestonePopUp,
  NotEnoughResourcesPopUp,
  GateSecondControlPopUp,
  PlanYourProjectPopUp,
  TestForm,
  PrevReportPopUp,
  IdleTimer,
  IdlePopUp,
  BlockElement,
  AssistantChat,
  ChangeProjectPopUp,
} from "./components/index";
import {
  Tasks,
  Login,
  Report,
  MobileMessage,
  MaintanenceMode,
  NewLoginPage
} from "./pages/index";
import { updateBoard, Board, Board as BoardData } from "./data/Board";
import { Cards as CardsData } from "./data/Cards";
import { ConstraintOuterCircle, Info } from "./Constants/assets";
import { GeneralPMTasks } from "./data/GeneralPMTasks";
import ResizePopUp from "./components/LargeScreenPopUp/ResizePopup";
import Help from "./pages/Help/Help";
import CreateListener from "./socket";

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-image: url(${background});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* // justify-content: flex-end; */
`;
const ContentSection = styled.div`
  ${(props) => !props.isProjectSheetOpen ? centerContentBoard : centerContentProjectSheet}
  overflow: hidden;
  `;

const RightLine = styled.div`
  width: 8vw;
  height: 7px;
  background: linear-gradient(
    ${(props) => (props.reverse ? "to right" : "to left")},
    ${(props) => props.previousCardColor},
    ${(props) => props.currentCardColor}
  );
  position: absolute;
  z-index: -1;
`;

const UpLine = styled.div`
  height: 12vh;
  width: 7px;
  background: linear-gradient(
    to top,
    ${(props) => props.previousCardColor},
    ${(props) => props.currentCardColor}
  );
  position: absolute;
  z-index: -1;
`;
/* 
    - Add theme
*/
class App extends Component {
  constructor(props) {
    super(props);
    this.isGamePausedRef = React.createRef();
    this.cardsLiveViewRefGlobal = React.createRef();
    this.isGamePausedRef.current = false;
    this.gameStartTime = React.createRef();
    this.totalTimeoutDuration = React.createRef();
    this.timeoutStartTime = React.createRef();
    this.gameStartTime.current = performance.now();
    this.isPlanningRef = React.createRef();
    this.isPlanningRef.current = false;
    this.totalTimoutInPlanningDuration = React.createRef();
    this.totalTimoutInPlanningDuration.current = 0;
    this.startedPlanningTimeRef = React.createRef();
    this.totalPlanningTimeRef = React.createRef();
    this.mileStonePositions = React.createRef(); // calculating it on each render would be very resource consuming.
    this.mileStonePositions.current = Board.filter(
      (e) => e.type === "mile-stone"
    ).map((e) => e.id);
    this.gatePositions = React.createRef(); // calculating it on each render would be very resource consuming.
    this.gatePositions.current = Board.filter((e) => e.type === "gate").map(
      (e) => e.id
    );
    this.projectPopupCount = React.createRef(0);
    this.projectPopupCount.current = 0;

    this.changedProjectOrder = React.createRef(false);
    this.changedProjectOrder.current = false;

    this.lastFlipped = React.createRef(0);
    this.lastFlipped.current = 0;

    this.timeSeconds = React.createRef(0);
    this.timeSeconds.current = 0;
    this.pauseForPlanningTimer = React.createRef(0);
    this.pauseForPlanningTimer.current = 0;

    this.hasExecuteRemainingTasksAtGateRef = React.createRef(false);
    this.hasExecuteRemainingTasksAtGateRef.current = 0;

    this.totalPlanningTimeRef.current = 0;
    this.preGamePlanningNetMsRef = { current: null }; // frozen net ms once the game starts; used for reports/snapshots
    this.totalTimeoutDuration.current = 0;

    this.executeTaskWithOpenPredecessor = React.createRef(false);
    this.executeTaskWithOpenPredecessor.current = false;

    this.executeTaskWithNotEnoughResources = React.createRef(false);
    this.executeTaskWithNotEnoughResources = false;

    this.state = this.getInitialState();
  }

  getInitialState = () => ({
      value: {
        scale: 1,
        translation: { x: 0, y: 0 },
      },
      socketIO: null,
      isMaintanenceModeActive: false,
      openGeneralPmTasks: false,
      gameEventId: 0,
      idlePopUp: false,
      executeGPMTOnMilestone: false,
      firstGateTileId: 0,
      firstMilestoneTileId: 0,
      firstMileStonePassed: true,
      tasksTimer: null,
      gameLogLoading: false,
      needsToDelayExecutePopup: false,
      error: null,
      errorInfo: null,
      sentErrorLog: false,
      showNetworkErrorPopUp: false,
      showBrowserErrorPopUp: false,
      showRestoreGamePopup: false,
      budgetRequest: { count: 0, budget: 2000 },
      resourcesForDoublePrice: 0,
      isContinuedGame: false, // a flag to check if this is a previous game that we are resuming
      prevGameId: null,
      tempUserId: null, // used to temporarily hold the user id before actually logging in
      tempPlayerName: null, // used to temporarily hold player display name before actually logging in
      modalToggle: true,
      playerEmail: "",
      modalTitle: "modals.welcome.info_title",
      modalText: ``,
      modalButton: "modals.welcome.button2",
      modalInfoButton: "modals.welcome.button1",
      showExperationModal: false,
      taskToggle: false,
      resourceToggle: false,
      toggleToolTip: false,
      gameLogToggle: false,
      showTrivia: false,
      generalInfoShow: false,
      isStartTurnMessageShowing: false,
      gameDefinitionsShow: false,
      projectNeedToBeDisabled: false,
      MilestoneModalShow: false,
      delayCardIsTakenInGateControl: true,
      gateTextNeedToChange: false,
      gateSecondControlShow: false,
      secondGateControlNeeded: false,
      openTriviaWhenDelayTaken: false,
      amountResourcesExpensive: [0, 0, 0],
      playerTotalValue: [],
      playerRemainignBudget: [],
      playerRegularResources: [],
      playerSeniorResources: [],
      playerExpensiveResources: [],
      playerTurnNumber: [],
      turnNumber: 1,
      BeginTurnPopUpShow: false,
      AfterMilestonePopUpShow: false,
      afterMilestonChecked: false,
      beginTurnChecked: false,
      tutorialShow: false,
      helpShow: false,
      gameFirstPopUp: false,
      infoTitle: "Gate Info",
      definitionsTitle: "Table",
      tutorialTitle: "Tutorial",
      infoParagraph:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis",
      projectStage: 0,
      checkedTask: null,
      showOpenProjectSheetAfterBack: false,
      card: {
        cardToggle: false,
      },
      milestone: [false, false, false, false, false, false, false],
      turnNeedsToEndInGate: false,
      gate: [false, false, false],
      toggleGate: false,
      gateTasks: [],
      showIsPaused: false,
      disableAdditionalBudgetPopUpSideBar: false,
      generalTasks: [0, 0, 0, 0, 0],
      ExecuteTaskPopUpShow: false,
      milestonefirstpass: true,
      milestonePopUp: [true, true, true, true, true, true, true, true, true],
      NotEnoughResourcesPopUpShow: false,
      checkedPmCount: 0,
      StartGamePopUpShow: false,
      ProjectScopeBackButtonDisabled: false,
      player: {
        id: 0,
        gameId: 0,
        fullName: "",
        canPlayUntil: null,
        name: "", // Temporary, until the login will work
        position: 0,
        budget: 0,
        earnedValue: 0,
        instructorId: 0,
        accountId: 0,
        resources: {
          regular: 0,
          executive: 0,
          expensive: 0,
        },
        assistantMode: false,
      },
      playerDifAnimation: {
        budget: 0,
        earnedValue: 0,
        resources: {
          regular: 0,
          executive: 0,
          expensive: 0,
        },
      },
      prevPlayerDifAnimation: {
        budget: 0,
        earnedValue: 0,
        resources: {
          regular: 0,
          executive: 0,
          expensive: 0,
        },
      },
      tasksByNumber: [],
      tasks: [],
      tasksButOrTasksNotSaved: [],
      projectName: "",
      projectObjective: "",
      projectId: 1,
      mapImage: null,
      orTasks: [],
      logSideBar: {
        Constraint: 0,
        Delay: 0,
        Gate: 0,
        General: 0,
        Milestone: 0,
        Planned: 0,
        Risk: 0,
        Unplanned: 0,
      },
      log: [],
      gameLog: [],
      showReport: false,
      shortReport: {
        numOfPlanChanges: 0,
        percentOfPlanning: 27,
        returnPlanTime: "00:00:56",
        actionCounter: {
          Unplanned: 1,
          Risk: 2,
          Constraint: 0,
          Delay: 0,
          gateTasks: 1,
          orTasks: 0,
        },
        remainResources: {
          regular: 7,
          senior: 999, // do not change this number
          expensive: 4,
        },
        remainBudget: 6100,
        addBudget: 6000,
        doubleCost: 600,
        totalResources: 3900,
        totalBudget: 5900,
        totalValue: 11600,
        endGamePosition: Board.length - 1,
        returnGameTIme: "00:03:27",
        realLocation: 0,
        tasksCompleted: 0,
        localTime: "00:02:38",
      },
      playerStatusChange: {
        earnedValue: 0,
        stepsDifference: 0,
        earnedValueDifference: 0,
        priceDifference: 0,
        regular: 0,
        executive: 0,
        expensive: 0,
      },
      triviaValues: [],
      unplannedCards: [],
      maximumUnplannedCards: 0,
      explanationCard: false,
      isDisabledPMTasks: false,
      gateNumber: 1,
      gameDefinitionsStage: 0,
      cardState: false,
      newTurn: false,
      endGameModal: false,
      onePlanedTaskLeft: false,
      dontShowNextCard: false,
      resizePopUpShown: null,
      isZeroSteps: false,
      positionGameLog: [1],
      alreadyBeenAtPositionOne: false,
      isPlanning: false,
      gatePassed: [false, false, false],
      milestonePassed: [false, false, false, false, false, false, false, false],
      updatedCards: [],
      animationVars: {
        isAnimationNeeded: false,
        cameFromSideBar: false,
      },
      prevReportPopUp: false,
      prevReports: [],
      prevGameIdOfSpecificUser: [],
      isItAPreviousReport: false,
      downloadReport: false,
      gameStartTime: new Date().toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      gameStartDate: new Date().toLocaleDateString([], {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      }),
      clearTimer: false,
      needsToStartNewGame: false,
      resetTimer: false,
      keepShowingBeginTurnPopUp: true,
      // timeSeconds: 0,
      isGamePaused: false,
      gameGoals: {
        value: 0,
        position: 0,
        budget: 0,
        steps_more_than: 0,
        steps_less_than: 0,
      },
      finalGrade: {},
      isItAPreviousGame: false,
      isGameGotRestarted: false,
      projectArrayBeforeArrangement: [],
      saveOnGate: false,
      plannedTaskExecutedIndex: 0,
      generalIndexCounter: 0,
      changesMade: false, // checking if changes has been made at project arrangement.
      hasTurnStarted: false,
      baselineTaskOrder: [],
      baselineFlippedSet: [],
      reorderActionsSinceBaseline: 0,
      manualReorderTouched: false,
      draggedTaskIdsSinceBaseline: [],
      localTimerOfPreviousGame: 0, // if value is not 0, it means we started game that isn't completed - we need to update the local timer.
      planningTimerBaselineRev: 0, // bump when snapshot restores planning totals so Timer re-seeds planningElapsed
      previousReportsGameLogData: [],
      gameUIdOfPrevGame: 0,
      disableScreen: false, // global variable that every time there is no reason to click the sidebar it will be true.
      plannedTaskStack: [], // planned tasks that didn't got executed on there time will be inserted to an queue
      completedTasksArray: [],
      orTasksAtPause: [], // for the alternative task change comment
      isConference: false,
      sideLogAnimation: {
        plannedTask: false,
        unplanned: false,
        constraint: false,
        risk: false,
        delay: false,
        milestone: false,
        gate: false,
      },
      isGameStartedForTheFirstTime: false,
      keepShowingIdlePopUp: true,
      isCardCountDownActive: false,
      totalUsed: {
        budgetUsed: 0,
        regular: 0,
        senior: 0,
        expensive: 0,
      },
      needToOpenProjectSheetAfterMilestonePopUp: true,
      assistantJson: "",
      movedToLessValueAtDelayCard: false,
      pressedOkGotIt: false,
      gateRestartCounter: 0,
      movedTaskBeforePredecessorCount: false,
      selectedUnPlannedTask: 0,
      isChoosingFromDelayedCard: false,
      goToStartFromDelay: false,
      gateTestResult: '',
      oneLessStep: false,
      offeredToGoBack: 0,
      offeredToGoToStart: 0,
      oneLessStepTurn: null,
      performedLateTasksAtGateAndAskedFor: {
        budget: false,
        resources: false
      },
      showChangeProjectPopUp: false,
      allMainProjects: [],
      originalPercentage: 100,
      languagesList: [],
      currentLanguage: 'English',
      shortCutLanguage: 'en',
      unixTimestampMS: null,
      clientDateTime: null,
      apiDate: null,
  });

  async componentDidMount() {
    const that = this;

    i18n.changeLanguage('en');
    const fetchLanguages = async () => {
      const translationsData = await getLanguages();

      const languagesList = Object.values(translationsData);

      that.setState({ languagesList });
    };

    fetchLanguages();
    // await this.fetchTranslations();
    this.isCorrectBrowser();
    // retry requests until successful
    axiosRetry(axios, {
      retries: 120, // 120 for 1 minutes at 500ms between tries
      retryDelay: (retryCount) => {
        // console.log(`retry attempt: ${retryCount}`);
        return 500; // time interval between retries
      },
      retryCondition(error) {
        // TODO: catch different response codes if needed
        that.setState({ showNetworkErrorPopUp: true });
        if (that.state.errorInfo !== null) return false;
        // console.log(`NEW NETWORK ERROR: ${error}`)
        return true;
      },
    });
    axios.interceptors.response.use(
      (response) => {
        that.setState({ showNetworkErrorPopUp: false });
        return response;
      },
      (error) => {
        that.setState({ showNetworkErrorPopUp: false });
        that.setState({
          error,
          errorInfo: error,
        });
      }
    );

    axios.get(
      `${fetchConfig.prefix}/is_game_on_maintenance_mode`
    ).then(response => {
      console.log("RESOSSSSS", response)
      this.toggleMaintanenceMode(JSON.parse(response.data[0].value))
    }).catch(e => {
      console.log("cant get maintenance mode status");
    })
    const queryParams = new URLSearchParams(window.location.search);
    const gameEventId = queryParams.get("gameEventId");
    this.setState({ gameEventId: gameEventId !== null ? gameEventId : 0 });
    // console.log(queryParams.get('gameEventId'), "is the event query")
  }

  componentDidUpdate(prevProps, prevState) {
    // Avoiding infinite loops by checking for a change in state
    if (this.state.firstGateTileId === 0 && prevState.firstGateTileId !== this.state.firstGateTileId) {
      this.setFirstGate();
    }

    if (this.state.firstMilestoneTileId === 0 && prevState.firstMilestoneTileId !== this.state.firstMilestoneTileId) {
      this.setFirstMilestone();
    }

    if (JSON.stringify(this.state.tasksByNumber) === JSON.stringify([]) && JSON.stringify(prevState.tasksByNumber) !== JSON.stringify(this.state.tasksByNumber)) {
      this.setInitialTasksArrayForGameLog();
    }

    if (this.state.oneLessStep && (this.state.turnNumber - this.state.oneLessStepTurn >= 3)) { // actual turns effect for one less step card 2 turns.
      console.log(this.state.turnNumber - this.state.oneLessStepTurn >= 2, this.state.turnNumber, this.state.oneLessStepTurn, "ONE STEP LESSS!")
      this.setOneLessStep(false);
    }
  }


  componentDidCatch(error, errorInfo) {
    console.warn("APP STATE: ", this.state);

    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    });

    // Sentry.withScope(scope => {
    //     scope.setExtras(errorInfo);
    //     scope.setExtras(this.state);

    //     Sentry.captureException(error);
    // });
    // You can also log error messages to an error reporting service here
  }

  /**
   * save data in the DB that is relevant for resuming later
   * @param {JSON} saveData - a JSON object in the following format:
   *   {   (possible properties: 'board'/'milestonesAndGates'/'tasks'/'unplannedTasks')
   *
   *       'board': JSON object similar to the local one
   *
   *       'MGdata': { (only needed if type is 'milestonesAndGates')
   *           'milestones': a milestones object or array similar to the one in state ,
   *           'gates': a gates object or array similar to the one in state
   *       },
   *
   *       'tasks': [
   *           tasks, (same object as in state)
   *           orTasks (same object as in state),
   *           generalTasks (same object as in state)
   *       ]
   *
   *       'unplannedTasks': object or array similar to the one in state ,
   *
   *   }
   */
  /*
    TODO: 
        implement saving player resources
        check if we need to save more stuff
    */

  saveGame = async (saveData) => {
    const data = {
      gameId: this.state.player.gameId,
      data: saveData,
    };
    await axios.post(`${fetchConfig.prefix}/game/save_game`, data);

    // Auto-save snapshot after saving game data
    if (this.state.player && this.state.player.gameId && this.state.player.id) {
      try {
        // Calculate timer format (HH:MM:SS) from gameStartTime and totalTimeoutDuration
        // Timer = current time - game start time - total timeout duration
        const currentTime = performance.now();
        const elapsedMilliseconds = currentTime - this.gameStartTime.current - this.totalTimeoutDuration.current;
        const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
        const gameRunTimeSeconds = `0${Math.floor(totalSeconds % 60)}`.slice(-2);
        const gameRunTimeMinutes = `0${Math.floor((totalSeconds / 60) % 60)}`.slice(-2);
        const gameRunTimeHours = `0${Math.floor((totalSeconds / 3600) % 60)}`.slice(-2);
        const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;

        // Get current modal state
        const modalState = this.getCurrentModalState();

        // Get additional snapshot data
        const additionalData = this.getAdditionalSnapshotData();

        await axios.post(`${fetchConfig.prefix}/game/save_game_snapshot`, {
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
          timer: gameRunTime,
          cardState: (this.state.card && this.state.card.cardToggle) ? this.state.card : null,
          // Only save if card is open, otherwise null
          modalState, // Save which modal is showing
          additionalData, // Save additional data (popup dismissal, planning pause, language)
          currentPosition: this.state.player.position // Pass current frontend position
        });
      } catch (error) {
        console.error("Error auto-saving snapshot:", error);
        // Don't throw - snapshot save failure shouldn't break game save
      }
    }
  };

  /** Net planning time (ms) before game start, including an open isPlanning segment if any. */
  computePreGamePlanningNetMsFromRefs = () => {
    let acc = this.totalPlanningTimeRef.current;
    if (this.isPlanningRef.current === true && this.startedPlanningTimeRef.current) {
      acc += performance.now() - this.startedPlanningTimeRef.current;
    }
    return Math.max(0, acc - this.totalTimoutInPlanningDuration.current);
  };

  // Get additional snapshot data (popup dismissal, planning pause, language)
  getAdditionalSnapshotData = () => {
    // Only persist closed planning segments in totalPlanningTimeRef; an open segment
    // is continued on restore via wasPlanningOpen + fresh startedPlanningTimeRef.
    let preGamePlanningNetMs = null;
    if (this.preGamePlanningNetMsRef.current != null) {
      preGamePlanningNetMs = this.preGamePlanningNetMsRef.current;
    } else if (!this.state.isGameStartedForTheFirstTime) {
      preGamePlanningNetMs = this.computePreGamePlanningNetMsFromRefs();
    }
    return {
      popupDismissalState: {
        afterMilestonChecked: this.state.afterMilestonChecked || false,
        beginTurnChecked: this.state.beginTurnChecked || false,
        keepShowingBeginTurnPopUp: this.state.keepShowingBeginTurnPopUp !== undefined ? this.state.keepShowingBeginTurnPopUp : true
      },
      planningSession: {
        completedPlanningMs: this.totalPlanningTimeRef.current,
        timeoutDuringPlanningMs: this.totalTimoutInPlanningDuration.current,
        wasPlanningOpen: this.isPlanningRef.current === true,
        preGamePlanningNetMs,
      },
      planningPause: {
        isPausedForPlanning: this.state.showIsPaused || false
      },
      language: {
        currentLanguage: this.state.currentLanguage || 'English',
        shortCutLanguage: this.state.shortCutLanguage || 'en'
      }
    };
  };

  // Get current modal state - which modal is currently showing
  getCurrentModalState = () => {
    // Priority 1: Card is open
    if (this.state.card && this.state.card.cardToggle === true) {
      return {
        type: "card",
        cardType: this.state.card.type, // "unplanned-task", "Risk", "Constraint", "Delay"
        cardId: this.state.card.id,
        // Include all card data
        cardData: this.state.card
      };
    }

    // Priority 2: BeginTurnPopUp
    if (this.state.BeginTurnPopUpShow && this.state.keepShowingBeginTurnPopUp) {
      return {
        type: "BeginTurnPopUp"
      };
    }

    // Priority 3: ExecuteTaskPopUp
    if (this.state.ExecuteTaskPopUpShow) {
      return {
        type: "ExecuteTaskPopUp"
      };
    }

    // Priority 4: MilestoneModal
    if (this.state.MilestoneModalShow) {
      return {
        type: "MilestoneModal"
      };
    }

    // Priority 5: End of Turn Modal
    if (this.state.modalToggle && this.state.modalTitle === "modals.end_of_turn.info_title") {
      return {
        type: "EndOfTurn"
      };
    }

    // Priority 6: AfterMilestonePopUp
    if (this.state.AfterMilestonePopUpShow) {
      return {
        type: "AfterMilestonePopUp"
      };
    }

    // Priority 7: Gate/Trivia
    if (this.state.showTrivia) {
      return {
        type: "Trivia"
      };
    }

    // Priority 8: GateSecondControlPopUp
    if (this.state.gateSecondControlShow) {
      return {
        type: "GateSecondControlPopUp"
      };
    }

    // Priority 9: NotEnoughResourcesPopUp
    if (this.state.NotEnoughResourcesPopUpShow) {
      return {
        type: "NotEnoughResourcesPopUp"
      };
    }

    // Nothing is showing
    return null;
  };

  // Save card state snapshot whenever a card is opened
  saveCardStateSnapshot = async (cardStateOverride = null) => {
    // Use provided cardState or current state
    const cardToSave = cardStateOverride || this.state.card;

    // Only save if card is open
    if (!cardToSave || !cardToSave.cardToggle) {
      return; // No card open, don't save
    }

    if (this.state.player && this.state.player.gameId && this.state.player.id) {
      try {
        const currentTime = performance.now();
        const elapsedMilliseconds = currentTime - this.gameStartTime.current - this.totalTimeoutDuration.current;
        const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
        const gameRunTimeSeconds = `0${Math.floor(totalSeconds % 60)}`.slice(-2);
        const gameRunTimeMinutes = `0${Math.floor((totalSeconds / 60) % 60)}`.slice(-2);
        const gameRunTimeHours = `0${Math.floor((totalSeconds / 3600) % 60)}`.slice(-2);
        const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;

        // Get current modal state
        const modalState = this.getCurrentModalState();

        // Get additional snapshot data
        const additionalData = this.getAdditionalSnapshotData();

        await axios.post(`${fetchConfig.prefix}/game/save_game_snapshot`, {
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
          timer: gameRunTime,
          cardState: cardToSave, // Save the open card
          modalState, // Save which modal is showing
          additionalData, // Save additional data (popup dismissal, planning pause, language)
          currentPosition: this.state.player.position // Pass current frontend position
        });
      } catch (error) {
        console.error("Error saving card state snapshot:", error);
        // Don't throw - card state save failure shouldn't break game
      }
    }
  };

  initializePlayerOnBoard = (
    startingTaskId,
    cardsArrangement,
    startingPoint = 0
  ) => {
    // FIX
    const tasksCopy = [...cardsArrangement];
    // tasksCopy.filter(task => task.number === startingTaskId).completed = true; // set the task as completed
    const Change = this.state.playerStatusChange;
    const prevAnimationStats = this.state.playerDifAnimation;
    let needsToOpenBeginTurnPopUp = false;
    const playerPosition = this.state.player.position;
    if (playerPosition == 0 && this.state.gameLog.length <= 1) {
      needsToOpenBeginTurnPopUp = true;
    }
    console.log("this.state.player1 ", this.state.player);
    this.setState((prevState) => ({
      player: {
        ...prevState.player,
        position: startingPoint,
      },
      BeginTurnPopUpShow: needsToOpenBeginTurnPopUp,
      tasks: tasksCopy,
      tasksButOrTasksNotSaved: tasksCopy,
      playerDifAnimation: {
        budget: Change.priceDifference,
        earnedValue: Change.earnedValueDifference,
        resources: {
          regular: Change.regular,
          executive: Change.executive,
          expensive: Change.expensive,
        },
      },
      prevPlayerDifAnimation: {
        budget: prevAnimationStats.budget,
        earnedValue: prevAnimationStats.earnedValue,
        resources: {
          regular: prevAnimationStats.resources.regular,
          executive: prevAnimationStats.resources.executive,
          expensive: prevAnimationStats.resources.expensive,
        },
      },
    }));
  };

  getBrowserName = () => {
    const useragent = navigator.userAgent;
    const browser = Bowser.getParser(useragent);
    const { name: browserName } = browser.parsedResult.browser;
    return browserName;
  }

  isCorrectBrowser = async () => {
    const useragent = navigator.userAgent;
    const browser = Bowser.getParser(useragent);
    const { name: browserName, version } = browser.parsedResult.browser;
    if (
      !(
        (browserName === "Chrome" && parseFloat(version) > 95) ||
        (browserName === "Firefox" && parseFloat(version) > 95) ||
        (browserName === "Microsoft Edge" && parseFloat(version) > 95) ||
        (browserName === "Safari" && parseFloat(version) > 14)
      )
    ) {
      this.toggleIncorrectBrowser(true);
    }
  };

  mapScreenshot = async () => {
    await html2canvas(document.getElementsByClassName("map")[0], {
      backgroundColor: null,
    })
      .then((canvas) => {
        const imageData = canvas.toDataURL();
        this.setState({ mapImage: imageData });
      })
      .catch((e) => console.log(e));
  };

  /**
   * The walking algorithm that makes the player move through the board
   * @param {number} steps - The number of steps the player will take
   * @param {number} tileId - The id of the tile the player is standing on
   * @param {object} playerStatus - Player data like resources, budget and earned value
   * @param {boolean} continueTurn - If the player is going to continue the turn
   * @param {boolean} isPausedStatus - Checks if the player paused the game
   *
   */
  walkingAlgorithm = async (
    steps,
    tileId,
    playerStatus,
    continueTurn,
    isPausedStatus = false,
    lastTile = steps != 0 ? tileId + steps : tileId
  ) => {
    this.toggleProjectNeedToBeDisabled(true);
    this.sideLogUpdate(false);
    if (tileId === lastTile) {
      Board[tileId].landed = true;
      Board[tileId].checked = true;
    }
    if (steps >= 1) {
      setTimeout(() => {
        Board[tileId].checked = true;
        this.moveCameraWithPlayer(tileId);
        this.SoundPlay(stepsSound);
        progressAnimationCoords(checkDirection(tileId));
        this.walkingAlgorithm(
          steps - 1,
          tileId + 1,
          playerStatus,
          continueTurn,
          isPausedStatus,
          lastTile
        );
      }, 1000);
    } else if (steps <= -1) {
      setTimeout(() => {
        Board[tileId].checked = true;
        this.moveCameraWithPlayerReverse(tileId, false);
        this.SoundPlay(stepsSound);
        progressAnimationCoords(checkReverseDirection(tileId));
        this.walkingAlgorithm(
          steps + 1,
          tileId - 1,
          playerStatus,
          continueTurn,
          isPausedStatus,
          lastTile
        );
      }, 1000);
    } else {
      this.playerStatusChangeStats(playerStatus, false);
      document.documentElement.style.setProperty("--progress-end-top", `0vh`);
      document.documentElement.style.setProperty("--progress-end-right", `0vw`);

      const Change = this.state.playerStatusChange;
      const prevAnimationStats = this.state.playerDifAnimation;
      this.setState(
        (prev) => ({
          player: {
            ...prev.player,
            position: tileId,
            budget: playerStatus.data[0].budget,
            earnedValue: playerStatus.data[0].earnedValue,
            resources: {
              regular: playerStatus.data[0].regular,
              executive: playerStatus.data[0].senior,
              expensive: playerStatus.data[0].expensive,
            },
          },
          playerDifAnimation: {
            budget: Change.priceDifference,
            earnedValue: Change.earnedValueDifference,
            resources: {
              regular: Change.regular,
              executive: Change.executive,
              expensive: Change.expensive,
            },
          },
          prevPlayerDifAnimation: {
            budget: prevAnimationStats.budget,
            earnedValue: prevAnimationStats.earnedValue,
            resources: {
              regular: prevAnimationStats.resources.regular,
              executive: prevAnimationStats.resources.executive,
              expensive: prevAnimationStats.resources.expensive,
            },
          },
        }),
        () => {
          const gameRunTimeSeconds = `0${Math.floor(
            this.state.timeSeconds % 60
          )}`.slice(-2);
          const gameRunTimeMinutes = `0${Math.floor(
            (this.state.timeSeconds / 60) % 60
          )}`.slice(-2);
          const gameRunTimeHours = `0${Math.floor(
            (this.state.timeSeconds / 3600) % 60
          )}`.slice(-2);
          const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;
          this.saveGame({
            tasks: [
              this.state.tasks,
              this.state.orTasks,
              this.state.generalTasks,
            ],
            unplannedTasks: this.state.unplannedCards,
            board: Board,
            localTimer: gameRunTime,
          });

          this.toggleProjectNeedToBeDisabled(false);
          this.projectScopeDisabeling(false);
          this.ProjectScopeDisable(false);
          if (continueTurn) {
            setTimeout(() => this.handleProgress(), 500);
            return;
          }
          setTimeout(() => this.endTurn(), 750);
        }
      );
    }

    // this.saveGame({ 'tasks': [this.state.tasks, this.state.orTasks, this.state.generalTasks], 'unplannedTasks': this.state.unplannedCards, 'board': Board });
  };

  /**
   * The goTo function sends player to a specific location
   * goTo should get an object that contains:
   * @param {boolean} constLocation - indicates to travel to a specific tile id or name.
   * @param {boolean} steps -  indicates to travel a certin number of steps.
   * @param {string/integer} id - tile id or tile name id where the player should go.
   * @param {number} numberOfSteps - number of steps the player should move.
   * @param {boolean} continueTurn - for the walkingAlgorithem function (almost always represented in a certing function we user goTo with)
   * @param {JSON} playerStatus(log) - for the walkingAlgorithem function (almost always represented in a certing function we user goTo with)
   * Attention!
   * when using for a quick travel. please add the following to every condition below.
   *  log = await axios.post(`${fetchConfig.prefix}/game/log_data_insert`, data)
   */

  goTo = async (obj) => {
    let spotId;
    let log;
    const { log: playerLog, id: tileId, continue: continueTurn } = obj;
    let data;
    if (typeof this.state.player === "undefined") {
      console.error("this.state.player is undefined, goTo function.");
      return false;
    }

    if (!obj) {
      console.error("obj is undefined, goTo function.");
      return false;
    }

    if (obj.constLocation === true) {
      if (typeof obj.id === "string") {
        const tile = Board.find((element) => element.nameId === tileId);
        if (tile.nameId === tileId) {
          spotId = tile.id;
          data = {
            steps: spotId - this.state.player.position,
            gameId: this.state.player.gameId,
            userId: this.state.player.id,
          };
          // log = await axios.post(`${fetchConfig.prefix}/game/log_data_insert`, data)
        }
      }

      if (typeof obj.id === "number") {
        if (tileId < Board.length && tileId >= 0) {
          spotId = Board[tileId].id;
          data = {
            steps: spotId - this.state.player.position,
            gameId: this.state.player.gameId,
            userId: this.state.player.id,
          };
          // log = await axios.post(`${fetchConfig.prefix}/game/log_data_insert`, data)
        }
      }
    } else if (obj.steps === true) {
      if (
        this.state.player.position + obj.NumberOfSteps <= Board.length - 1 &&
        this.state.player.position + obj.NumberOfSteps > 0
      ) {
        data = {
          steps: obj.NumberOfSteps,
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
        };
      }
    }
    if (!data) return false;
    // const log = await axios.post(`${fetchConfig.prefix}/game/log_data_insert`, data) // for FastForward only!
    this.walkingAlgorithm(
      data.steps,
      this.state.player.position,
      playerLog,
      continueTurn
    );
  };

  setFirstGate = () => {
    const gateTile = this.getUpcomingGateTileId();
    this.setState({ firstGateTileId: gateTile });
  };

  setFirstMilestone = () => {
    const milestoneTile = this.getUpcomingMilestoneTileId();
    this.setState({ firstMilestoneTileId: milestoneTile });
  };

  setInitialTasksArrayForGameLog = () => {
    const { tasks } = this.state;
    this.setState({ tasksByNumber: [...tasks] });
  };

  setTasksPopupClose = () => {
    this.setState({ taskToggle: false });
  };

  getLastGateTileId = () => {
    const gateIdArr = Board.filter(
      (el) => el.type === "gate" && el.checked === true
    );
    if (gateIdArr.length > 0) {
      let lastElement = gateIdArr.slice(-1);
      if (lastElement.length > 0) {
        const gateId = Board.filter(
          (el) =>
            el.type === "gate" &&
            el.checked === true &&
            this.state.player.position > el.id
        );
        lastElement = gateId.slice(-1);
      }
      // if(lastElement && lastElement.length !== 0){
      //     console.log(lastElement[0].id, "lastElement[0].id");
      //     if(Board[lastElement[0].id]  && lastElement[0].id === this.state.player.position){
      //         const gateId = Board.filter((el) => el.type === 'gate' && el.gate.passed === true && this.state.player.position < el.id)
      //         if(gateId.length > 0){
      //             lastElement = gateId.slice(-1);
      //             console.log("gateId2", gateId);
      //         }
      //     }
      // }

      if (!lastElement || lastElement.length === 0) {
        return false;
      }

      return lastElement[0].id;
    }
  };

  goToLastGate = async (log, continueTurn) => {
    const gateId = this.getLastGateTileId();
    if (gateId) {
      const data = {
        constLocation: true,
        steps: false,
        id: gateId.id,
        log: playerLog,
        continue: continueTurn,
      };
      this.goTo(data);
      return true;
    }
    return false;
  };

  isPlayerOnMileStone = () => {
    return Board.some(
      (element) =>
        element.type === "mile-stone" &&
        element.id == this.state.player.position
    );
  };

  updateOrTaskFlip = (taskNumber, flipStatus = false) => {
    if (!Number.isInteger(taskNumber) || typeof flipStatus !== "boolean")
      return false;

    const { tasks } = this.state;
    const newTaskArray = tasks.map((task) => {
      if (task.number === taskNumber) {
        return {
          ...task,
          isOrFlipped: flipStatus,
        };
      }
      return task;
    });

    // console.log('new Tasks Array: ', newTaskArray)

    this.setState({ tasks: newTaskArray });
  };

  getDefaultMilestoneTileId = () => {
    return Board.find((el) => el.type === "mile-stone");
  };

  getLastMilestoneTileId = () => {
    const milestoneIdIdArr = Board.filter(
      (el) => el.type === "mile-stone" && el.checked === true
    );
    let lastElement;
    if (milestoneIdIdArr.length > 0) {
      const mileStoneId = milestoneIdIdArr.filter(
        (el) =>
          el.type === "mile-stone" &&
          el.checked === true &&
          this.state.player.position >= el.id
      );
      lastElement = mileStoneId.slice(-1);
    }
    if (lastElement && lastElement.length !== 0) {
      if (Board[lastElement[0].id] && Board[lastElement[0].id].milestone)
        if (
          Board[lastElement[0].id] &&
          Board[lastElement[0].id].milestone.passed &&
          lastElement[0].id === this.state.player.position
        ) {
          // console.log("lastMilestone if", Board[lastElement[0].id], Board[lastElement[0].id].milestone.passed, lastElement === this.state.player.position)
          const mileStoneId = milestoneIdIdArr.filter(
            (el) =>
              el.type === "mile-stone" &&
              el.checked === true &&
              this.state.player.position > el.id
          );
          lastElement = mileStoneId.slice(-1);
        }
    }

    if (!lastElement || lastElement.length === 0) {
      return false;
    }

    // console.log("lastElement", lastElement);
    return lastElement[0].id;
  };

  getUpcomingMilestoneTileId = () => {
    const playerPosition = this.state.player.position;
    const milestoneIdIdArr = Board.filter((el) => el.type === "mile-stone");
    let element;
    if (milestoneIdIdArr.length > 0) {
      const mileStoneId = milestoneIdIdArr.filter(
        (el) => el.type === "mile-stone" && el.id >= playerPosition
      );
      if (mileStoneId[0]) {
        const { id: ele } = mileStoneId[0];
        element = ele;
      }
    }
    if (!element) {
      return false;
    }
    return element;
  };

  getUpcomingGateTileId = () => {
    const playerPosition = this.state.player.position;
    const gateIdArr = Board.filter((el) => el.type === "gate");
    let element;
    if (gateIdArr.length > 0) {
      const gateId = gateIdArr.filter(
        (el) => el.type === "gate" && el.id >= playerPosition
      );
      // console.log("gateId filter", gateId);
      // console.log("gateId", gateId[0]);
      if (gateId[0]) {
        const { id: ele } = gateId[0];
        element = ele;
      }
    }
    if (!element) {
      return false;
    }
    return element;
  };

  /**
   * reset the 'executed' parameter of tiles when player goes back some steps
   *
   * @param {INT} newPosition number of tile the player went back to
   *
   */
  updateBoardTileExecuted = async (newPosition) => {
    for (let i = newPosition; i < Board.length; i++) {
      if (
        Board[i].milestone?.passed === true ||
        Board[i].gate?.passed === true
      ) {
        // eslint-disable-next-line no-continue
        continue;
      }

      Board[i].executed = false;
    }
  };

  goToLastMilestone = async (log, continueTurn) => {
    const milestoneId = this.getLastMilestoneTileId();
    if (milestoneId) {
      const data = {
        constLocation: true,
        steps: false,
        id: gateId.id,
        log: playerLog,
        continue: continueTurn,
      };
      this.goTo(data);
      this.updateBoardTileExecuted(data.id);
      return true;
    }
    return false;
  };

  goToLastMilestoneOrGate = async (
    playerLog,
    continueTurn,
    returnOnlyTileNum = false
  ) => {
    const milestoneId = this.getLastMilestoneTileId();
    const gateId = this.getLastGateTileId();
    let data;
    let maxId = milestoneId > gateId ? milestoneId : gateId;

    if (maxId > this.state.player.position) {
      maxId = milestoneId > gateId ? gateId : milestoneId;
    }
    if (!maxId) {
      maxId = !milestoneId ? (maxId = gateId) : (maxId = milestoneId);
      if (!maxId) {
        return false;
      }
    }

    if (returnOnlyTileNum && maxId) {
      return maxId;
    }

    if (maxId) {
      data = {
        constLocation: true,
        steps: false,
        id: maxId,
        log: playerLog,
        continue: continueTurn,
      };
    }
    this.goTo(data);
    this.updateBoardTileExecuted(data.id);
    return true;
  };

  lastPlayerPositionForPrevReport = async (userId, gameId) => {
    let result;
    try {
      result = await axios.get(`${fetchConfig.prefix}/game/user_report`, {
        params: {
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
        },
      });
    } catch (e) {
      console.log(e);
    }
    return result.data.endGamePosition;
  };
  // isBoardFixed = () => {
  //     if (this.checkBoardTileNameId()) {

  //     }
  // }

  checkBoardTileNameId = () => {
    const Arr = [];
    Board.forEach((element) => {
      if (this.countInArrayNameId(Board, element.nameId) > 1) Arr.push(element);
    });
    return !Arr.length > 0;
  };

  countInArrayNameId = (array, what) => {
    return array.filter((item) => item.nameId == what && item.nameId).length;
  };

  SoundPlay = async (src) => {
    const sound = new Howl({
      src,
    });
    sound.play();
  };

  /* Fetching an parsing the last player action then push it into the game log array.
   *   params:
   *   @array restoredGameLog - last game log for restoring a game.
   *
   */
  gameLogFetch = async (restoredGameLog = undefined) => {
    this.setState({
      gameLogLoading: true,
    });
    const gameLog = !restoredGameLog
      ? await this.getPlayerLog({ lastPlayData: true })
      : restoredGameLog;
    const dataForGameLog =
      this.state.gameLog.length > 0 ? [...this.state.gameLog] : [];
    if (!restoredGameLog) {
      Object.keys(gameLog.data).map((current, index) => {
        if (dataForGameLog.length === 0) {
          dataForGameLog.push(gameLog.data[current]);
        } else {
          const valid = dataForGameLog.map((s) =>
            s.turnData ? s.turnData.id != current : ""
          );
          if (!valid.includes(false)) {
            dataForGameLog.push(gameLog.data[current]);
          }
        }
      });
    } else {
      Object.keys(restoredGameLog.data).map((current, index) => {
        dataForGameLog.push(restoredGameLog.data[current]);
      });
    }
    // this.setState(({
    //     gameLogLoading: false,
    // }));
    return dataForGameLog;
  };

  sideLogUpdate = async (isItForPreviousReports, userUId, gameUId, step = true) => {
    if (step) {
      const lastMilestoneOrGateTileNum = await this.goToLastMilestoneOrGate(
        0,
        0,
        true
      );
    }
    if (!isItForPreviousReports) {
      const gameLogData = await this.gameLogFetch();
      const sum = {
        budgetUsed: 0,
        regular: 0,
        senior: 0,
        expensive: 0,
      };
      gameLogData.map((item) => {
        if (item.cardData) {
          if (
            item.cardData.code !== 8 && // milestone - it only gives us stuff
            item.cardData.code !== 9 && // gate - -it only gives us stuff
            item.cardData.code !== 13 && // gate - -it only gives us stuff
            item.cardData.code !== 21 && // gate - -it only gives us stuff
            item.cardData.code !== 10 && // buy resources  - the condition below handel it
            item.cardData.code !== 7 && // get additional budget
            typeof item.cardData.code !== "undefined"
          ) {
            sum.budgetUsed += Math.abs(Math.max(0, -item.cardData.costMoney));
            sum.regular += Math.abs(
              Math.max(0, -item.cardData.costResourcesNormal)
            );
            sum.senior += Math.abs(
              Math.max(0, -item.cardData.costResourcesSenior)
            );
            sum.expensive += Math.abs(
              Math.max(0, -item.cardData.costResourcesExpensive)
            );
          }
        }
        if (item.turnData) {
          if (item.turnData.code == 10 && item.turnData.decision == 0) {
            // decision = 0 -> buy, not exchange
            sum.budgetUsed += Math.abs(item.turnData.costMoney);
          } else if (item.turnData.code == 10 && item.turnData.decision == 1) {
            sum.regular += Math.max(0, -item.cardData.costResourcesNormal);
            sum.senior += Math.max(0, -item.cardData.costResourcesSenior);
            sum.expensive += Math.max(0, -item.cardData.costResourcesExpensive);
            // in exchange we want to "add" only the negative resources
          }
        }
      });
      const logSummaryObj = logSummary(gameLogData); // TODO: change to gameLogData
      this.setState((prev) => ({
        logSideBar: logSummaryObj,
        // log: log.data, // old version.
        gameLog: gameLogData,
        gameLogLoading: false,
        totalUsed: sum,
      }));
    } else {
      const lastPlayerPosition = await this.lastPlayerPositionForPrevReport(
        userUId,
        gameUId
      );
      const log = await this.getPlayerLog({
        gameAndUserIdObj: {
          gameId: gameUId,
          userId: userUId,
        },
      });
      const gameLogData = await this.gameLogFetch(log.data);
      const logSummaryObj = logSummary(log.data);
      this.setState((prev) => ({
        logSideBar: logSummaryObj,
        gameLog: gameLogData,
      }));
    }
  };

  getUserPreviousGames = async (userId) => {
    const log = await axios.get(
      `${fetchConfig.prefix}/project/get_user_past_report`,
      {
        params: {
          userId,
        },
      }
    );
    this.setState((prev) => ({
      prevReports: log.data,
    }));
  };

  postUserPreviousGames = async (reports) => {
    const time = new Date().toGMTString();
    const data = {
      userId: this.state.player.id,
      gameId: this.state.player.gameId,
      reports,
      time,
    };
    const log = await axios.post(
      `${fetchConfig.prefix}/project/post_user_past_report`,
      data
    );
  };

  getUserPreviousGames = async (userId) => {
    const log = await axios.get(
      `${fetchConfig.prefix}/project/get_user_past_report`,
      {
        params: {
          userId,
        },
      }
    );
    this.setState((prev) => ({
      prevReports: log.data,
    }));
  };

  getUserPreviousGameId = async (userId) => {
    const log = await axios.get(
      `${fetchConfig.prefix}/game/give_me_a_list_of_all_players_game_ids_by_useruid`,
      {
        params: {
          userId,
          instructorId: this.state.player.instructorId,
          accountId: this.state.player.accountId,
        },
      }
    );
    this.setState((prev) => ({
      prevGameIdOfSpecificUser: log.data,
    }));
  };

  additionalBudgetCommentsInit = async (taskRowId, isGeneralTask = false) => {
    if (this.state.budgetRequest.count > 0) {
      for (let i = 0; i < this.state.budgetRequest.count; i++) {
        const comment = this.commentAdditionalBudget(
          this.state.budgetRequest.budget,
          taskRowId
        );
      }
    }
    if (!isGeneralTask) {
      this.setState((prev) => {
        return {
          budgetRequest: {
            count: 0,
          },
        };
      });
    }
    /* eslint-disable */
    // this.state.budgetRequest.count = 0;
  };

  resourcesForDoublePriceCommentInit = async (
    taskRowId,
    isGeneralTask = false
  ) => {
    if (this.state.resourcesForDoublePrice > 0) {
      const comment = this.commentResourcesAtDoublePrice(taskRowId);
    }
    !isGeneralTask ? (this.state.resourcesForDoublePrice = 0) : "";
  };

  performPlannedTask = async (
    taskId,
    ifOrTask,
    type,
    cards,
    callback = async () => { },
    cardId = null,
    checkedPmCount = 0,
    checkedTaskRedo = false
  ) => {
    // For planned tasks, never use ordinal - derive from cards if needed
    let taskIdToSend = cardId;
    if (!taskIdToSend && type === 'planned' && cards?.length) {
      const cardForTask = cards.find(c => c.number == taskId);
      taskIdToSend = cardForTask?.taskIdnumberInDB ?? cardForTask?.id;
    }
    if (type === 'planned' && !taskIdToSend) {
      console.error('Cannot execute planned task: no valid task ID. checkedTaskDBId=', cardId, 'taskId=', taskId);
      this.toggleProjectNeedToBeDisabled(false);
      this.ProjectScopeDisable(false);
      return;
    }
    const cardIdOrTaskId = type === 'planned' ? (taskIdToSend ?? taskId) : (cardId ?? taskId);
    // mark that the player is done with this spot
    Board[this.state.player.position].executed = true;
    this.toggleDisableScreen(true); // start disabling screen from now
    this.ProjectScopeDisable(true);
    console.log(1275);
    // here was the last err for ticket 850
    this.toggleProjectNeedToBeDisabled(true);
    // if (ifOrTask) {
    //     const commentIt = await this.commentOrTaskExecuted();
    // }
    const taskArray = cards.map((current) => current.number);
    const orTaskArray = Array(taskArray.length).fill(0);
    const currentIndexArray = cards.map((current) => {
      for (let i = 0; i < this.state.orTasks.length; i++) {
        if (current.number == this.state.orTasks[i]) {
          orTaskArray[cards.indexOf(current)]++;
        }
      }
    });
    let executedTaskIndex;
    const orTaskIndex = cards.map((current, index) => {
      if (current.number == taskId) {
        executedTaskIndex = index;
      }
    });
    const getPlannedArray = await axios.get(
      `${fetchConfig.prefix}/game/get_planned_array?gameId=${this.state.player.gameId}&userId=${this.state.player.id}`
    );

    // Ensure planned array data is valid
    if (!getPlannedArray || !getPlannedArray.data) {
      console.error("getPlannedArray returned invalid data:", getPlannedArray);
    }

    const playerPosition = this.state.player.position;
    const upcomingGate = this.getUpcomingGateTileId();
    const { turnNumber, tasksTimer } = this.state;
    const timeSeconds = this.timeSeconds.current;  // referencing the value and not the pointer. changed values will not be updated globally
    // const turnNumber  = this.state.turnNumber;
    let data;
    let playerStatus;
    if (type === "planned") {
      const actionTime = timeSeconds - tasksTimer;
      data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        taskId: cardIdOrTaskId,
        ifOrTask,
        playerPosition,
        upcomingGate,
        turnNumber,
        projectId: this.state.projectId,
        orTaskArray,
        taskArray,
        timer: actionTime,
        redo: checkedTaskRedo,
        oneLessStep: this.state.oneLessStep,
      };
      playerStatus = await axios.post(
        `${fetchConfig.prefix}/game/planned_task`,
        data
      );
      if (typeof playerStatus.data === "string") {
        if (playerStatus.data === "insufficient funds" && checkedPmCount > 1) {
          this.executeTaskWithNotEnoughResources = true;
          Board[this.state.player.position].executed = false;
          this.toggleNotEnoughResourcesPopUp(true, checkedPmCount);
          this.SoundPlay(errorSound);
        } else if (playerStatus.data === "insufficient funds") {
          this.executeTaskWithNotEnoughResources = true;
          Board[this.state.player.position].executed = false;
          this.toggleNotEnoughResourcesPopUp(true);
          this.SoundPlay(errorSound);
        } else {
          this.executeTaskWithOpenPredecessor = true;
          this.SoundPlay(errorSound);
          this.onlyShowModal(
            "modals.unavailable_task.info_title",
            "modals.unavailable_task.info_text",
            "modals.unavailable_task.button1"
          );
          this.executeTaskWithOpenPredecessor = false;
        }
        this.toggleProjectNeedToBeDisabled(false);
        this.ProjectScopeDisable(false);
        this.executeTaskWithNotEnoughResources = false;
        return;
      }
      if (checkedTaskRedo) {
        const commentIt = await this.commentOnRedoTask(playerStatus.data[1]);
      } else if (ifOrTask) {
        const commentIt = await this.commentOrTaskExecuted(
          playerStatus.data[1]
        );
      }
      const taskInfo = cards.filter(x => x.id == taskId)[0];
      if (taskInfo.orTask != "" && (((this.state.gameGoals.budget > 0 || this.state.gameGoals.steps_more_than > 0) && !ifOrTask) || ((this.state.gameGoals.value > 0 || this.state.gameGoals.steps_less_than) && ifOrTask))) {
        this.commentTaskOnPosition(playerStatus.data[1], "Task not aligned with project goals");
      }

      // this.state.tasksTimer = this.state.timeSeconds; // reset taskTimer state. BAD PRACTICE!
      await this.additionalBudgetCommentsInit(playerStatus.data[1]);
      // await this.resourcesForDoublePriceCommentInit(playerStatus.data[1]);
      await callback(taskId, type, playerStatus.data[1]);

      let completedTasks = 0;
      console.log("this.state.tasks ", this.state.tasks);
      this.state.tasks.map((current) =>
        current.completed ? completedTasks++ : ""
      );

      // out of order comment:
      const plannedTaskArrayInPausing = Array.isArray(getPlannedArray.data) ? getPlannedArray.data : [];
      let temporaryArray = []; // creating a new array, there we will have less and less indexes each time.
      plannedTaskArrayInPausing.map((el, index) => {
        if (
          this.state.plannedTaskStack.includes(
            plannedTaskArrayInPausing[index]
          ) ||
          completedTasks == 0
        ) {
          temporaryArray[index] = plannedTaskArrayInPausing[index];
        }
      });
      temporaryArray = temporaryArray.filter((a) => a); // remove all 'empty' indexes
      if (taskId == temporaryArray[0]) {
        // is the task we executed equal to "stack.top"
        temporaryArray.shift(); // shift == "pop"
      } else if (!checkedTaskRedo) {
        // task executed out of order
        await this.commentTaskExecutedOutOfOrder(playerStatus.data[1]); // comment
        temporaryArray = temporaryArray.filter((element) => element != taskId); // remove the task executed from the "stack"
      }

      this.setState((prev) => ({
        plannedTaskStack: temporaryArray, // setting the state array to the temporary one.
        needToOpenProjectSheetAfterMilestonePopUp: false,
        checkedTask: null,
      }));
      // Task not aligned with project goals


      // changed selection of choice comment:
      let changedSelectionCondition = true;
      for (let i = 0; i < cards.length; i++) {
        if (cards[i].number == taskId) {
          if (
            cards[i].isOrFlipped &&
            this.state.orTasksAtPause.includes(taskId)
          ) {
            changedSelectionCondition = false;
          }
          if (
            !cards[i].isOrFlipped &&
            !this.state.orTasksAtPause.includes(taskId)
          ) {
            changedSelectionCondition = false;
          }
          // console.log("yoni66 true", cards[i].isOrFlipped, this.state.orTasksAtPause);
        }
      }
      if (changedSelectionCondition) {
        const commentIt = await this.commentChangedSelection(
          playerStatus.data[1]
        );
      }
      // this.setState(prevState => ({
      //     completedTasksArray: [...prevState.completedTasksArray, taskId],
      //     generalIndexCounter: commentFlag ? this.state.plannedTaskExecutedIndex + 1 : prevState.generalIndexCounter,
      //     plannedTaskExecutedIndex: this.state.plannedTaskExecutedIndex + 1,
      // }));
    } else {
      const actionTime = timeSeconds - tasksTimer;
      data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        taskId,
        playerPosition,
        turnNumber,
        timer: actionTime,
      };
      playerStatus = await axios.post(
        `${fetchConfig.prefix}/game/general_task`,
        data
      );

      if (typeof playerStatus.data === "string") {
        if (playerStatus.data === "insufficient funds" && checkedPmCount > 1) {
          Board[this.state.player.position].executed = false;
          this.toggleNotEnoughResourcesPopUp(true, checkedPmCount);
          this.SoundPlay(errorSound);
        } else if (playerStatus.data === "insufficient funds") {
          Board[this.state.player.position].executed = false;
          this.toggleNotEnoughResourcesPopUp(true);
          this.SoundPlay(errorSound);
        }
        this.toggleProjectNeedToBeDisabled(false);
        // const condition =
        //   Board[this.state.player.position].type == "mile-stone"
        //     ? this.ProjectScopeDisable(true)
        //     : this.ProjectScopeDisable(false);
        // this.isPaused(true);
        return;
      }

      await Promise.all(
        playerStatus.data[2].map(async (index) => {
          await this.additionalBudgetCommentsInit(index, true);
          // await this.resourcesForDoublePriceCommentInit(index, true);
        })
      );
      this.setState((prev) => ({
        budgetRequest: {
          count: 0,
        },
        resourcesForDoublePrice: 0,
      }));
    }
    this.toggleExecuteGPMTOnMilestone(false);
    // playerStatus =  playerStatus.data.res;
    const prevPosition = this.state.player.position;
    const numberOfSteps = Math.abs(
      playerStatus.data[0].location - prevPosition
    );
    this.toggleIsAnimationNeeded(true);
    let continueTurn = false;
    setTimeout(() => this.SoundPlay(moneySound), 200);
    if (playerStatus.data[0].location != this.state.player.position) {
      continueTurn = true;
    }
    if (numberOfSteps == 0) {
      this.setState({
        isZeroSteps: true,
      });
      if (prevPosition == 1) {
        this.playerStatusChangeStats(playerStatus, false);
      }
    }
    this.ProjectScopeDisable(false);
    this.toggleProject(0, cards);
    const cardType = Board[playerStatus.data[0].location].type;
    if (continueTurn) {
      if (
        cardType == "planned-task" &&
        // numberOfSteps > 0 &&
        !this.state.onePlanedTaskLeft &&
        !this.state.endGameModal
      ) {
        this.playerStatusChangeStats(playerStatus, true);
        setTimeout(() => {
          if (!this.state.MilestoneModalShow) {
            // this.toggleExecutePopUp(true);
          } else {
            this.state.needsToDelayExecutePopup = true;
          }
          this.toggleProject(3);
        }, numberOfSteps * 1333);
      }
      // this.setState({ playerStatus });
      this.walkingAlgorithm(
        numberOfSteps,
        prevPosition,
        playerStatus,
        true,
        false
      );
    } else {
      this.walkingAlgorithm(
        numberOfSteps,
        prevPosition,
        playerStatus,
        continueTurn,
        !continueTurn
      );
    }
    await callback(taskId, cardType);
    this.toggleSideLogAnimation("plannedTask");
    this.sideLogUpdate(false);
    this.setChangesMade(false);
    this.toggleProjectNeedToBeDisabled(false);
    this.setState(() => ({
      taskToggle: false,
      openGeneralPmTasks: false
    }));
    setTimeout(() => this.toggleDisableScreen(false), 1000); // remove the disable only when the other function starts

    // Animation check
    // setTimeout(()=>{
    //   document.getElementById("plannedtask_executed_icon").classList.add("pulse");
    //   setTimeout(()=>{
    //     document.getElementById("plannedtask_executed_icon").classList.remove("pulse");
    //   },1000)
    // }, 2000)
  };

  handleOrTaskChange = (taskId, isRotated, isPlanning) => {
    if (!this.state.orTasks.includes(taskId) && isRotated) {
      this.setState((prevState) => ({
        orTasks: [...prevState.orTasks, taskId],
      }));
      if (isPlanning) {
        this.setState((prevState) => ({
          orTasksAtPause: [...prevState.orTasksAtPause, taskId],
        }));
      }
    } else if (!isRotated) {
      // If the user rotated back to the original task
      this.setState((prevState) => ({
        orTasks: prevState.orTasks.filter(
          (stateTaskID) => taskId !== stateTaskID
        ), // Delete the element from the array
      }));
      if (isPlanning) {
        this.setState((prevState) => ({
          orTasksAtPause: prevState.orTasksAtPause.filter(
            (stateTaskID) => taskId !== stateTaskID
          ), // Delete the element from the array
        }));
      }
    }
  };

  handlePlayerStatus = (
    newEarnedValue,
    newRegular,
    newSenior,
    newExpensive,
    newBudget,
    newLocation
  ) => {
    const Change = this.state.playerStatusChange;
    const prevAnimationStats = this.state.playerDifAnimation;
    const lastMilestone = this.getLastMilestoneTileId();
    const lastGate = this.getLastGateTileId();
    this.setState((prev) => ({
      player: {
        ...prev.player,
        budget: newBudget,
        earnedValue: newEarnedValue,
        resources: {
          executive: newSenior,
          regular: newRegular,
          expensive: newExpensive,
        },
        position: newLocation,
      },
      playerDifAnimation: {
        budget: Change.priceDifference,
        earnedValue: Change.earnedValueDifference,
        resources: {
          regular: Change.regular,
          executive: Change.executive,
          expensive: Change.expensive,
        },
      },
      prevPlayerDifAnimation: {
        budget: prevAnimationStats.budget,
        earnedValue: prevAnimationStats.earnedValue,
        resources: {
          regular: prevAnimationStats.resources.regular,
          executive: prevAnimationStats.resources.executive,
          expensive: prevAnimationStats.resources.expensive,
        },
      },
    }));
  };

  getPlayerLog = async ({
    gameAndUserIdObj = false,
    lastPlayData = false,
    needssummaryReport = false,
    sendByMail = false,
    previousReport,
    reportPageDownLoad,
    isAbandoned = false,
    apiDate = null,
  }) => {
    const language = i18n.language;
    let { gameId } = this.state.player;
    let userId = this.state.player.id;
    if (gameAndUserIdObj) {
      gameId = gameAndUserIdObj.prevGameId;
      userId = gameAndUserIdObj.userId;
    }
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const playerStat = await axios.get(
      `${fetchConfig.prefix}/game/getCommentPerRow`,
      {
        params: {
          gameId,
          userId,
          lastPlayData,
          needssummaryReport,
          sendByMail,
          previousReport,
          userTimeZone,
          language,
          isAbandoned,
          serverDateTimeAtGameStart: this.state.serverDateTimeAtGameStart,
          unixTimestampMS: this.state.unixTimestampMS,
          clientDateTime: this.state.clientDateTime,
          apiDate: this.state.apiDate,
        },
      }
    );

    if (reportPageDownLoad) return playerStat;

    this.previousReportHandler(previousReport, playerStat);
    return playerStat;
  };

  base64toBlob = (data) => {
    // const bytes = Buffer.from(data, 'base64') // should be working, returning blank pdf.
    // .then((buf)=>{
    //     buf.toString('utf-8');}
    // )
    const bytes = atob(data); // DEPRICATED SHOULD FIND SOLOUTION!!

    let { length } = bytes;
    const out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  };

  previousReportHandler = (previousReport, playerStat) => {
    try {
      const playerData = playerStat?.data ? playerStat.data.summery : playerStat
      switch (previousReport) {
        case "download": {
          const result = `data:application/pdf;base64,${playerStat.data ? playerData.pdf : playerData.pdf}`;
          // triggerBase64Download(result, "PM_Zone Game Report"); // download the pdf;
          // const originalDate = new Date(playerData.startGameTime);
          // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          // const options = { timeZone: userTimeZone, timeZoneName: 'short', hour12: false };
          // const dateFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: userTimeZone, timeZoneName: 'short' };
          // const timeFormatOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: userTimeZone, timeZoneName: 'short', hour12: false };
          // const formattedDateTemp = originalDate.toLocaleDateString("en-GB", dateFormatOptions).split(',')[0]
          // const formattedDate = formattedDateTemp.split('/').reverse().join('-');
          // const formattedTime = originalDate.toLocaleTimeString(undefined, timeFormatOptions).split(' ')[0];
          console.log("player data", playerData)
          const date = playerData.startGameTimeAsFullUtcString?.replace(":", "_") ?? ""
          const reportName = `PMzone-Simulation-Board-Game-Player-Summary-Report-${date}`;
          triggerBase64Download(result, reportName); // download the pdf with the updated name
          break;
        }
        case "view": {
          const blob = this.base64toBlob(playerStat.data.summery.pdf);
          const blobURL = URL.createObjectURL(blob);
          const win = window.open();
          if (!win || win.closed || typeof win.closed == "undefined") {
            const msg = (
              <div>
                We couldn't open your Report preview in a new window because it
                seems you have a popup blocker.
                <br />
                Please disable popup blockers for this site.
              </div>
            );

            this.onlyShowModal("Popup Blocked", msg, "OK, Got it");
            return;
          }
          win.document.write(
            `<iframe src="${blobURL}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
          );
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
          }, 100);
          break;
        }
        default:
          return;
      }
    } catch (e) {
      console.log("Error catched from previous reports function. ", e);
      this.errorLoadingDataPopUp();
    }
  };

  async getCommentsTable() {
    const responseData = await axios.get(`${fetchConfig.prefix}/game/get_comments_table`);
    return responseData.data;
  }

  refreshPopUP = () => {
    window.onbeforeunload = function rfrsh() {
      return "";
    };
  };
  async recheckDoneTasks() {
    const responseData = await axios.get(`${fetchConfig.prefix}/project/done_tasks?gameId=${this.state.player.gameId}&userId=${this.state.player.id}`);
    const completedTasks = responseData.data.map((current) => +current.value);

    if (completedTasks.length >= this.state.tasks.length) {
      this.showEndGameModal(true);
    } else {
      this.showEndGameModal(false);
    }
  }
  performCard = async (
    cardId,
    cardType,
    optionNum,
    commentIt = async () => { },
    additionalComments = []
  ) => {
    // mark that the player has already reached done this unplanned thing, used for Restore Game
    Board[this.state.player.position].executed = true;
    this.saveGame({ board: Board });
    this.toggleProjectNeedToBeDisabled(true);
    this.setState((prevState) => ({
      card: {
        ...prevState.card,
        cardToggle: false,
      },
      isZeroSteps: true,
    }));
    const playerPosition = this.state.player.position;
    const upcomingGateId = this.getUpcomingGateTileId();
    const currentTileType = Board[this.state.player.position].type;
    const { turnNumber, tasksTimer } = this.state;
    const timeSeconds = this.timeSeconds.current;
    const actionTime = timeSeconds - tasksTimer;
    if (cardType === "unplanned-task") {
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        cardId,
        playerPosition,
        upcomingGateId,
        turnNumber,
        timer: actionTime,
        oneLessStep: this.state.oneLessStep,
      };
      const playerStatus = await axios.post(
        `${fetchConfig.prefix}/game/unplanned_task`,
        data
      );
      if (typeof playerStatus.data === "string") {
        this.onlyShowModal(
          "Cannot execute task",
          playerStatus.data,
          "OK, Got it"
        );
        this.toggleProjectNeedToBeDisabled(false);
      } else {
        // this.setState((prev) => ({
        //   tasksTimer: prev.timeSeconds,
        // }));
        // this.state.tasksTimer = this.state.timeSeconds; // reset taskTimer state.
        await this.additionalBudgetCommentsInit(playerStatus.data[1]); // addition budget comment initiatior.
        // await this.resourcesForDoublePriceCommentInit(playerStatus.data[1]);
        await commentIt(playerStatus.data[1]);
        if (additionalComments.length > 0) {
          additionalComments.map((commentItFunction) => {
            commentItFunction(playerStatus.data[1]);
          });
        }
        let continueTurn = false;
        if (playerStatus.data[0].location != this.state.player.position) {
          continueTurn = true;
        }
        setTimeout(() => this.SoundPlay(moneySound), 200);
        this.SoundPlay(soundForFlipAndCards);
        const prevPosition = this.state.player.position;
        const numberOfSteps = playerStatus.data[0].location - prevPosition;
        // numberOfSteps = numberOfSteps === 0 ? numberOfSteps = 1 : numberOfSteps;
        this.toggleSideLogAnimation("unplanned");
        this.sideLogUpdate(false);
        const goToData = {
          constLocation: false,
          steps: true,
          NumberOfSteps: numberOfSteps,
          log: playerStatus,
          continue: continueTurn,
        };
        this.goTo(goToData); // maybe a problem with continueTurn variable
        this.updateBoardTileExecuted(playerStatus.data[0].location);
        let numberOfStepsDelay = numberOfSteps;

        if (this.state.endGameModal) {
          if (numberOfStepsDelay == 0) {
            numberOfStepsDelay = 1;
          }
          setTimeout(
            this.SetEndGameModal(),
            Math.abs(numberOfStepsDelay) * 1333
          );
        }
      }
    } else if (cardType === "Risk" || cardType === "Constraint") {
      const lastMilestoneOrGateTileNum = await this.goToLastMilestoneOrGate(
        0,
        0,
        true
      );
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        cardId,
        lastMilestoneOrGateTileNum,
        playerPosition,
        upcomingGateId,
        turnNumber,
        timer: actionTime,
        oneLessStep: this.state.oneLessStep,
      };
      const playerStatus = await axios.post(
        `${fetchConfig.prefix}/game/risk`,
        data
      );
      if (typeof playerStatus.data === "string") {
        this.onlyShowModal(
          "Cannot execute task",
          playerStatus.data,
          "OK, Got it"
        );
        this.toggleProjectNeedToBeDisabled(false);
      } else {
        // this.setState((prev) => ({
        //   tasksTimer: prev.timeSeconds,
        // }));
        // this.state.tasksTimer = this.state.timeSeconds; // reset taskTimer state.
        let continueTurn = false;
        await commentIt(playerStatus.data[1]);
        await this.additionalBudgetCommentsInit(playerStatus.data[1]); // addition budget comment initiatior.
        // await this.resourcesForDoublePriceCommentInit(playerStatus.data[1]);
        if (playerStatus.data[0].location != this.state.player.position) {
          continueTurn = true;
        }
        setTimeout(() => this.SoundPlay(moneySound), 200);
        this.SoundPlay(soundForFlipAndCards);
        const prevPosition = this.state.player.position;
        const numberOfSteps = playerStatus.data[0].location - prevPosition;
        // this.toggleProject(0);
        if (
          (data.cardId == 58 || data.cardId == 59 || data.cardId == 61) &&
          !optionNum
        ) {
          const goToLastGateorMilestone = await this.goToLastMilestoneOrGate(
            playerStatus,
            continueTurn
          );
          if (!goToLastGateorMilestone) {
            // this.goTo({ constLocation: true, steps: false, id: 0, log: playerStatus, continue: continueTurn }) // maybe a problem with continueTurn variable
            setTimeout(() => {
              this.SoundPlay(stepsSound); // needs to be a special sound in the future
              this.moveCameraWithPlayerReverse(playerPosition, true);
              this.walkingAlgorithm(0, 0, playerStatus, false);
              // this.endTurn();
            }, 1000);
          }
        } else {
          // numberOfSteps = numberOfSteps === 0 ? numberOfSteps = 1 : numberOfSteps;
          const toggleAnimation =
            cardType == "Risk"
              ? this.toggleSideLogAnimation("risk")
              : this.toggleSideLogAnimation("constraint");
          this.sideLogUpdate(false);
          const goToData = {
            constLocation: false,
            steps: true,
            NumberOfSteps: numberOfSteps,
            log: playerStatus,
            continue: continueTurn,
          };
          this.goTo(goToData); // maybe a problem with continueTurn variable
        }
        let numberOfStepsDelay = numberOfSteps;
        if (this.state.endGameModal) {

          axios.post(`${fetchConfig.prefix}/game/complete_saved_game`, {
            gameId: this.state.player.gameId,
          });

          if (numberOfStepsDelay == 0) {
            numberOfStepsDelay = 1;
          }
          this.setState((prevState) => ({
            dontShowNextCard: true,
          }));
          setTimeout(
            () =>
              this.onlyShowModal(
                "modals.project_completed.info_title",
                "modals.project_completed.info_text",
                "modals.project_completed.button1"
              ),
            Math.abs(numberOfStepsDelay) * 1111,
            this.toggleProjectNeedToBeDisabled(false)
          );
        }
      }
    } else if (cardType === "Delay") {
      let lastMilestoneOrGateTileNum;

      if (cardId === 3 || cardId === 4)
        lastMilestoneOrGateTileNum = await this.goToLastMilestoneOrGate(
          0,
          0,
          true
        );
      if (cardId === 4 && optionNum == 1) {
        this.toggleGoToStartFromDelay(true);
      }

      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        cardId,
        optionNum,
        lastMilestoneOrGateTileNum,
        playerPosition,
        turnNumber,
        timer: actionTime,
        oneLessStep: this.state.oneLessStep,
      };
      const playerStatus = await axios.post(
        `${fetchConfig.prefix}/game/delay`,
        data
      );
      if (typeof playerStatus.data === "string") {
        this.onlyShowModal(
          "Cannot execute task",
          playerStatus.data,
          "OK, Got it"
        );
        this.toggleProjectNeedToBeDisabled(false);
      } else {
        // FIX: Explicitly close the card state so the snapshot doesn't think it's still open
        this.setState(prevState => ({
          card: {
            ...prevState.card,
            cardToggle: false
          }
        }));

        if (playerStatus.data[0].earnedValue < this.state.player.earnedValue) {
          this.setMovedToLessValueAtDelayCard(true);
        }
        this.toggleSideLogAnimation("delay");
        this.sideLogUpdate(false);
        // this.setState((prev) => ({
        //   tasksTimer: prev.timeSeconds,
        // }));
        // this.state.tasksTimer = this.state.timeSeconds; // reset taskTimer state.
        this.SoundPlay(soundForFlipAndCards);
        let continueTurn = false;
        if (playerStatus.data[0].location != this.state.player.position) {
          continueTurn = true;
        }
        if (
          currentTileType == "gate" &&
          (
            (cardId == 4 && optionNum == 2) ||
            (cardId == 3 && optionNum == 2)
          )
          && this.state.secondGateControlNeeded
        ) {
          this.toggleGate(true);
          continueTurn = true;
          // here need to hold the change status until the secon gate control is pass.
        } else if (
          currentTileType == "gate" &&
          ((optionNum == 1 && cardId == 3) ||
            (optionNum == 1 && cardId == 4) ||
            cardId
          ) &&
          this.state.secondGateControlNeeded
        ) {
          continueTurn = true;
        } else if (
          currentTileType == "gate" &&
          ((optionNum == 1 && cardId == 3) ||
            (optionNum == 1 && cardId == 4)) &&
          !this.state.secondGateControlNeeded
        ) {
          this.triviaToggle(false);
          continueTurn = true;
        } else if (
          currentTileType == "gate" &&
          !this.state.delayCardIsTakenInGateControl
        ) {
          // WHAT THIS THING DO?!
          this.toggleTriviaNotOpenIfDelay(false);
          this.toggleGate(true);
          // this.toggleDelayCardAtFirstGateControl(false);
          continueTurn = true;
        }
        const prevPosition = this.state.player.position;
        const numberOfSteps = playerStatus.data[0].location - prevPosition;
        if (optionNum == 1 && cardId == 4) {
          continueTurn = true;
        }
        if (
          this.state.player.position <= this.state.firstMilestoneTileId &&
          optionNum == 1 &&
          cardId == 3
        ) {
          continueTurn = true;
        }

        await this.recheckDoneTasks();  // in case we have a redo card we want to recheck the "done tasks" value

        if (this.state.player.position != "gate") {
          // ||
          // this.state.player.position != 24 ||
          // this.state.player.position != 36)
          if (data.cardId == 3 && optionNum == 1 && continueTurn) {
            const lastMilestoneOrGate = await this.goToLastMilestoneOrGate(
              playerStatus,
              continueTurn
            );
            if (!lastMilestoneOrGate) {
              continueTurn = false;
              // this.goTo({ constLocation: true, steps: false, id: 0, log: playerStatus, continue: continueTurn }) // maybe a problem with continueTurn variable
              setTimeout(() => {
                this.SoundPlay(stepsSound); // needs to be a special sound in the future
                this.moveCameraWithPlayerReverse(playerPosition, true);
                this.walkingAlgorithm(0, 0, playerStatus, continueTurn);
                // this.endTurn();
              }, 1000);
            }
          } else if (data.cardId == 4 && continueTurn && optionNum == 1) {
            continueTurn = false;
            // this.goTo({ constLocation: true, steps: false, id: 0, log: playerStatus, continue: continueTurn }) // maybe a problem with continueTurn variable
            setTimeout(() => {
              this.SoundPlay(stepsSound); // needs to be a special sound in the future
              this.moveCameraWithPlayerReverse(playerPosition, true);
              this.walkingAlgorithm(0, 0, playerStatus, continueTurn);
              // this.endTurn();
            }, 1000);
          } else {
            // numberOfSteps = numberOfSteps === 0 ? numberOfSteps = 1 : numberOfSteps;
            const goToData = {
              constLocation: false,
              steps: true,
              NumberOfSteps: numberOfSteps,
              log: playerStatus,
              continue: continueTurn,
            };
            this.goTo(goToData); // maybe a problem with continueTurn variable
            // this.walkingAlgorithm(numberOfSteps, prevPosition, playerStatus, continueTurn);
          }
        }
        let numberOfStepsDelay = numberOfSteps;
        if (this.state.endGameModal) {
          axios.post(`${fetchConfig.prefix}/game/complete_saved_game`, {
            gameId: this.state.player.gameId,
          });

          if (numberOfStepsDelay == 0) {
            numberOfStepsDelay = 1;
          }
          this.setState((prevState) => ({
            dontShowNextCard: true,
          }));
          setTimeout(
            () =>
              this.onlyShowModal(
                "modals.project_completed.info_title",
                "modals.project_completed.info_text",
                "modals.project_completed.button1"
              ),
            Math.abs(numberOfStepsDelay) * 1111
          );
        }
      }
      this.toggleGoToStartFromDelay(false);
    }
    this.toggleProjectNeedToBeDisabled(false);
  };

  setInstructorAndAccountId = (instructorId, accountId) => {
    this.setState((prev) => ({
      player: {
        ...prev.player,
        accountId: accountId,
        instructorId: instructorId,
      }
    }))
  }

  /**
   * @param {string} title - The title of the modal, Also controls the buttons to be shown
   */
  onlyShowModal = (title, text, button, modalButtons = "modals.welcome.button1") => {
    this.setState((prev) => ({
      modalTitle: title,
      modalText: text,
      modalButton: button,
      modalToggle: true,
      // modalToggle: !prev.modalToggle,
      modalInfoButton: modalButtons,
    }));
  };

  toggleExperationModal = (state) => {
    this.setState((prev) => ({
      showExperationModal: !prev.showExperationModal,
    }));
  };

  showModal = async () => {
    this.setState((prev) => ({
      modalToggle: !prev.modalToggle,
    }));

    if (
      !this.state.taskToggle &&
      !this.state.resourceToggle &&
      this.state.modalTitle === "modals.welcome.info_title"
    ) {
      this.toggleProject(0);
    }
  };

  restartGameFunction = async (playerName, Email, overrideInstructorId = null, overrideAccountId = null) => {
    const initialState = this.getInitialState();
    const { player, gameEventId, playerEmail, languagesList, currentLanguage, shortCutLanguage, allMainProjects } = this.state;
    const creationDateTime = { creationTime: initialState.gameStartTime, creationDate: initialState.gameStartDate };
    const newGameResult = await createNewGame(
      player.id,
      gameEventId,
      creationDateTime,
      overrideAccountId ?? player.accountId,
      overrideInstructorId ?? player.instructorId,
      true // forceNewGame = true to delete saved game and create fresh game
    );

    // Extract gameId from result (could be object { gameId: ... } or just the number)
    const newGameId = newGameResult?.gameId || newGameResult;

    // Reset the finished run before any new-game requests can read its state.
    await new Promise(resolve => this.setState({
      ...initialState,
      socketIO: this.state.socketIO,
      gameEventId,
      playerEmail,
      languagesList,
      currentLanguage,
      shortCutLanguage,
      allMainProjects,
      modalText: 'modals.welcome.info_text',
      needsToStartNewGame: true,
      resetTimer: true,
      clearTimer: true,
      player: {
        ...initialState.player,
        id: player.id,
        gameId: newGameId,
        name: playerName,
        fullName: player.fullName,
        canPlayUntil: player.canPlayUntil,
        assistantMode: player.assistantMode,
        instructorId: overrideInstructorId ?? player.instructorId,
        accountId: overrideAccountId ?? player.accountId,
      },
    }, resolve));
    this.resetGameRuntime();
    await this.handleLogin(playerName, player.id, newGameId, shortCutLanguage);
    await this.sideLogUpdate(false, player.id, newGameId, false);
    this.SoundPlay(stepsSound);
    this.handleRestartMap();
    this.toggleProject(3);
  };

  resetGameRuntime = () => {
    this.gameStartTime.current = performance.now();
    this.pauseForPlanningTimer.current = 0;
    this.preGamePlanningNetMsRef.current = null;
    this.totalPlanningTimeRef.current = 0;
    this.totalTimoutInPlanningDuration.current = 0;
    this.totalTimeoutDuration.current = 0;
    this.startedPlanningTimeRef.current = null;
    this.timeoutStartTime.current = null;
    this.timeSeconds.current = 0;
    this.isPlanningRef.current = false;
    this.isGamePausedRef.current = false;
    this.lastFlipped.current = 0;
    this.hasExecuteRemainingTasksAtGateRef.current = 0;
    this.projectPopupCount.current = -1;
    this.changedProjectOrder.current = false;
    this.executeTaskWithOpenPredecessor = false;
    this.executeTaskWithNotEnoughResources = false;

    for (let i = 0; i < Board.length; i++) {
      Board[i].landed = false;
      Board[i].checked = false;
      Board[i].executed = false;
      if (Board[i].type === "gate") {
        Board[i].gate.passed = false;
        Board[i].gate.firstTime = true;
      } else if (Board[i].type === "mile-stone") {
        Board[i].milestone.passed = false;
        Board[i].milestone.popUp = false;
      }
    }
  };

  restartGameWithNewProject = async projectId => {
    this.closeEverything();
    this.isPaused(false);
    this.setNewTurn(false);
    this.toggleChangeProject(false);
    this.setCheckedTask(null); // Reset task selection to avoid stale IDs from previous project

    // Call changeProject and capture result which now includes instructor_id and account_id
    const changeProjectResult = await this.changeProject(projectId);

    this.setState({ projectId: projectId });
    this.commentEndGameAbandoned();

    // Pass the fetched IDs to restartGameFunction
    await this.restartGameFunction(
      this.state.player.name,
      null,
      changeProjectResult?.instructor_id,
      changeProjectResult?.account_id
    );
  };

  closeEverything = () => {
    this.setState((prev) => ({
      card: {
        cardToggle: false,
      },
      MilestoneModalShow: false,
      ExecuteTaskPopUpShow: false,
      showTrivia: false,
      prevReportPopUp: false,
      toggleGate: false,
      resourceToggle: false,
      taskToggle: false,
      gameLogToggle: false,
    }));
  }

  changeProject = async projectId => {
    let result;
    try {
      // Pass gameId as well to fetch current context
      const gameId = this.state.player.gameId;
      const response = await axios.get(`${fetchConfig.prefix}/game/changeProject?projectId=${projectId}&userId=${this.state.player.id}&gameId=${gameId}`);
      return response.data; // Return the full data object
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  commentAdditionalBudget = async (budget, taskRowId = -1) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const data = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent: `${budget}$ Additional budget received`,
      playerPosition: this.state.player.position,
      taskRowId,
      turnNumber,
    };
    const result = await axios.get(
      `${baseUrl}?gameId=${data.gameId}&userId=${data.userId
      }&comment=${encodeURI(data.commentContent)}&playerPosition=${data.playerPosition
      }&taskRowId=${data.taskRowId}`,
      data
    );
  };
  commentEndGameAbandoned = async () => {
    const baseUrl = `${fetchConfig.prefix}/game/comment_endgame_abandoned`;
    const data = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
    };
    return await axios.get(
      `${baseUrl}?gameId=${data.gameId}&userId=${data.userId
      }&comment=${encodeURI(data.commentContent)}&playerPosition=${data.playerPosition
      }&taskRowId=${data.taskRowId}`,
      data
    );
  };

  toggleProject = (stage, cards = null) => {
    this.projectPopupCount.current++;
    this.lastFlipped.current = this.state.tasks.filter((e) => e.isOrFlipped).length;
    // const updatedTasks = this.state.tasks;
    const cardType = Board[this.state.player.position].type;
    // eslint-disable-next-line react/no-access-state-in-setstate
    const updatedTasks = cards !== null ? cards : this.state.tasks;
    this.setState((prevState) => ({
      tasksByNumber:
        prevState.tasksByNumber.length > 0
          ? prevState.tasksByNumber
          : prevState.tasks,
    }));
    let completedTasks;
    axios
      .get(
        `${fetchConfig.prefix}/project/done_tasks?gameId=${this.state.player.gameId}&userId=${this.state.player.id}`
      )
      .then((responseData) => {
        completedTasks = responseData.data.map((current) => +current.value);
        this.setState({
          tasks: updatedTasks.map((task, index) => ({
            ...task,
            // id: index + 1,
            // relationships: filterRelationshipsFromData(task),
            // completed: completedTasks.includes(task.id),
            completed: completedTasks.includes(task.taskIdnumberInDB),
          })).sort((a, b) => {
            const indexA = completedTasks.indexOf(a.taskIdnumberInDB);
            const indexB = completedTasks.indexOf(b.taskIdnumberInDB);

            if (indexA === -1 || indexB === -1) {
              return 0;
            }

            return completedTasks.indexOf(a.taskIdnumberInDB) - completedTasks.indexOf(b.taskIdnumberInDB);
          }),
        });
        if (completedTasks.length >= this.state.tasks.length - 1) {
          this.toggleOnePlannedTaskLeft(true);
        }
        if (completedTasks.length >= this.state.tasks.length) {
          this.showEndGameModal(true);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
    // });

    // }
    axios
      .get(
        `${fetchConfig.prefix}/game/general_task_status?gameId=${this.state.player.gameId}&userId=${this.state.player.id}`
      )
      .then((response) => {
        const completedGeneralTasks = [0, 0, 0, 0, 0];
        response.data.map(
          (current) => completedGeneralTasks[current.value - 1]++
        );
        this.setState((prevState) => ({
          generalTasks: completedGeneralTasks,
        }));
      })
      .catch((error) => {
        console.log("error: ", error);
      });

    this.mapScreenshot();
    this.state.taskToggle ? this.handleRestartMap() : '';
    // !prev.MilestoneModalShow ? prev.taskToggle :
    if (stage != 3) {
      this.setState((prev) => ({
        taskToggle: !prev.taskToggle,
        projectStage: stage,
        tasks: updatedTasks,
        openGeneralPmTasks: !prev.taskToggle ? prev.openGeneralPmTasks : false,
        showOpenProjectSheetAfterBack: !prev.taskToggle
          ? false
          : prev.showOpenProjectSheetAfterBack,
      }));
    }
  };

  errorLoadingDataPopUp = () => {
    this.onlyShowModal(
      "Error while loading data",
      "Cannot load the current media at the moment.",
      "OK, Got it"
    );
  };

  setTasksPopupClose = () => {
    this.setState({ taskToggle: false });
  };

  toggleResources = (status) => {
    if (status != false) {
      this.setTasksTimer();
      console.log("setting tasks timer", this.state.tasksTimer)
    }
    this.setState({
      resourceToggle: status,
    });
  };

  setTasksCounter = (counter) => {
    this.setState({
      generalIndexCounter: counter,
      plannedTaskExecutedIndex: counter,
    });
  };

  projectScopeDisabeling = (status) => {
    this.setState({
      projectNeedToBeDisabled: status,
      ProjectScopeBackButtonDisabled: status,
    });
    return true;
  };

  toggleToolTip = (status) => {
    this.setState({
      toolTipToggle: status,
    });
  };

  toggleMilestoneFirstTime = (status) => {
    this.setState({
      milestonefirstpass: status,
    });
  };

  toggleSeconGateControl = (status) => {
    this.setState({
      gateSecondControlShow: status,
    });
  };

  toggleNeedsToDelayExecutePopup = (status) => {
    this.setState({
      needsToDelayExecutePopup: status,
    });
  };

  setTasksButOrTasksNotSaved = (status) => {
    this.setState({
      tasksButOrTasksNotSaved: status,
    });
  };

  setSelectedCardIs = cardId => {
    this.setState({
      selectedUnPlannedTask: cardId,
    })
  }
  setIsChoosingFromDelayedCard = status => {
    this.setState({
      isChoosingFromDelayedCard: status,
    })
  }
  setPlayerEmail = (status) => {
    this.setState({
      playerEmail: status,
    });
  };

  handleTurnNumber = (status) => {
    this.setState({
      turnNumber: status,
    });
  };

  setResourcesInTheTurn = (status) => {
    this.setState({
      amountResourcesExpensive: status,
    });
  };

  toggleSecondGateNeeded = (status) => {
    this.setState({
      secondGateControlNeeded: status,
    });
  };

  togglePrevReportPopUp = (status) => {
    this.setState({
      prevReportPopUp: status,
    });
  };

  toggleTriviaNotOpenIfDelay = (status) => {
    this.setState({
      openTriviaWhenDelayTaken: status,
    });
  };

  gameLogToggle = (status) => {
    this.setState({
      gameLogToggle: status,
    });
  };

  triviaToggle = (status) => {
    if (status) {
      this.toggleDisableScreen(true);
    } else {
      setTimeout(() => this.toggleDisableScreen(false), 1000);
    }
    this.setState({
      showTrivia: status,
    });
  };

  toggleIncorrectBrowser = (status) => {
    this.setState({
      showBrowserErrorPopUp: status,
    });
  };

  toggleRestoreGamePopup = (status) => {
    this.setState({
      showRestoreGamePopup: status,
    });
  };

  toggleIsFirstMileStonePassed = (status) => {
    this.setState({
      firstMileStonePassed: status,
    });
  };

  turnEndsInGateToggle = (status) => {
    this.setState({
      turnNeedsToEndInGate: status,
    });
  };

  toggleInfo = (status) => {
    this.setState({
      generalInfoShow: status,
    });
  };

  toggleGameDefinitions = (status) => {
    this.setState({
      gameDefinitionsShow: status,
    });
  };

  toggleProjectNeedToBeDisabled = (status) => {
    this.setState({
      projectNeedToBeDisabled: status,
    });
    return true;
  };

  advanceOfferedToGoBack = () => {
    const state = this.state.offeredToGoBack + 1;
    this.setState({
      offeredToGoBack: state
    })
  }
  advanceOfferedToGoToStart = () => {
    const state = this.state.offeredToGoToStart + 1
    this.setState({
      offeredToGoToStart: state
    })
  }

  toggleProjectScopeBackButtonDisabled = (status) => {
    this.setState({
      ProjectScopeBackButtonDisabled: status,
    });
  };

  toggleSaveOnGate = (status) => {
    this.setState({
      saveOnGate: status,
    });
  };

  toggleIsAnimationNeeded = (status, backButton) => {
    this.setState({
      animationVars: {
        isAnimationNeeded: status,
        cameFromSideBar: backButton,
      },
    });
  };

  togglePlanYourProjectPopUp = (status) => {
    if (status == false) this.isPlanning(true);
    this.setState({
      gameFirstPopUp: status,
    });
  };

  toggleMilestoneModal = (status) => {
    this.setState({
      MilestoneModalShow: status,
    });
  };

  toggleDelayCardAtFirstGateControl = (status) => {
    this.setState({
      delayCardIsTakenInGateControl: status,
    });
  };

  toggleGateTextNeedToChange = (status) => {
    this.setState({
      gateTextNeedToChange: status,
    });
  };

  toggleTutorial = (status) => {
    this.setState({
      tutorialShow: status,
    });
  };

  toggleModal = (status) => {
    this.setState({
      modalToggle: status,
    });
  };

  setMovedTaskBeforePredecessorCount = (status) => {
    if (status) {
      this.setState({
        movedTaskBeforePredecessorCount: status,
      });
      this.setMovedTaskBeforePredecessorCount(!status);
    } else {
      this.setState({
        movedTaskBeforePredecessorCount: status,
      });
    }
  };

  toggleGate = (status, needSecondGateControl = false) => {
    if (status) {
      // only if opening the gate we want this function to work
      this.endGameFunction(true, this.state.player.id, 0, "Ignore_me", true);
    }
    this.setState({
      toggleGate: status,
    });
    if (!status) {
      if (!needSecondGateControl) {
        this.setGateTestResult("");
        Board[this.state.player.position].gate.firstTime = false;
      }
      setTimeout(() => this.toggleDisableScreen(false), 1000);
    }
  };

  modalVisible = (status) => {
    this.setState({
      modalVisible: status,
    });
  };

  setTimerSeconds = (status) => {
    this.timeSeconds.current = (
      (performance.now() - this.gameStartTime.current - this.totalTimeoutDuration.current) / 1000
    ).toFixed(0)
  };

  quitGameModal = (status) => {
    this.onlyShowModal(
      "modals.end_game.info_title",
      "modals.end_game.info_text",
      "modals.end_game.button1",
      "modals.end_game.button2"
    );
  };

  // quitGameModal = (status) => { // example for the POC of the translation task
  //   this.onlyShowModal(
  //     "modals.end game.header",
  //     "modals.end game.paragraph",
  //     "modals.end game.left button",
  //     "modals.end game.right button"
  //   );
  // };

  toggleExecutePopUp = (status) => {
    let completedTasks = 0;
    this.state.tasks.map((current) =>
      current.completed ? completedTasks++ : ""
    );
    if (completedTasks == this.state.tasks.length) return // if player completed the project scope don't show him this pop up
    this.setState({
      ExecuteTaskPopUpShow: status,
    });
  };

  toggleClearTimer = (status) => {
    this.setState({
      clearTimer: status,
    });
  };

  ProjectScopeDisable = (status) => {
    this.setState({
      isDisabledPMTasks: status,
    });
    return true;
  };

  StartTurnMessageDisable = (status) => {
    this.setState({
      isStartTurnMessageShowing: status,
    });
  };

  toggleNotEnoughResourcesPopUp = (status, checkedPmCount = 0) => {
    this.setState({
      NotEnoughResourcesPopUpShow: status,
      checkedPmCount: checkedPmCount,
    });
  };

  toggleBeginTurnPopUp = (status) => {
    this.setState({
      BeginTurnPopUpShow: status,
    });
    if (!status) {
      setTimeout(() => this.toggleDisableScreen(false), 1000);
    } else {
      this.toggleDisableScreen(true);
    }
  };

  setGateTestResult = status => {
    this.setState({
      gateTestResult: status,
    });
  }

  isPlanning = (status) => {
    // console.log("setting isPlanning to ", this.isPlanningRef.current, status)
    if (this.isPlanningRef.current == false && status == true)
      this.startedPlanningTimeRef.current = performance.now();
    else if (this.isPlanningRef.current == true && status == false)
      this.totalPlanningTimeRef.current +=
        performance.now() - this.startedPlanningTimeRef.current;

    // console.log("performance.now()", performance.now())
    // console.log("startedPlanningTimeRef", this.startedPlanningTimeRef.current, "status", status)
    // console.log("totalTimoutInPlanningDuration", this.totalTimoutInPlanningDuration.current, "status", status)
    // console.log("totalPlanningTimeRef= ", performance.now(), " - ", this.startedPlanningTimeRef.current, " -", this.totalTimoutInPlanningDuration.current)
    // console.log("-totalPlanningTimeRef", this.totalPlanningTimeRef.current, "status", status)

    this.isPlanningRef.current = status;
    this.setState({
      isPlanning: status,
    });
  };

  toggleAfterMilestonePopUp = (status) => {
    this.setState({
      AfterMilestonePopUpShow: status,
    });
  };

  toggleMilestonCkeckbox = (status) => {
    this.setState({
      afterMilestonChecked: status,
    });
  };

  toggleNeedsToStartNewGame = (status) => {
    this.setState({
      needsToStartNewGame: status,
    });
  };

  setTasksTimer = () => {
    const actualTimer = this.getSecondsTime();
    console.log("setting tasks timer", actualTimer);
    this.setState({
      tasksTimer: actualTimer,
    });
  };

  getSecondsTime = () => {
    return this.timeSeconds.current;
  };

  toggleResetTimer = (status) => {
    if (this.state.resetTimer == true || status == false) {
      this.gameStartTime.current = performance.now();
      this.totalTimeoutDuration.current = 0;
    }
    this.setState({
      resetTimer: status,
    });
  };

  updatePlanningTimer = (status) => {
    this.pauseForPlanningTimer.current = status;
  };

  handleGateNumber = (status) => {
    this.setState({
      gateNumber: status,
    });
  };

  handleDefinitionsStage = (status) => {
    this.setState({
      gameDefinitionsStage: status,
    });
  };

  toggleBeginTurnCkeckbox = (status) => {
    this.setState({
      beginTurnChecked: status,
    });
  };

  toggleIdlePopUp = (state) => {
    this.setState({
      idlePopUp: state,
    });
  };

  toggleStartGamePopUp = (status) => {
    this.setState({
      StartGamePopUpShow: status,
    });
  };

  setOpenGeneralPmTasks = (status) => {
    this.setState({
      openGeneralPmTasks: status,
    });
  };

  toggleIsGamePaused = (status) => {
    if (status == true && this.isGamePausedRef.current == false) {
      // if we are goin into pause
      this.timeoutStartTime.current = performance.now();
    } else if (status == false && this.isGamePausedRef.current == true) {
      // if we are exiting a timeOut back to the game
      const timeoutEndTime = performance.now();
      const timeoutDuration = timeoutEndTime - this.timeoutStartTime.current; // Duration of the timeout in milliseconds
      this.totalTimeoutDuration.current += timeoutDuration;
      if (this.isPlanningRef.current == true)
        this.totalTimoutInPlanningDuration.current += timeoutDuration;
    }
    this.isGamePausedRef.current = status;
    this.setState({
      isGamePaused: status,
    });
  };
  setTasks = (status) => {
    this.setState({
      tasks: status,
    });
  };

  toggleExecuteGPMTOnMilestone = (status) => {
    this.setState({
      executeGPMTOnMilestone: status,
    });
  };

  toggleKeepShowingBeginTurnPopUp = (status) => {
    this.setState({
      keepShowingBeginTurnPopUp: status,
    });
  };

  setDisableBudget = (status) => {
    this.setState({
      disableAdditionalBudgetPopUpSideBar: status,
    });
  };

  setNewTurn = (status) => {
    this.setState({ newTurn: status });
    setTimeout(() => this.toggleDisableScreen(false), 1000);
  };

  setCheckedTask = (taskId) => {
    this.setState({ checkedTask: taskId });
  };
  setShowOpenProjectSheetAfterBack = (status) => {
    this.setState({ showOpenProjectSheetAfterBack: status });
  };
  setSocketIO = (socket) => {
    this.setState({ socketIO: socket });
  }

  setOneLessStep = (oneLessStep, callback = () => { }) => {
    this.setState({
      oneLessStep,
      oneLessStepTurn: this.state.turnNumber
    }, callback);
  }

  setLocalTimerOfPreviousGame = (number) => {
    this.setState({ localTimerOfPreviousGame: number });
  };

  setIsGameStarted = (status) => {
    if (status == true) {
      this.isPlanning(false);
      const net = this.computePreGamePlanningNetMsFromRefs();
      this.preGamePlanningNetMsRef.current = net;
      this.pauseForPlanningTimer.current = net / 1000;
    }
    this.setState({ isGameStartedForTheFirstTime: status });
  };

  setPressedOkGotIt = (value) => {
    this.setState({
      pressedOkGotIt: value,
    })
  }

  toggleDisableScreen = (status) => {
    this.setState({ disableScreen: status });
  };

  setKeepShowingIdlePopUp = (status) => {
    this.setState({ keepShowingIdlePopUp: status });
  };

  setIsCardCountDownActive = (status) => {
    console.log("status:", status);
    this.setState({ isCardCountDownActive: status });
  };

  toggleOpenSheetAfterPopUp = (status) => {
    this.setState({ toggleOpenSheetAfterPopUp: status });
  };

  toggleRestartHasBeenMadeNow = () => {
    this.setState((prev) => ({
      gateRestartCounter: prev.gateRestartCounter + 1,
    }));
  };

  toggleOpenSheetAfterPopUp;
  // POC - side log animation controller.
  toggleSideLogAnimation = (animationElement) => {
    return;
    // console.log(animationElement);
    // this.setState((prev) => ({
    //   sideLogAnimation: {
    //     ...prev.sideLogAnimation,
    //     [animationElement]: true,
    //   },
    // }));

    // setTimeout(() => {
    //   this.setState((prev) => ({
    //     sideLogAnimation: {
    //       ...prev.sideLogAnimation,
    //       [animationElement]: false,
    //     },
    //   }));
    // }, 10 * 1000);
  };

  openAdditionalBudgetPopUp = (status) => {

    this.setState((prev) => ({
      modalTitle: "modals.additional_budget.info_title",
      modalText: "modals.additional_budget.info_text",
      modalButton: "modals.additional_budget.button1",
      modalInfoButton: "modals.additional_budget.button2",
      modalToggle: status,
    }));

  }

  isPaused = async (status) => {
    if (status === false) {
      this.setState({
        showIsPaused: false,
        newTurn: true,
      });
      if (this.state.player.position > 1) {
        this.toggleBeginTurnPopUp(false);
        // some functions may call isPaused() twice or call isPaused and startTurn, resulting in the Project tasks window to appear and disappear right after.
        // to avoid these miss-behaviors this check is in place, because for some unknown reason to me this only happens on Gate and MileStone and UnplanedTask tiles.
        // its better to just check if the beginNewTurnPopup is enabled but im afraid it can brick some code.
        // const currentTileType = Board[this.state.player.position].type;
        // if (currentTileType != 'mile-stone' && currentTileType != 'gate' && currentTileType != 'Risk' && currentTileType != 'unplanned-task' && currentTileType != 'planned-task' && currentTileType != 'constraint') {
        //     this.startTurn();
        // }
        // This is getting ridiculous, why even call it in the first place?
      }
      // if (!this.state.isStartTurnMessageShowing) {
      //     this.toggleBeginTurnPopUp(true);
      // } else {
      //     console.log("hello world!");
      //     this.startTurn();
      // }
    } else if (status === 2) {
      // if we want both
      this.startTurn(true);
      this.setState({
        showIsPaused: true,
      });
    } else {
      // status === true means user clicked "Pause for planning"
      // Save snapshot BEFORE closing the modal so the modal state is preserved
      if (this.state.player && this.state.player.gameId && this.state.player.id) {
        try {
          const currentTime = performance.now();
          const elapsedMilliseconds = currentTime - this.gameStartTime.current - this.totalTimeoutDuration.current;
          const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
          const gameRunTimeSeconds = `0${Math.floor(totalSeconds % 60)}`.slice(-2);
          const gameRunTimeMinutes = `0${Math.floor((totalSeconds / 60) % 60)}`.slice(-2);
          const gameRunTimeHours = `0${Math.floor((totalSeconds / 3600) % 60)}`.slice(-2);
          const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;

          // Get current modal state BEFORE it's closed
          const modalState = this.getCurrentModalState();

          // Get additional snapshot data
          const additionalData = this.getAdditionalSnapshotData();

          await axios.post(`${fetchConfig.prefix}/game/save_game_snapshot`, {
            gameId: this.state.player.gameId,
            userId: this.state.player.id,
            timer: gameRunTime,
            cardState: (this.state.card && this.state.card.cardToggle) ? this.state.card : null,
            modalState, // Save which modal is showing (should be "EndOfTurn")
            additionalData,
            currentPosition: this.state.player.position
          });
        } catch (error) {
          console.error("Error saving snapshot on pause:", error);
        }
      }

      this.setState({
        showIsPaused: true,
      });
    }
  };

  handleRestartMap = () => {
    const positionGlobal = this.state.player.position - 2;
    const counter = positionGlobal / 3;
    const yReset = counter * 25;
    if (this.state.player.position > 3) {
      this.setState({
        value: {
          scale: 1,
          translation: { x: 0, y: yReset * (window.innerHeight / 100) },
        },
      });
    } else {
      this.setState({
        value: {
          scale: 1,
          translation: { x: 0, y: 0 },
        },
      });
    }
  };

  moveCameraWithPlayer = (tileId) => {
    const lastY = this.state.value.translation.y;
    if ((tileId % 4 === 3 || tileId % 4 === 0) && tileId > 4) {
      if (((tileId / 8) % 8) % 2 === 1) {
        this.setState({
          value: {
            scale: 1,
            translation: { x: 0, y: lastY + 85 },
          },
        });
      } else {
        this.setState({
          value: {
            scale: 1,
            translation: { x: 0, y: lastY + 185 },
          },
        });
      }
    }
  };

  moveCameraWithPlayerReverse = (tileId, startingPoint) => {
    if (!startingPoint) {
      const lastY = this.state.value.translation.y;
      if ((tileId % 4 === 1 || tileId % 4 === 0) && tileId > 4) {
        if (((tileId / 8) % 8) % 2 === 1) {
          this.setState({
            value: {
              scale: 1,
              translation: { x: 0, y: lastY - 100 },
            },
          });
        } else {
          this.setState({
            value: {
              scale: 1,
              translation: { x: 0, y: lastY - 200 },
            },
          });
        }
      }
    } else {
      this.setState({
        value: {
          scale: 1,
          translation: { x: 0, y: 0 },
        },
      });
    }
  };

  limitMovement = () => {
    const prevX = this.state.value.translation.x;
    const prevY = this.state.value.translation.y;
    const maxY = (Board.length - 1) * 25 * 3.85;
    if (prevY < -517) {
      this.setState({
        value: {
          scale: 1,
          translation: { x: prevX, y: -500 },
        },
      });
    } else if (prevY > maxY) {
      this.setState({
        value: {
          scale: 1,
          translation: { x: prevX, y: maxY - 25 },
        },
      });
    } else if (prevX > 635) {
      this.setState({
        value: {
          scale: 1,
          translation: { x: 625, y: prevY },
        },
      });
    } else if (prevX < -470) {
      this.setState({
        value: {
          scale: 1,
          translation: { x: -460, y: prevY },
        },
      });
    }
  };

  playerStatusChangeStats = async (playerStatus, secondUpdate) => {
    const prevPosition = this.state.player.position;
    const numberOfSteps = Math.abs(
      playerStatus.data[0].location - prevPosition
    );

    const prevValue = this.state.player.earnedValue;
    const earnedValue = playerStatus.data[0].earnedValue - prevValue;

    const prevRegular = this.state.player.resources.regular;
    const regular = playerStatus.data[0].regular - prevRegular;

    const prevExecutive = this.state.player.resources.executive;
    const executive = playerStatus.data[0].senior - prevExecutive;

    const prevExpensive = this.state.player.resources.expensive;
    const expensive = playerStatus.data[0].expensive - prevExpensive;

    const prevPrice = this.state.player.budget;
    const price = playerStatus.data[0].budget - prevPrice;
    if (secondUpdate) {
      this.setState((prev) => ({
        playerStatusChange: {
          ...prev.playerStatusChange,
          earnedValue,
          stepsDifference: numberOfSteps,
          earnedValueDifference: earnedValue,
          priceDifference: price,
          regular,
          executive,
          expensive,
        },
        playerStatus,
      }));
    } else {
      this.setState((prev) => ({
        playerStatusChange: {
          ...prev.playerStatusChange,
          earnedValue,
          stepsDifference: numberOfSteps,
          earnedValueDifference: earnedValue,
          priceDifference: price,
          regular,
          executive,
          expensive,
        },
      }));
    }
  };

  handlePlayerPosition = (location) => {
    this.setState((prevState) => ({
      player: {
        ...prevState.player,
        position: location,
      },
    }));
  };

  handleUnplannedCards = (newCards, addBack) => {
    this.setState((prevState) => ({
      unplannedCards: [{ ...newCards }, ...prevState.unplannedCards],
      cardState: true,
    }));
  };

  removeUnplannedCards = (chosenId) => {
    this.setState((prevState) => ({
      unplannedCards: prevState.unplannedCards.filter(
        (current) => current.id != chosenId
      ),
    }));
  };
  setResizePopup = (state) => {
    this.setState({
      resizePopUpShown: state
    });
  };
  setOriginalPercentage = (state) => {
    this.setState((prevState) => ({
      originalPercentage: state
    }));
  };

  setUpdatedCards = (cardArray) => {
    this.setState((prevState) => ({
      updatedCards: cardArray,
    }));
  };

  toggleDownloadReport = (status) => {
    this.setState((prevState) => ({
      downloadReport: status,
    }));
  };
  setResizePercentage = (status) => {
    this.setState((prevState) => ({
      resizePercentage: status,
    }));
  };

  setCardState = (status) => {
    this.setState({
      cardState: status,
    });
  };

  showEndGameModal = (status) => {
    this.setState({
      endGameModal: status,
    });
  };

  setPlannedTaskStack = (plannedTasks) => {
    this.setState({
      plannedTaskStack: plannedTasks
    })
  }

  toggleOnePlannedTaskLeft = (status) => {
    this.setState({
      onePlanedTaskLeft: status,
    });
  };

  setChangesMade = (status) => {
    this.setState({
      changesMade: status,
    });
  };

  bumpReorderAction = () => {
    // Phase 2B note: kept for diagnostics only; commit-time reorder count is
    // computed via baseline diff in sendCardsToServer.
    this.setState((prev) => ({
      reorderActionsSinceBaseline: prev.reorderActionsSinceBaseline + 1,
    }));
  };

  markManualReorderTouched = () => {
    this.setState({
      manualReorderTouched: true,
    });
  };

  /** Phase 2D: task numbers the user dragged since last committed baseline (unique). */
  markTaskDragged = (taskNumber) => {
    const n = Number(taskNumber);
    if (!Number.isFinite(n)) return;
    this.setState((prev) => {
      if (prev.draggedTaskIdsSinceBaseline.includes(n)) return null;
      return {
        draggedTaskIdsSinceBaseline: [...prev.draggedTaskIdsSinceBaseline, n],
      };
    });
  };

  resetDraggedTasks = () => {
    this.setState({ draggedTaskIdsSinceBaseline: [] });
  };

  setGameUIdOfPrevGame = (gameId) => {
    this.setState({
      gameUIdOfPrevGame: gameId,
    });
  };
  setMovedToLessValueAtDelayCard = (value) => {
    this.setState({
      movedToLessValueAtDelayCard: value,
    });
  };
  toggleGoToStartFromDelay = value => {
    this.setState({
      goToStartFromDelay: value,
    })
  }

  setAskedForBudgetAtGate = (budget) => {
    this.setState((prev) => ({
      performedLateTasksAtGateAndAskedFor: {
        ...prev.performedLateTasksAtGateAndAskedFor,
        budget,
      }
    }));
  }

  setAskedForResourcesAtGate = (resources) => {
    this.setState((prev) => ({
      performedLateTasksAtGateAndAskedFor: {
        ...prev.performedLateTasksAtGateAndAskedFor,
        resources,
      }
    }));
  }

  toggleChangeProject = status => {
    this.setState({
      showChangeProjectPopUp: status,
    })
  }
  toggleHelp = status => {
    this.setState({
      helpShow: status,
    })
  }
  setCurrentLanguage = (lang, shortLang) => {
    this.setState({
      currentLanguage: lang,
      shortCutLanguage: shortLang
    })

    // emit only if socket was already created, eg. started playing
    this.state.socketIO?.emit("changed-language", {
      language: shortLang
    })
  }


  SetEndGameModal = (status) => {
    if (this.state.endGameModal || status) {

      axios.post(`${fetchConfig.prefix}/game/complete_saved_game`, {
        gameId: this.state.player.gameId,
      });

      this.setState((prevState) => ({
        dontShowNextCard: true,
      }));
      let completedTasks = 0;
      this.state.tasks.map((current) =>
        current.completed ? completedTasks++ : ""
      );
      if (completedTasks >= this.state.tasks.length) {
        this.onlyShowModal(
          "modals.project_completed.info_title",
          "modals.project_completed.info_text",
          "modals.project_completed.button1"
        );
      } else {
        this.onlyShowModal(
          "modals.game_over.info_title",
          "modals.game_over.info_text",
          "modals.game_over.button1"
        );
      }
    }
  };
  handleCardSetDelayValueByEffect = (effect) => {
    const gatePosition = Board.findIndex(item => item.type === 'gate');
    const passedFirstGate = gatePosition !== -1 && this.state.player.position >= gatePosition
    if (effect === 'go_back') {
      this.advanceOfferedToGoBack()
    }
    if (effect === 'go_back_to_start') {
      if (!passedFirstGate) this.advanceOfferedToGoBack()
      else this.advanceOfferedToGoToStart()
    }
  }
  handleCardSetConstraintValueByEffect = (steps) => {
    const gatePosition = Board.findIndex(item => item.type === 'gate');
    const passedFirstGate = gatePosition !== -1 && this.state.player.position > gatePosition;
    if (steps < 0 || steps === 100) {
      this.advanceOfferedToGoBack()
    }
  }
  handleCard = async (type) => {
    this.toggleDisableScreen(true);
    if (this.state.dontShowNextCard) {
      console.log("dont erase me please"); // Why ?
    } else {
      if (this.state.card.cardToggle) {
        let cardMoreThenZeroSteps = true;
        if (this.state.card.steps > 0) {
          cardMoreThenZeroSteps = false;
        }
        this.setState((prevState) => ({
          card: {
            ...prevState.card,
            cardToggle: false,
          },
          isZeroSteps: cardMoreThenZeroSteps,
        }));
      }
      const currentTileType = Board[this.state.player.position].type;
      let chosenCard = "did not got it";
      let optionTwo;
      const lastMileStone = this.getLastMilestoneTileId();
      // const upcomingMilestome = this.getUpcomingMilestoneTileId();
      let completedTask = 0;
      this.state.tasks.map((current) =>
        current.completed ? completedTask++ : ""
      );
      switch (type) {
        default:
        case "planned-task":
          if (
            lastMileStone &&
            this.state.player.position >= lastMileStone &&
            Board[lastMileStone].milestone.popUp === false
          ) {
            Board[lastMileStone].milestone.popUp = true;
            this.toggleMilestoneModal(true);
          }
          //   else if (
          //     this.state.player.position === 1 &&
          //     completedTask < 1 &&
          //     !this.state.taskToggle
          //   ) {
          //     this.toggleProject(0);
          //   }
          break;
        case "unplanned-task":
          this.SoundPlay(soundForFlipAndCards);
          if (
            lastMileStone &&
            this.state.player.position >= lastMileStone &&
            Board[lastMileStone].milestone.popUp === false
          ) {
            this.toggleMilestoneModal(true);
            Board[lastMileStone].milestone.popUp = true;
            // this.handleMilestone(this.state.player.gameId, this.state.player.id);
            // const changeIndex = this.state.milestonePopUp.indexOf(true);
            // const newMilestone = [...this.state.milestonePopUp];
            // newMilestone[changeIndex] = false;
            // this.setState(prevState => ({
            //     milestonePopUp: [...newMilestone],
            // }));
          } else {
            try {
              chosenCard = await axios.get(
                `${fetchConfig.prefix}/game/take_card`,
                {
                  params: {
                    gameId: this.state.player.gameId,
                    userId: this.state.player.id,
                    cardType: type,
                    existingCards: this.state.unplannedCards.map(card => card.id),
                  },
                }
              );
            } catch (e) {
              console.log(e);
            }
            // this.handleTotalValue();
            // eslint-disable-next-line no-case-declarations
            let exceptionalCardCheck;
            if (this.state.unplannedCards.length > 0) {
              exceptionalCardCheck = true;
            } else {
              exceptionalCardCheck = false;
            }
            // Create the new card state before setState
            const newCardState = {
              ...chosenCard.data,
              cardToggle: true,
            };

            this.setState((prevState) => ({
              card: newCardState,
              explanationCard: exceptionalCardCheck,
              unplannedCards: [
                { ...chosenCard.data },
                ...prevState.unplannedCards,
              ],
              cardState: false,
            }), () => {
              // Save card state immediately after it opens - pass the new card state
              this.saveCardStateSnapshot(newCardState);
            });
            if (this.state.unplannedCards.length > 1) {
              this.setIsChoosingFromDelayedCard(true);
              this.setState((prevState) => ({
                unplannedCards: prevState.unplannedCards.slice(1),
              }));
            }
          }
          break;
        case "Risk":
        case "Constraint":
          this.SoundPlay(soundForFlipAndCards);
          if (
            lastMileStone &&
            this.state.player.position >= lastMileStone &&
            Board[lastMileStone].milestone.popUp === false
          ) {
            this.toggleMilestoneModal(true);
            Board[lastMileStone].milestone.popUp = true;
            // this.handleMilestone(this.state.player.gameId, this.state.player.id);
            // const changeIndex = this.state.milestonePopUp.indexOf(true);
            // const newMilestone = [...this.state.milestonePopUp];
            // newMilestone[changeIndex] = false;
            // this.setState(prevState => ({
            //     milestonePopUp: [...newMilestone],
            // }));
          } else {
            try {
              chosenCard = await axios.get(
                `${fetchConfig.prefix}/game/take_card`,
                {
                  params: {
                    gameId: this.state.player.gameId,
                    userId: this.state.player.id,
                    cardType: type,
                  },
                }
              );
            } catch (e) {
              console.log(e);
            }
            this.handleCardSetConstraintValueByEffect(chosenCard.data.steps)

            // Create the new card state before setState
            const newCardState = {
              ...chosenCard.data,
              cardToggle: true,
            };

            this.setState({
              card: newCardState,
            }, () => {
              // Save card state immediately after it opens - pass the new card state
              this.saveCardStateSnapshot(newCardState);
            });
          }
          break;
        case "Delay":
          this.SoundPlay(soundForFlipAndCards);
          try {
            chosenCard = await axios.get(
              `${fetchConfig.prefix}/game/take_delay_card`,
              {
                params: {
                  gameId: this.state.player.gameId,
                  userId: this.state.player.id,
                  value: this.state.player.earnedValue,
                  cards: this.state.tasks.filter((e) => e.completed)
                    .length,
                  oneStepLess: this.state.oneLessStep,
                },
              }
            );
          } catch (e) {
            console.log(e);
          }
          console.log(chosenCard)
          this.handleCardSetDelayValueByEffect(chosenCard.data.effect)

          // Create the new card state before setState
          const newCardState = {
            type,
            id: chosenCard.data.id,
            name: chosenCard.data.description,
            delayOptions: {
              optionOne: chosenCard.data.optionOneEffect,
              optionTwo: chosenCard.data.optionTwoValue
            },
            cardToggle: true,
          };

          this.setState({
            card: newCardState,
          }, () => {
            // Save card state immediately after it opens - pass the new card state
            this.saveCardStateSnapshot(newCardState);
          });
          break;
        case "finish":
          // eslint-disable-next-line no-case-declarations
          let completedTasks = 0;
          this.state.tasks.map((current) =>
            (current.completed && current.redo != 1) ? completedTasks++ : ""
          );
          this.showEndGameModal(true);
          setTimeout(() => this.SetEndGameModal(), 250);
          break;

        case "gate":
        case "mile-stone":
          this.getTriviaData();
          if (
            lastMileStone &&
            this.state.player.position >= lastMileStone &&
            Board[lastMileStone].milestone.popUp === false
          ) {
            this.toggleMilestoneModal(true);
            Board[lastMileStone].milestone.popUp = true;
            break;
          } else if (this.isPlayerOnMileStone()) {
            // sometimes if the milestone has passed it wont enter the block above resulting in the GPM Task screen staying closed.
            this.toggleProject(1);
            this.ProjectScopeDisable(true);
            console.log(3121);
          } else if (
            currentTileType === "gate" &&
            this.state.secondGateControlNeeded
          ) {
            this.setTasksPopupClose(false);
            this.toggleGate(true);
            break;
          } else if (
            currentTileType === "gate" &&
            !this.state.delayCardIsTakenInGateControl &&
            !this.state.openTriviaWhenDelayTaken
          ) {
            this.setTasksPopupClose(false);
            this.toggleGate(true);
            break;
          } else if (
            currentTileType === "gate" &&
            this.state.openTriviaWhenDelayTaken
          ) {
            // here need to open the trivia
            console.log("hi yoni9");
            this.toggleDelayCardAtFirstGateControl(true);
            this.triviaToggle(true);
            this.SoundPlay(soundForFlipAndCards);
            this.turnEndsInGateToggle(true);
            this.setTasksPopupClose(false);
            break;
          } else if (
            currentTileType === "gate" &&
            !this.state.secondGateControlNeeded &&
            !this.state.showTrivia
          ) {
            this.toggleGate(true);
          } else {
            console.log("dont get crush2");
          }
      }
      setTimeout(() => this.toggleDisableScreen(false), 750);
    }
  };

  handleMilestone = async (gameId, userId) => {
    let playerStat;
    const spot = this.state.player.position;
    const milestone = this.getLastMilestoneTileId();
    const tileObj = Board[milestone];
    if (tileObj.executed) {
      tileObj.milestone.passed = true;
      return;
    }
    const { turnNumber } = this.state;
    try {
      const data = {
        gameId,
        userId,
        spot,
        milestone,
        tileObj,
        turnNumber,
      };
      playerStat = await axios.post(
        `${fetchConfig.prefix}/game/milestone`,
        data
      );
    } catch (e) {
      console.log(e);
    }

    this.setState((prevState) => ({
      player: {
        ...prevState.player,
        budget: playerStat.data.budget,
        resources: {
          regular: playerStat.data.regular,
          executive: playerStat.data.senior,
          expensive: playerStat.data.expensive,
        },
      },
    }));

    // mark that the player has already reached this milestone, used for Restore Game
    tileObj.executed = true;
    this.saveGame({ board: Board });
    await this.sideLogUpdate(false, userId, gameId);
  };

  handleGate = async (gateNumber) => {
    // Sync state.gateNumber with the actual gate ID from Board
    this.setState({ gateNumber });
    this.toggleDisableScreen(true);
    try {
      const result = await axios.get(`${fetchConfig.prefix}/game/gate_tasks`, {
        params: {
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
          gateNumber,
          turnNumber: this.state.turnNumber,
        },
      });
      this.setState((prevState) => ({
        gateTasks: result.data,
      }));
    } catch (e) {
      console.log(e);
    }
    this.toggleGate(true);
  };

  handleProgress = () => {
    // if (this.state.player.position == Board.length) {
    //     console.log('exceeded board length.');
    //     this.setState({
    //         endGameModal: true,
    //     });
    // }
    const currentTileType = Board[this.state.player.position].type;
    const currentTile = Board[this.state.player.position];
    const lastMileStone = this.getLastMilestoneTileId();
    // const upcomingMilestome = this.getUpcomingMilestoneTileId();
    const lastGate = this.getLastGateTileId();
    const upComingGate = this.getUpcomingGateTileId();

    if (
      lastMileStone &&
      this.state.player.position >= lastMileStone &&
      Board[lastMileStone].milestone.passed === false
    ) {
      // if (this.state.firstMileStonePassed) {
      //     this.setState({
      //         firstMileStonePassed: false,
      //     });
      // } else {
      //     this.setState({
      //         firstMileStonePassed: true,
      //     });
      // }
      this.handleMilestone(this.state.player.gameId, this.state.player.id);
      // this.toggleMilestoneModal(true);
      // Board[lastMileStone].milestone.popUp = true;

      // const changeIndex = this.state.milestone.indexOf(false);
      // const newMilestone = [...this.state.milestone];
      // newMilestone[changeIndex] = true;
      // this.setState(prevState => ({
      //     milestone: [...newMilestone],
      // }));
      // if (lastMileStone){
      //     Board[lastMileStone].milestone.passed = true;
      // }else if (upcomingMilestome){
      //     Board[upcomingMilestome].milestone.passed = true;
      // }
      const cardType = Board[this.state.player.position].type;
      // tileObj.passed = true;
      if (this.state.endGameModal) {
        this.SetEndGameModal();
      }
      if (!this.state.dontShowNextCard) {
        this.handleCard(cardType);
      }
      // this.toggleProjectScopeBackButtonDisabled(false)
    } else if (
      (upComingGate &&
        this.state.player.position >= upComingGate &&
        !Board[upComingGate].gate.passed) ||
      (!upComingGate &&
        lastGate &&
        this.state.player.position >= lastGate &&
        !Board[lastGate].gate.passed)
      // (this.state.player.position >= 24 && this.state.gate[1] === false) ||
      // (this.state.player.position >= 36 && this.state.gate[2] === false)
    ) {
      if (this.state.endGameModal) {
        this.SetEndGameModal();
      } else if (!currentTile.gate.passed) {
        this.ProjectScopeDisable(true);
        console.log(3307);
        const playerPos = this.state.player.position;
        this.setState((prevState) => ({
          taskToggle: false,
          player: {
            ...prevState.player,
            position: playerPos,
          },
        }));
        currentTile.gate.passed = true;
        // Use currentTile.gate.id instead of this.state.gateNumber to ensure correct gate number
        this.handleGate(currentTile.gate.id);
      }
    } else {
      // this.handlePlayerPosition(playerPosition);
      const cardType = Board[this.state.player.position].type;
      if (this.state.endGameModal && cardType == "planned-task") {
        setTimeout(() => this.SetEndGameModal(), 250);
      }
      if (
        cardType == "planned-task"
        // this.state.isZeroSteps &&
        // && this.state.player.position !== 1
        // && !this.state.ExecuteTaskPopUpShow
      ) {
        setTimeout(() => this.toggleProject(3), 220);
        this.toggleExecutePopUp(true);
        // setTimeout(() => this.toggleProject(0), 250);
        this.setState({
          isZeroSteps: false,
        });
      }
      let completedTasks = 0;
      this.state.tasks.map((current) =>
        current.completed ? completedTasks++ : ""
      );
      if (!this.state.dontShowNextCard || completedTasks >= this.state.tasks.length) {
        this.handleCard(cardType);
      }
    }
  };

  askRestoreGame = (userId, playerName, prevGameId) => {
    this.setState({
      tempUserId: userId,
      tempPlayerName: playerName,
      prevGameId,
    });
    this.toggleRestoreGamePopup(true);
  };

  handleRestoreGame = async (userId, prevGameId, playerName, providedState = null, canPlayUntil = null) => {
    // get and locally set general game and user data
    try {
      // Set flags EARLY so handleLogin can see them if called during restoration
      this.setState({
        isContinuedGame: true,
        isItAPreviousGame: true,
      });

      console.log("=== FRONTEND: RESTORING GAME ===");
      console.log("User ID:", userId);
      console.log("Game ID:", prevGameId);
      console.log("Provided state:", providedState ? "YES" : "NO - will fetch from API");

      // If state is provided, use it; otherwise fetch from API
      const fetchResult = providedState ? { data: providedState } : await axios.get(
        `${fetchConfig.prefix}/game/get_previous_game_data`,
        {
          params: {
            gameId: prevGameId,
            userId,
          },
        }
      );

      console.log("📥 DATA RECEIVED FROM SERVER:");
      console.log("   Budget:", fetchResult.data.budget);
      console.log("   Regular:", fetchResult.data.regular);
      console.log("   Senior:", fetchResult.data.senior);
      console.log("   Expensive:", fetchResult.data.expensive);
      console.log("   Location:", fetchResult.data.location);
      console.log("   EarnedValue:", fetchResult.data.earnedValue);
      console.log("   Board:", fetchResult.data.board ? `(${JSON.parse(fetchResult.data.board).length} cells)` : "empty");
      console.log("   Tasks:", fetchResult.data.tasks ? "exists" : "empty");
      console.log("   Unplanned:", fetchResult.data.unplanned ? `(${JSON.parse(fetchResult.data.unplanned).length} tasks)` : "empty");
      console.log("   LocalTimer:", fetchResult.data.localTimer);

      // Load game log and project data in parallel to speed up
      const [prevGameLog, projectDataResponse] = await Promise.all([
        this.getPlayerLog({
          gameAndUserIdObj: {
            prevGameId,
            userId,
          },
        }),
        axios.get(fetchConfig.paths.tasks, {
          params: { userId: userId, eventId: this.state.gameEventId, gameId: prevGameId },
        }).catch(err => {
          console.error("Error loading project metadata:", err);
          return { data: null };
        })
      ]);

      const gameLog = await this.gameLogFetch(prevGameLog);
      const prevGameData = fetchResult.data;
      const projectData = projectDataResponse.data;

      // Calculate gate number based on player position
      // First, parse the board to find the gate at or before the player's position
      const parsedBoard = JSON.parse(prevGameData.board);
      let playerLocation = parseInt(prevGameData.location) || 0;

      // If we have a snapshot, use that location instead (it's more accurate)
      if (providedState?.state?.location !== undefined && providedState?.state?.location !== null) {
        const snapshotLocation = parseInt(providedState.state.location);
        if (!isNaN(snapshotLocation) && snapshotLocation >= 0) {
          playerLocation = snapshotLocation;
        }
      }

      // Find the gate at the current position, or the last gate before the position
      let currentGateId = 0;
      for (let i = 0; i < parsedBoard.length; i++) {
        if (parsedBoard[i].type === "gate") {
          if (parsedBoard[i].id <= playerLocation) {
            // This gate is at or before the player's position
            currentGateId = parsedBoard[i].gate?.id || parsedBoard[i].id;
          } else {
            // We've passed the player's position, break
            break;
          }
        }
      }

      // If player is on a gate, use that gate's ID
      if (parsedBoard[playerLocation]?.type === "gate" && parsedBoard[playerLocation]?.gate?.id) {
        currentGateId = parsedBoard[playerLocation].gate.id;
      }

      this.handleGateNumber(currentGateId);
      // Parse timer from database (format: "HH:MM:SS" or JSON string)
      let totalGameTimeInSeconds = 0;
      try {
        let timerString = prevGameData.localTimer;
        // Remove JSON quotes if present
        if (timerString.startsWith('"') && timerString.endsWith('"')) {
          timerString = timerString.slice(1, -1);
        }
        // Handle "aN:aN:aN" or invalid timer format
        if (timerString && timerString !== "aN:aN:aN" && timerString.includes(":")) {
          const parts = timerString.split(":");
          if (parts.length === 3) {
            const hours = parseInt(parts[0]) || 0;
            const minutes = parseInt(parts[1]) || 0;
            const seconds = parseInt(parts[2]) || 0;
            totalGameTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
          }
        }
      } catch (error) {
        console.error("Error parsing timer:", error);
        totalGameTimeInSeconds = 0;
      }

      // Set gameStartTime so timer starts from the correct time
      // If we have previous game time, adjust gameStartTime backwards
      if (totalGameTimeInSeconds > 0) {
        this.gameStartTime.current = performance.now() - (totalGameTimeInSeconds * 1000);
      } else {
        this.gameStartTime.current = performance.now();
      }

      // Restore cumulative planning time (pre-game planning must not reset on re-entry).
      const snapshotOverlay = {
        ...(providedState && typeof providedState === "object" ? providedState : {}),
        ...(providedState?.state && typeof providedState.state === "object"
          ? providedState.state
          : {}),
      };
      const planningSnap = snapshotOverlay.planningSession || null;
      let restoredPlanningFromSnapshot = false;
      if (planningSnap && typeof planningSnap.completedPlanningMs === "number") {
        this.totalPlanningTimeRef.current = planningSnap.completedPlanningMs;
        this.totalTimoutInPlanningDuration.current =
          typeof planningSnap.timeoutDuringPlanningMs === "number"
            ? planningSnap.timeoutDuringPlanningMs
            : 0;
        if (planningSnap.wasPlanningOpen) {
          this.isPlanningRef.current = true;
          this.startedPlanningTimeRef.current = performance.now();
          this.setState({ isPlanning: true });
        } else {
          this.isPlanning(false);
        }
        restoredPlanningFromSnapshot = true;
      } else if (
        planningSnap &&
        typeof planningSnap.accumulatedMs === "number" &&
        !planningSnap.wasPlanningOpen
      ) {
        // Legacy snapshots: accumulatedMs matched closed-only totals when planning was not open.
        this.totalPlanningTimeRef.current = planningSnap.accumulatedMs;
        this.totalTimoutInPlanningDuration.current =
          typeof planningSnap.timeoutDuringPlanningMs === "number"
            ? planningSnap.timeoutDuringPlanningMs
            : 0;
        this.isPlanning(false);
        restoredPlanningFromSnapshot = true;
      } else {
        this.isPlanning(false);
      }

      let lockedPreGameMs = null;
      if (planningSnap && typeof planningSnap.preGamePlanningNetMs === "number") {
        lockedPreGameMs = planningSnap.preGamePlanningNetMs;
      } else if (
        planningSnap &&
        typeof planningSnap.completedPlanningMs === "number"
      ) {
        lockedPreGameMs = Math.max(
          0,
          planningSnap.completedPlanningMs -
            (typeof planningSnap.timeoutDuringPlanningMs === "number"
              ? planningSnap.timeoutDuringPlanningMs
              : 0),
        );
      } else if (
        planningSnap &&
        typeof planningSnap.accumulatedMs === "number" &&
        !planningSnap.wasPlanningOpen
      ) {
        lockedPreGameMs = Math.max(
          0,
          planningSnap.accumulatedMs -
            (typeof planningSnap.timeoutDuringPlanningMs === "number"
              ? planningSnap.timeoutDuringPlanningMs
              : 0),
        );
      }
      if (lockedPreGameMs != null) {
        this.preGamePlanningNetMsRef.current = lockedPreGameMs;
        this.pauseForPlanningTimer.current = lockedPreGameMs / 1000;
      }

      if (restoredPlanningFromSnapshot) {
        this.setState((p) => ({
          planningTimerBaselineRev: p.planningTimerBaselineRev + 1,
        }));
      }

      // First, update the board - this must happen before setting state
      // parsedBoard was already declared above for gate calculation, reuse it here
      await updateBoard(parsedBoard);

      // Verify board was updated correctly
      if (!Board || Board.length === 0) {
        console.error("Error: Board not updated correctly");
        throw new Error("Board update failed");
      }

      // Verify board state is correct after update
      console.log("🔍 BOARD STATE VERIFICATION:");
      console.log("   Board length:", Board.length);
      console.log("   Parsed board length:", parsedBoard.length);
      console.log("   Cell 0 checked:", Board[0]?.checked, "executed:", Board[0]?.executed);
      console.log("   Cell 1 checked:", Board[1]?.checked, "executed:", Board[1]?.executed);
      console.log("   Cell 2 checked:", Board[2]?.checked, "executed:", Board[2]?.executed);
      if (prevGameData.location) {
        const loc = parseInt(prevGameData.location);
        console.log(`   Cell ${loc} (player location) checked:`, Board[loc]?.checked, "executed:", Board[loc]?.executed);
      }

      // Count checked cells
      const checkedCount = Board.filter(cell => cell?.checked).length;
      const executedCount = Board.filter(cell => cell?.executed).length;
      console.log(`   Total checked cells: ${checkedCount}, executed cells: ${executedCount}`);

      // Get completed tasks from API to ensure correct status (load both in parallel)
      let completedTaskIds = [];
      let completedTaskIdsForProject = [];
      try {
        const completedTasksResponse = await axios.get(
          `${fetchConfig.prefix}/project/done_tasks?gameId=${prevGameId}&userId=${userId}`
        );
        completedTaskIds = completedTasksResponse.data.map((current) => +current.value);
        completedTaskIdsForProject = completedTaskIds; // Use same data for both
        console.log("✅ Completed tasks loaded:", completedTaskIds.length, "tasks");
      } catch (error) {
        console.error("Error loading completed tasks:", error);
      }

      const tasksArr = JSON.parse(prevGameData.tasks);

      // Ensure tasks have correct completed status
      if (tasksArr[0] && Array.isArray(tasksArr[0])) {
        tasksArr[0] = tasksArr[0].map(task => ({
          ...task,
          completed: completedTaskIds.includes(task.taskIdnumberInDB || task.id),
          // Preserve isOrFlipped status if it exists
        }));
        console.log("✅ Tasks updated with completed status");
      }

      // Use absolute location from database - player jumps directly to saved position
      // Board array uses 0-based indexing, so location 5 = Board[5]
      let newLocation = parseInt(prevGameData.location) || 0;

      // If we have a snapshot, use that location instead (it's more accurate)
      // The snapshot location is saved with currentPosition, which is the actual frontend position
      // Use state.location (now comes from snapshot playerState directly)
      if (providedState?.state?.location !== undefined && providedState?.state?.location !== null) {
        const snapshotLocation = parseInt(providedState.state.location);
        if (!isNaN(snapshotLocation) && snapshotLocation >= 0 && snapshotLocation < Board.length) {
          console.log("📍 Using snapshot location from state:", snapshotLocation, "instead of database location:", newLocation);
          newLocation = snapshotLocation;
        }
      }

      // Verify location is within board bounds
      if (newLocation >= Board.length) {
        console.warn(`⚠️ Location ${newLocation} is out of bounds (board length: ${Board.length}), using 0`);
        newLocation = 0;
      }

      console.log("📍 LOCATION SETUP:");
      console.log("   Database location:", prevGameData.location);
      console.log("   Parsed location:", newLocation);
      console.log("   Board length:", Board.length);
      console.log("   Board cell at location:", Board[newLocation] ? `id=${Board[newLocation].id}, type=${Board[newLocation].type}` : "OUT OF BOUNDS");

      // Set state only after board is updated
      // Ensure taskToggle is false initially to show board immediately
      // Also set all states that Get Started modal would set when closing
      this.setState(prevState => ({
        isZeroSteps: true,
        isContinuedGame: true,
        gameFirstPopUp: false,
        isItAPreviousGame: true,
        isStartTurnMessageShowing: false, // Don't show start turn message for restored games
        keepShowingBeginTurnPopUp: true, // Allow BeginTurnPopUp to show if needed
        BeginTurnPopUpShow: false, // Don't show begin turn popup
        modalToggle: false, // Don't show welcome modal
        taskToggle: false, // Show board first, not project sheet
        disableScreen: false, // Don't disable screen - show everything immediately
        isGameStartedForTheFirstTime: true, // Start timer for restored games
        isGamePaused: false, // Ensure game is not paused to prevent Time Out modal
        showIsPaused: false, // Don't show paused state
        // Ensure all modals are closed and clickable (not blocking)
        MilestoneModalShow: false,
        ExecuteTaskPopUpShow: false,
        StartGamePopUpShow: false,
        NotEnoughResourcesPopUpShow: false,
        gateSecondControlShow: false, // GateSecondControlPopUpShow
        AfterMilestonePopUpShow: false,
        gameFirstPopUp: false, // PlanYourProjectPopUpShow
        showTrivia: false,
        toggleGate: false,
        showChangeProjectPopUp: false,
        showExperationModal: false,
        showNetworkErrorPopUp: false,
        showBrowserErrorPopUp: false,
        prevReportPopUp: false,
        // States that Get Started modal sets when closing:
        pressedOkGotIt: true, // Set to true like Get Started does
        projectNeedToBeDisabled: false, // Ensure project sheet is clickable
        card: {
          cardToggle: false, // Ensure card is closed
        },
        boardUpdated: Date.now(), // Force re-render of board components
        gameLog,
        player: {
          ...prevState.player,
          id: userId,
          gameId: prevGameId,
          name: playerName,
          canPlayUntil: canPlayUntil || this.state.player.canPlayUntil || null,
          position: newLocation,
          budget: prevGameData.budget,
          earnedValue: prevGameData.earnedValue,
          resources: {
            regular: prevGameData.regular,
            executive: prevGameData.senior,
            expensive: prevGameData.expensive,
          },
        },
        tasks: tasksArr[0],
        tasksButOrTasksNotSaved: tasksArr[0],
        orTasks: tasksArr[1],
        generalTasks: tasksArr[2],
        unplannedCards: JSON.parse(prevGameData.unplanned),
        localTimerOfPreviousGame: totalGameTimeInSeconds,
        turnNumber: 1,
        // Restore additional snapshot data if available
        ...(providedState?.state?.popupDismissalState ? {
          afterMilestonChecked: providedState.state.popupDismissalState.afterMilestonChecked || false,
          beginTurnChecked: providedState.state.popupDismissalState.beginTurnChecked || false,
          keepShowingBeginTurnPopUp: providedState.state.popupDismissalState.keepShowingBeginTurnPopUp !== undefined
            ? providedState.state.popupDismissalState.keepShowingBeginTurnPopUp
            : true
        } : {}),
        ...(providedState?.state?.planningPause ? {
          showIsPaused: providedState.state.planningPause.isPausedForPlanning || false
        } : {}),
        ...(providedState?.state?.language ? {
          currentLanguage: providedState.state.language.currentLanguage || 'English',
          shortCutLanguage: providedState.state.language.shortCutLanguage || 'en'
        } : {}),
      }), async () => {
        // Comprehensive console log with all essential state
        console.log("=== GAME RESTORED ===");
        console.log("Player State:", {
          name: this.state.player.name,
          email: this.state.playerEmail,
          gameId: this.state.player.gameId,
          position: this.state.player.position,
          budget: this.state.player.budget,
          earnedValue: this.state.player.earnedValue,
          resources: {
            regular: this.state.player.resources.regular,
            executive: this.state.player.resources.executive,
            expensive: this.state.player.resources.expensive
          },
          time: this.state.localTimerOfPreviousGame,
          turnNumber: this.state.turnNumber
        });

        // Check if there's a saved modal state in the snapshot
        const savedModalState = providedState?.state?.modalState || providedState?.modalState || null;
        const savedCardState = providedState?.state?.cardState || providedState?.cardState || null;

        console.log("Modal State:", savedModalState ? {
          type: savedModalState.type,
          cardType: savedModalState.cardType || "N/A"
        } : "null");

        console.log("Card State:", {
          isOpen: savedCardState?.cardToggle || false,
          type: savedCardState?.type || null,
          id: savedCardState?.id || null
        });

        // Log additional restored data
        const savedCardsOrder = providedState?.state?.cardsOrder || providedState?.cardsOrder || null;
        const savedPopupDismissalState = providedState?.state?.popupDismissalState || providedState?.popupDismissalState || null;
        const savedPlanningPause = providedState?.state?.planningPause || providedState?.planningPause || null;
        const savedLanguage = providedState?.state?.language || providedState?.language || null;

        console.log("Cards Order:", savedCardsOrder ? {
          risks: savedCardsOrder.risks?.length || 0,
          constraints: savedCardsOrder.constraints?.length || 0,
          delays: savedCardsOrder.delays?.length || 0
        } : "null");
        console.log("Popup Dismissal State:", savedPopupDismissalState || "null");
        console.log("Planning Pause:", savedPlanningPause || "null");
        console.log("Language:", savedLanguage || "null");

        // Restore language if available
        if (savedLanguage && savedLanguage.shortCutLanguage) {
          try {
            i18n.changeLanguage(savedLanguage.shortCutLanguage);
          } catch (e) {
            console.error("Error changing language:", e);
          }
        }

        // Priority: If there's a saved modal state, restore it
        if (savedModalState) {
          console.log("Restoring saved modal state:", savedModalState);

          // Mark position as landed and checked
          const restoredLocation = newLocation;
          if (Board[restoredLocation]) {
            Board[restoredLocation].landed = true;
            Board[restoredLocation].checked = true;
          }

          // Restore modal based on type
          if (savedModalState.type === "card") {
            // Card modal - restore card state
            if (savedCardState && savedCardState.cardToggle === true) {
              // Get the correct position - use state.location (from snapshot)
              let cardPosition = newLocation;
              if (providedState?.state?.location !== undefined && providedState?.state?.location !== null) {
                const snapshotLocation = parseInt(providedState.state.location);
                if (!isNaN(snapshotLocation) && snapshotLocation >= 0 && snapshotLocation < Board.length) {
                  cardPosition = snapshotLocation;
                }
              }

              // Preserve all existing state (tasks, board, player, etc.) when restoring card
              this.setState((prevState) => ({
                card: savedCardState,
                // Preserve tasks and other important state
                tasks: prevState.tasks,
                tasksButOrTasksNotSaved: prevState.tasksButOrTasksNotSaved,
                orTasks: prevState.orTasks,
                generalTasks: prevState.generalTasks,
                unplannedCards: prevState.unplannedCards,
                player: {
                  ...prevState.player,
                  position: cardPosition // Use correct position from snapshot
                },
                boardUpdated: Date.now() // Force board re-render to show correct state
              }), () => {
                // Mark the correct position as landed and checked
                if (Board[cardPosition]) {
                  Board[cardPosition].landed = true;
                  Board[cardPosition].checked = true;
                }

                // After state is set, update sidebar with correct game log counts
                if (this.state.player && this.state.player.gameId && this.state.player.id) {
                  // Update sidebar log counts from gameLog
                  this.sideLogUpdate(false).catch(err => {
                    console.error("Error updating sidebar log:", err);
                  });
                  // Also recheck done tasks to ensure UI is updated
                  this.recheckDoneTasks().catch(err => {
                    console.error("Error rechecking done tasks:", err);
                  });
                }
              });
              return; // Exit early - card is already shown
            }
          } else if (savedModalState.type === "BeginTurnPopUp") {
            // BeginTurnPopUp modal
            this.setState({
              BeginTurnPopUpShow: true,
              keepShowingBeginTurnPopUp: true
            });
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "ExecuteTaskPopUp") {
            // ExecuteTaskPopUp modal
            this.setState({
              ExecuteTaskPopUpShow: true
            });
            this.toggleDisableScreen(true);
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "MilestoneModal") {
            // MilestoneModal - this will be handled by handleProgress if needed
            // Continue with normal flow
          } else if (savedModalState.type === "EndOfTurn") {
            // End of Turn modal
            this.setState({
              modalTitle: "modals.end_of_turn.info_title",
              modalText: "modals.end_of_turn.info_text",
              modalButton: "modals.end_of_turn.button2",
              modalInfoButton: "modals.end_of_turn.button1",
              modalToggle: true,
            });
            this.toggleDisableScreen(true);
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "AfterMilestonePopUp") {
            // AfterMilestonePopUp modal
            this.setState({
              AfterMilestonePopUpShow: true
            });
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "Trivia") {
            // Trivia modal
            this.setState({
              showTrivia: true
            });
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "GateSecondControlPopUp") {
            // GateSecondControlPopUp modal
            this.setState({
              gateSecondControlShow: true
            });
            return; // Exit early - modal is shown
          } else if (savedModalState.type === "NotEnoughResourcesPopUp") {
            // NotEnoughResourcesPopUp modal
            this.setState({
              NotEnoughResourcesPopUpShow: true
            });
            return; // Exit early - modal is shown
          }
        }

        // Fallback: If there's a saved card state with cardToggle=true (but no modalState), restore it directly
        if (savedCardState && savedCardState.cardToggle === true && !savedModalState) {
          console.log("Restoring saved card state (fallback):", {
            type: savedCardState.type,
            id: savedCardState.id,
            cardToggle: savedCardState.cardToggle
          });

          // Get the correct position - use state.location (from snapshot)
          let cardPosition = newLocation;
          if (providedState?.state?.location !== undefined && providedState?.state?.location !== null) {
            const snapshotLocation = parseInt(providedState.state.location);
            if (!isNaN(snapshotLocation) && snapshotLocation >= 0 && snapshotLocation < Board.length) {
              cardPosition = snapshotLocation;
            }
          }

          // Mark position as landed and checked
          if (Board[cardPosition]) {
            Board[cardPosition].landed = true;
            Board[cardPosition].checked = true;
          }

          // Restore the card state directly with correct position
          this.setState((prevState) => ({
            card: savedCardState,
            player: {
              ...prevState.player,
              position: cardPosition // Use correct position from snapshot
            }
          }), () => {
            // After state is set, update sidebar with correct game log counts
            if (this.state.player && this.state.player.gameId && this.state.player.id) {
              // Update sidebar log counts from gameLog
              this.sideLogUpdate(false).catch(err => {
                console.error("Error updating sidebar log:", err);
              });
              // Also recheck done tasks to ensure UI is updated
              this.recheckDoneTasks().catch(err => {
                console.error("Error rechecking done tasks:", err);
              });
            }
          });

          // Don't call walkingAlgorithm or handleProgress - just show the card
          return; // Exit early - card is already shown
        }

        // Get last log entry to determine what modal should be open
        const lastLogEntry = gameLog && gameLog.length > 0 ? gameLog[0] : null;
        const lastActionCode = lastLogEntry?.turnData?.code;
        const lastActionValue = lastLogEntry?.turnData?.value;
        const lastActionDecision = lastLogEntry?.turnData?.decision;
        const lastActionLocation = lastLogEntry?.turnData?.location;
        const lastActionSteps = lastLogEntry?.turnData?.steps;

        console.log("Last Action:", {
          code: lastActionCode,
          value: lastActionValue,
          decision: lastActionDecision,
          location: lastActionLocation,
          steps: lastActionSteps,
          description: lastActionCode === 2 ? "Planned Task" :
            lastActionCode === 3 ? "Unplanned Task" :
              lastActionCode === 4 ? "Risk" :
                lastActionCode === 5 ? "Constraint" :
                  lastActionCode === 6 ? "Delay" : "Other"
        });

        // Check current tile state
        const restoredLocation = newLocation;
        const currentTile = Board[restoredLocation];
        const currentTileType = currentTile?.type;
        const isTileExecuted = currentTile?.executed === true;

        console.log("Current Tile:", {
          position: restoredLocation,
          type: currentTileType,
          executed: isTileExecuted,
          id: currentTile?.id
        });

        // Check if task was executed but player didn't move (needs to move 1 step forward)
        const taskExecutedButNotMoved = (
          lastActionCode === 2 && // Planned task
          isTileExecuted && // Task is executed
          lastActionSteps === 0 && // No steps were taken (stepChange = 0)
          currentTileType === "planned-task" // Still on planned task tile
        );

        console.log("Game State Analysis:", {
          taskExecutedButNotMoved,
          shouldStartNewTurn: taskExecutedButNotMoved,
          shouldOpenCard: false, // Will be determined below
          shouldOpenExecuteTask: currentTileType === "planned-task" && !isTileExecuted && lastActionCode !== 2,
          shouldOpenEndOfTurn: false // Will be determined below
        });

        // Mark position as landed and checked
        if (Board[restoredLocation]) {
          Board[restoredLocation].landed = true;
          Board[restoredLocation].checked = true;
        }

        // If task was executed but player didn't move, need to show "End of Turn" modal
        // This will then show "Initiate Turn" modal when user clicks "Continue Playing"
        if (taskExecutedButNotMoved) {
          console.log("Task executed but player didn't move - showing End of Turn modal");
          // Show "End of Turn" modal - this will trigger the flow: End of Turn -> Initiate Turn -> startTurn()
          this.setState({
            modalTitle: "modals.end_of_turn.info_title",
            modalText: "modals.end_of_turn.info_text",
            modalButton: "modals.end_of_turn.button2",
            modalInfoButton: "modals.end_of_turn.button1",
            modalToggle: true,
          });
          this.toggleDisableScreen(true);
          return; // Exit early - modal will handle the rest
        }

        // Determine which modal should be open based on last action and current state
        let shouldOpenCard = false;
        let cardType = null;
        let cardId = null;

        // Check if Delay card should be open (taken after Risk/Constraint)
        if (lastActionCode === 6) {
          shouldOpenCard = true;
          cardType = "Delay";
        } else if ((lastActionCode === 4 || lastActionCode === 5) && lastActionDecision !== 0) {
          // Risk/Constraint was encountered but player chose "Take Delay Card"
          shouldOpenCard = true;
          cardType = "Delay";
        } else if (lastActionCode === 3) {
          // Unplanned task was drawn but not executed yet
          shouldOpenCard = true;
          cardType = "unplanned-task";
          cardId = lastActionValue;
        } else if (lastActionCode === 4 || lastActionCode === 5) {
          // Risk/Constraint was drawn but not executed yet
          shouldOpenCard = true;
          cardType = lastActionCode === 4 ? "Risk" : "Constraint";
          cardId = lastActionValue;
        }

        console.log("Modal State:", {
          shouldOpenCard,
          cardType,
          cardId,
          shouldOpenExecuteTask: currentTileType === "planned-task" && !isTileExecuted && lastActionCode !== 2,
          shouldOpenEndOfTurn: (currentTileType === "planned-task" && isTileExecuted && !taskExecutedButNotMoved) ||
            (currentTileType !== "planned-task" && currentTileType !== "start" && !shouldOpenCard)
        });

        // Create fake playerStatus for walkingAlgorithm
        const fakePlayerStatus = {
          data: [{
            location: restoredLocation,
            budget: this.state.player.budget,
            earnedValue: this.state.player.earnedValue,
            regular: this.state.player.resources.regular,
            senior: this.state.player.resources.executive,
            expensive: this.state.player.resources.expensive,
          }]
        };

        // If a card should be open, open it directly
        if (shouldOpenCard && cardType) {
          if (cardType === "Delay") {
            this.handleCard("Delay");
          } else if (cardType === "unplanned-task") {
            this.handleCard("unplanned-task");
          } else if (cardType === "Risk" || cardType === "Constraint") {
            this.handleCard(cardType);
          }
        } else if (currentTileType === "planned-task" && !isTileExecuted && lastActionCode !== 2) {
          // Planned task not executed - open ExecuteTaskPopUp
          this.setState({
            ExecuteTaskPopUpShow: true,
          });
          this.toggleDisableScreen(true);
        } else {
          // Use the same algorithm as new game - walkingAlgorithm with continueTurn=true
          // This will call handleProgress() which checks the tile and opens card if needed
          this.walkingAlgorithm(
            0,
            restoredLocation,
            fakePlayerStatus,
            true,  // continueTurn = true -> calls handleProgress()
            false
          );
        }
      });

      // Update project metadata if available
      if (projectData) {
        // Update project metadata only, not player state
        this.setState((prevState) => ({
          projectName: projectData.projectName,
          projectObjective: projectData.projectObjective,
          projectId: projectData.project_id,
          gameGoals: {
            value: projectData.value_goal,
            position: projectData.steps_goal,
            budget: projectData.budget_goal,
            steps_less_than: projectData.steps_goal_less_then,
            steps_more_than: projectData.steps_goal_more_then,
          },
          maximumUnplannedCards: projectData.maximumUnplannedCards,
          // Don't update player state - keep restored values
        }));

        // Update state with missing fields using projectData
        const nowDate = Date.now();
        this.setState((prevState) => ({
          ...prevState,
          projectArrayBeforeArrangement: filterTasksFromData(projectData).map(
            (task, index) => ({
              ...task,
              number: index + 1,
              completed: completedTaskIdsForProject.includes(task.id),
              relationships: filterRelationshipsFromData(task),
              isOrFlipped: task.isOrFlipped || false,
              id: index + 1,
              taskIdnumberInDB: task.id,
            })
          ),
          plannedTaskStack: Array(filterTasksFromData(projectData).length).fill(0),
          clientDateTime: new Intl.DateTimeFormat('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }).format(nowDate).replace(',', ''),
        }));

        // Set apiDate
        fetch("https://timeapi.io/api/Time/current/zone?timeZone=UTC")
          .then(response => {
            if (!response.ok) {
              throw new Error(`Network response was not ok ${response.statusText}`);
            }
            return response.json();
          })
          .then(data => {
            this.setState({
              apiDate: data.dateTime,
            });
          })
          .catch(error => {
            console.error("There was a problem with the fetch operation:", error);
          });

        // Set unixTimestampMS and serverDateTimeAtGameStart
        axios.get(`${fetchConfig.prefix}/game/currentUnixTimeStamp`)
          .then(res => {
            this.setState({
              unixTimestampMS: res.data.unixTimestampMS,
              serverDateTimeAtGameStart: res.data.serverDateTimeAtGameStart,
            });
          })
          .catch(err => {
            console.log("couldn't write the timestamp", err);
          });
      }

      const fullNameResult = await this.getPlayersFullName();
      await this.getPlayersAssistantInfo(userId, prevGameId);
      await this.getMainProjects();

      /**
       * this state basically says to open a trivia card everytime you go back to a gate,
       * it is set only in the state when you pass a gate and isn't saved anywhere so we check now if it's needed.
       * the getLastGateTileId returns the last gate num or false if you havn't passed any gates         *
       */
      // Verify location mapping - board array index should match location value
      console.log("📍 LOCATION VERIFICATION:");
      console.log("   Restored location from DB:", newLocation);
      console.log("   Board array length:", Board.length);
      console.log("   Board cell at location:", Board[newLocation] ? Board[newLocation].id : "OUT OF BOUNDS");
      if (Board[newLocation] && Board[newLocation].id !== undefined) {
        console.log("   Board cell ID matches location:", Board[newLocation].id === newLocation);
      }

      // console.log("sssss",this.getLastGateTileId());
      if (
        this.getLastGateTileId() ||
        Board[newLocation]?.gate?.passed === true ||
        Board[newLocation + 1]?.gate?.passed === true
      ) {
        this.getTriviaData();
        this.toggleTriviaNotOpenIfDelay(true);
      }

      // // handle tasks
      // const tasksArrangement = await axios.get(`${fetchConfig.prefix}/project/project_arranged`, {
      //     params: {
      //         gameId: prevGameId,
      //         userId,
      //     },
      // });

      // Note: startTurn and toggleProject are now called in setState callback
      // to ensure board is rendered first with all restored data

      // Update sidebar with correct game log counts after restoration
      // This ensures the sidebar shows correct task completion counts immediately
      if (this.state.player && this.state.player.gameId && this.state.player.id) {
        this.sideLogUpdate(false).catch(err => {
          console.error("Error updating sidebar log after restoration:", err);
        });
      }

      // handle restoring game for real
    } catch (error) {
      console.log(`this is an error from restore game function! ${error}`);
    }
  };
  findClosestValueInList(list, goal) {
    return list.reduce(function (prev, curr) {
      return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
    });
  }
  getClosestScreenWidth(width) {
    return this.findClosestValueInList([1280, 1366, 1600, 1920, 2560, 3200, 3840], width);
  }
  getClosestDPIList(zoom) {
    return this.findClosestValueInList([67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 225, 250, 300, 350], zoom);
  }

  getDPITranslationList(width) {  // sadly there's not much time to program it mathematically.
    let closestWidth = this.getClosestScreenWidth(width);

    console.log("found width", closestWidth, width);

    switch (closestWidth) {
      case 1280: return { 100: [67, 75, 80] };
      case 1366: return { 100: [67, 75, 80], 125: [50, 67, 75] };
      case 1600: return { 100: [75, 80, 90, 100], 125: [67, 75, 80], 150: [50, 67] };
      case 2560: return { 100: [125, 150, 175], 125: [90, 100, 110, 125], 150: [75, 80, 90, 100, 110], 175: [67, 75, 80, 90], 200: [67, 75, 80], 225: [50, 67, 75] };
      case 3200: return { 100: [150, 175, 200], 125: [125, 150, 175, 200], 150: [100, 110, 125, 150, 175, 200], 175: [80, 90, 100, 110, 125, 150, 175], 200: [75, 80, 90, 100, 110, 125, 150], 225: [67, 75, 80, 90, 100, 110, 125], 250: [67, 75, 80, 90, 100, 110], 300: [50, 67, 75, 80, 90] };
      case 3840: return { 100: [175, 200], 125: [150, 175, 200], 150: [125, 150, 175, 200], 175: [100, 110, 125, 150, 175, 200], 200: [90, 100, 110, 125, 150, 175, 200], 225: [75, 80, 90, 100, 110, 125, 150, 175], 250: [67, 75, 80, 90, 100, 110, 125], 300: [67, 75, 80, 90, 100, 110, 125], 350: [50, 67, 75, 80, 90, 100] };

      case 1920:  // default is FHD
      default:
        return { 75: [125], 90: [110], 100: [90, 100, 110, 125], 125: [75, 80, 90, 100], 150: [67, 75, 80], 175: [50, 67] }
    }
  }

  findClosestZoom(goal, byGoal, width) {
    const zoomsTranslate = this.getDPITranslationList(width);
    console.log("got translation list", zoomsTranslate, goal, byGoal);

    const desired = this.getClosestDPIList(goal)  // pick the closest DPI
    console.log("got desired", desired);
    // if (byGoal) {
    //   return [desired];
    // }
    return zoomsTranslate[desired];
  }
  checkForOversizedBrowser() {
    if (document.getElementById("assistant-messages")) {
      window.addEventListener('scroll', () => {
        if (!this.isElementInView()) {
          document.getElementById("assistant-messages").style.paddingTop = '20px';
        } else {
          document.getElementById("assistant-messages").style.paddingTop = '70px';
        }
      })
      if (this.state.resizePopUpShown == false) {
        return;
      }
      if (this.getBrowserName() == "Firefox") {
        this.checkForOversizedBrowserFirefox()
      } else {
        this.checkForOversizedBrowserChrome();
      }
    }
  }
  // // to be converted to a simple multiplication
  // if (window.devicePixelRatio * 100 >= 120) {  // edge case
  //   determinedZoom *= 0.9
  // }
  // if (window.devicePixelRatio * 100 >= 150) {  // edge case
  //   determinedZoom *= 0.9
  // }
  // if (window.devicePixelRatio * 100 >= 180) {  // edge case
  //   determinedZoom *= 0.9
  // }
  // if (window.devicePixelRatio * 100 >= 190) {  // edge case
  //   determinedZoom *= 0.9
  // }
  // if (window.devicePixelRatio * 100 >= 210) {  // edge case
  //   determinedZoom *= 1.1
  // }
  isInFirefoxZoomRange(width, zoom) {
    switch (width) {
      case 1280:
        return zoom < 67 ? -1 : zoom > 80 ? 1 : 0
      case 1366:
        return zoom < 62 ? -1 : zoom > 89 ? 1 : 0
      // return 62 < zoom < 89;
      case 1600:
        return zoom < 75 ? -1 : zoom > 101 ? 1 : 0
      // return 75 < zoom <= 101;
      case 2560:
        return zoom < 112 ? -1 : zoom > 160 ? 1 : 0
      // return 112 < zoom <= 160;
      case 3200:
        return zoom < 150 ? -1 : zoom > 250 ? 1 : 0
      // return 150 < zoom <= 250;
      case 3840:
        return zoom < 175 ? -1 : zoom > 300 ? 1 : 0
      // return 175 < zoom <= 300;
      case 1920:
      default:
        return zoom < 87 ? -1 : zoom > 120 ? 1 : 0
      // return 87 < zoom < 125;
    }
  }
  checkForOversizedBrowserFirefox() {
    let estimatedScreenWidth = screen.width * window.devicePixelRatio;
    let screenWidth = this.getClosestScreenWidth(estimatedScreenWidth);
    let determinedZoom = this.isInFirefoxZoomRange(screenWidth, window.devicePixelRatio * 100);
    console.log(estimatedScreenWidth, screenWidth, window.devicePixelRatio, determinedZoom);

    if (determinedZoom != 0) {
      console.log(window.devicePixelRatio * 100, determinedZoom);
      this.setResizePercentage(determinedZoom);  // closest to multiple of 10 
      this.setResizePopup(true);
    }
  }
  isElementInView() {
    const el = document.getElementById("main-game-header")
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  checkForOversizedBrowserChrome() {
    const desiredWidth = 1920, desiredZoom = 100;
    const overallZoom = window.devicePixelRatio * 100;
    const browserZoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
    const osZoomBase = (overallZoom / browserZoom);
    const screenWidth = window.screen.width * osZoomBase, osZoom = osZoomBase * 100;

    const zoomOut = (screenWidth / desiredWidth) * (desiredZoom / osZoom) * 100;
    const hasOsZoom = 95 > osZoom || osZoom > 105;
    console.log("zoom out is ", zoomOut, "with screen width", screenWidth, window.screen.width, window.devicePixelRatio, "base", osZoomBase, osZoom, hasOsZoom, browserZoom)
    const hasDesiredWidth = Math.abs(screenWidth - desiredWidth) < 100;
    const closestZoom = this.findClosestZoom(osZoom, !hasDesiredWidth, screenWidth);

    this.setOriginalPercentage(overallZoom);
    const closestMap = closestZoom?.map(e => e - browserZoom).filter(e => Math.abs(e) < 2)?.length;
    console.log(closestZoom, closestMap, browserZoom);
    if (closestMap > 0 || !closestZoom) {
      if (hasOsZoom) {
        this.setResizePopup(false);
      }
      console.log("browser zoom is the desired zoom", browserZoom, closestMap);  // no need to show message
      return;
    }

    this.setResizePercentage(closestZoom[0] - browserZoom)
    this.setResizePopup(true);
    console.log("have to fix to", closestZoom[0], closestZoom[0] - browserZoom)
    console.log(overallZoom, browserZoom, osZoom, zoomOut);
  }

  handleLogin = async (playerName, playerId, gameid = playerId, language, restoredState = null, canPlayUntil = null) => {
    console.log("should be working!", playerId);
    this.checkForOversizedBrowser();
    this.gameStartTime.current = performance.now();

    // If restoredState is provided, use it instead of fetching new data
    if (restoredState) {
      console.log("=== HANDLING RESTORED GAME STATE ===");
      console.log("Restored state provided:", restoredState);
      // Call handleRestoreGame with the provided state
      await this.handleRestoreGame(playerId, gameid, playerName, restoredState, canPlayUntil);
      i18n.changeLanguage(language);
      const fullNameResult = await this.getPlayersFullName();
      await this.getPlayersAssistantInfo(playerId, gameid);
      await this.getMainProjects();
      return;
    }

    await axios
      .get(
        `${fetchConfig.prefix}/project/done_tasks?gameId=${gameid}&userId=${playerId}`
      )
      .then(async (response) => {
        const completedTasks = response.data.map((current) => +current.value);
        await axios
          .get(fetchConfig.paths.tasks, {
            params: { userId: playerId, eventId: this.state.gameEventId, gameId: gameid },
          })
          .then(async ({ data }) => {
            const nowDate = Date.now();
            // Check if this is a restored game - if so, don't override player state or show modal
            // Use prevState to check flags that might have been set in handleRestoreGame
            await new Promise(resolve => this.setState((prevState) => {
              const isRestoredGame = prevState.isContinuedGame || prevState.isItAPreviousGame;

              // Only set modal if NOT a restored game
              const modalState = isRestoredGame ? {} : {
                modalTitle: "modals.welcome.info_title",
                modalButton: "modals.welcome.button2",
                modalInfoButton: "modals.welcome.button1",
                modalText: 'modals.welcome.info_text',
              };

              return {
                ...modalState,
                maximumUnplannedCards: data.maximumUnplannedCards,
                player: isRestoredGame ? {
                  // If restoring, keep existing player state completely - don't override anything
                  ...prevState.player,
                  id: playerId,
                  gameId: gameid,
                  name: playerName,
                  canPlayUntil: canPlayUntil || prevState.player.canPlayUntil || null,
                  // Don't override: position, budget, earnedValue, resources
                } : {
                  // If new game, set initial values
                  ...prevState.player,
                  id: playerId,
                  gameId: gameid,
                  name: playerName,
                  canPlayUntil: canPlayUntil || prevState.player.canPlayUntil || null,
                  position: 0,
                  earnedValue: 0,
                  budget: data.budget,
                  resources: {
                    regular: data.standard,
                    executive: data.senior,
                    expensive: data.executive,
                  },
                },
                tasks: filterTasksFromData(data).map((task, index) => ({
                  ...task,
                  number: index + 1,
                  completed: completedTasks.includes(task.id),
                  relationships: filterRelationshipsFromData(task),
                  isOrFlipped: task.isOrFlipped || false,
                  id: index + 1,
                  taskIdnumberInDB: task.id,
                })),
                projectArrayBeforeArrangement: filterTasksFromData(data).map(
                  (task, index) => ({
                    ...task,
                    number: index + 1,
                    completed: completedTasks.includes(task.id),
                    relationships: filterRelationshipsFromData(task),
                    isOrFlipped: task.isOrFlipped || false,
                    id: index + 1,
                    taskIdnumberInDB: task.id,
                  })
                ),
                plannedTaskStack: Array(filterTasksFromData(data).length).fill(0),
                tasksButOrTasksNotSaved: filterTasksFromData(data).map(
                  (task, index) => ({
                    ...task,
                    number: index + 1,
                    completed: completedTasks.includes(task.id),
                    relationships: filterRelationshipsFromData(task),
                    isOrFlipped: task.isOrFlipped || false,
                    id: index + 1,
                    taskIdnumberInDB: task.id,
                  })
                ),
                projectName: data.projectName,
                projectObjective: data.projectObjective,
                projectId: data.project_id,
                gameGoals: {
                  value: data.value_goal,
                  position: data.steps_goal,
                  budget: data.budget_goal,
                  steps_less_than: data.steps_goal_less_then,
                  steps_more_than: data.steps_goal_more_then,
                },
                clientDateTime: new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(nowDate).replace(',', ''),
              };
            }, resolve));
            fetch("https://timeapi.io/api/Time/current/zone?timeZone=UTC")
              .then(response => {
                if (!response.ok) {
                  throw new Error(`Network response was not ok ${response.statusText}`);
                }
                return response.json();
              })
              .then(data => {
                console.log("Current UTC Time:", data.dateTime);
                this.setState({
                  apiDate: data.dateTime,
                })
              })
              .catch(error => {
                console.error("There was a problem with the fetch operation:", error);
              });
            axios.get(
              `${fetchConfig.prefix}/game/currentUnixTimeStamp`
            ).then(res => {
              this.setState({
                unixTimestampMS: res.data.unixTimestampMS,
                serverDateTimeAtGameStart: res.data.serverDateTimeAtGameStart,
              })
            }).catch(err => {
              console.log("couldn't write the timestamp", err);
            });
          });
        i18n.changeLanguage(language);
        // playerData = this.state.player;
      })
      .catch((error) => {
        console.log("error: ", error);
      });

    const fullNameResult = await this.getPlayersFullName();
    await this.getPlayersAssistantInfo(playerId, gameid);
    await this.getMainProjects();
    console.log("state", this.state.player);
  };

  getPlayersAssistantInfo = async (userId, gameId) => {
    let result;
    try {
      result = await axios.get(
        `${fetchConfig.prefix}/auth/assistantMode?userId=${userId}&gameId=${gameId}`
      );
      console.log("yoniii2", result.data);
      this.setState((prevState) => ({
        player: {
          ...prevState.player,
          assistantMode: result.data.isAssistantMode,
        },
        assistantJson: JSON.parse(result.data.assistantJsonFromDB),
      }));
    } catch (e) {
      console.log(e);
    }
  };
  getMainProjects = async () => {
    let result;
    try {
      result = await axios.get(
        `${fetchConfig.prefix}/game/getMainProjects`
      );
      console.log("getMainProjects", result.data);
      this.setState({
        allMainProjects: result.data
      });
    } catch (e) {
      console.log(e);
    }
  };

  getArrayOfAccountsByEmail = async (emailInput) => {
    let result;
    try {
      result = await axios.get(`${fetchConfig.prefix}/auth/whoArePlayersAccounts?emailInput=${encodeURIComponent(emailInput)}`);
      return result.data;
    } catch (e) {
      console.log(e);
    }
  };

  getPlayersFullName = async () => {
    let result;
    try {
      const data = {
        playerEmail: this.state.playerEmail,
      };
      result = await axios.post(`${fetchConfig.prefix}/game/fullName`, data);
      const playersFullName = result?.data?.[0]?.fullname || "";
      this.setState((prevState) => ({
        player: {
          ...prevState.player,
          fullName: playersFullName,
          name: playersFullName || prevState.player.name,
        },
      }));
      return result;
    } catch (e) {
      console.log(e);
    }
  };

  endTurn = async () => {
    // ADD BOARD EXECUTED HERE
    const currentTileType = Board[this.state.player.position];

    if (
      (currentTileType === "gate" && this.state.secondGateControlNeeded) ||
      // (this.state.player.position === 24 && this.state.secondGateControlNeeded) ||
      // (this.state.player.position === 36 && this.state.secondGateControlNeeded) ||
      this.state.player.position >= Board.length ||
      this.state.endGameModal
    ) {
      this.setState((prev) => ({
        // prevent stucking on tile if you allready pasted the gate tile.
        secondGateControlNeeded: false,
        taskToggle: false,
      }));
      this.SetEndGameModal();
    } else {
      this.setState((prev) => ({
        modalTitle: "modals.end_of_turn.info_title",
        modalText: "modals.end_of_turn.info_text",
        modalButton: "modals.end_of_turn.button2",
        modalInfoButton: "modals.end_of_turn.button1",
        modalToggle: true,
      }), () => {
        // FIX: Force save now that modal is open
        const gameRunTimeSeconds = `0${Math.floor(this.state.timeSeconds % 60)}`.slice(-2);
        const gameRunTimeMinutes = `0${Math.floor((this.state.timeSeconds / 60) % 60)}`.slice(-2);
        const gameRunTimeHours = `0${Math.floor((this.state.timeSeconds / 3600) % 60)}`.slice(-2);
        const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;

        this.saveGame({
          tasks: [
            this.state.tasks,
            this.state.orTasks,
            this.state.generalTasks,
          ],
          unplannedTasks: this.state.unplannedCards,
          board: Board,
          localTimer: gameRunTime,
        });
      });
      this.toggleDisableScreen(true);
      this.handleTurnNumber(this.state.turnNumber + 1);
      this.turnEndsInGateToggle(false);
    }
  };

  startTurn = async (isAfterPause = false) => {
    this.isPlanning(false);
    this.toggleDisableScreen(true);
    let result;
    // const { turnNumber } = this.state;
    // this.state.tasksTimer = this.state.timeSeconds;
    this.setTasksTimer();
    try {
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        isAfterPause,
        isItAPreviousGame: this.state.isItAPreviousGame,
      };
      result = await axios.post(`${fetchConfig.prefix}/game/start_turn`, data);
    } catch (e) {
      console.log(e);
    }
    if (!this.state.hasTurnStarted) {
      const baselineTaskOrder = (this.state.tasks || []).map(
        (task) => task.number
      );
      const baselineFlippedSet = (this.state.tasks || [])
        .filter((task) => task.isOrFlipped)
        .map((task) => task.number);
      this.setState({
        hasTurnStarted: true,
        baselineTaskOrder,
        baselineFlippedSet,
        reorderActionsSinceBaseline: 0,
        draggedTaskIdsSinceBaseline: [],
      });
    }
    // this.isPaused(false);
    // in the first turn of a previous game that starts over, we dont want to advance the player in the DB
    if (this.state.isItAPreviousGame) {
      this.setState({
        isItAPreviousGame: false,
      });
    }
    this.walkingAlgorithm(
      // isAfterPause ? 0 : 1,
      1,
      this.state.player.position,
      result,
      true,
      isAfterPause
    );
    const cardType = Board[this.state.player.position].type;
    const cardTypeOfNextTurn = Board[this.state.player.position + 1]?.type;

    if (cardTypeOfNextTurn === undefined) {
      // FIXME: Check if fix is working
      this.endGameFunction(true, 0, 0, "reached the finish tile");
    }
    // console.log('here cardtype', cardType, 'cardtypenextturn', cardTypeOfNextTurn, 'is zero steps', this.state.isZeroSteps)
    if (
      (cardTypeOfNextTurn == "planned-task" && this.state.isZeroSteps) ||
      // && this.state.player.position !== 1
      ((cardType == "mile-stone" || cardType == "gate") &&
        cardTypeOfNextTurn == "planned-task")
    ) {
      setTimeout(() => this.toggleProject(3), 1330);
      //   setTimeout(() => this.toggleProject(0), 1350);
      // setTimeout(() => this.SoundPlay(toggleProjectSound), 1350);
      this.setState({
        isZeroSteps: false,
      });
    }
  };

  additionalBudget = async () => {
    this.sideLogUpdate(false);
    this.SoundPlay(moneySound);
    let result;
    const { turnNumber } = this.state;
    try {
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        isPaused: this.state.showIsPaused,
        turnNumber,
      };
      result = await axios.post(
        `${fetchConfig.prefix}/game/additional_budget`,
        data
      );
    } catch (e) {
      console.log(e);
    }
    if (this.state.showIsPaused) {
      this.commentAdditionalBudget(
        result.data.budget - this.state.player.budget,
        result.data.rowId
      );
    } else ++this.state.budgetRequest.count; // change to the right variable.
    this.state.budgetRequest.budget =
      result.data.budget - this.state.player.budget;
    // TODO:
    //  implement comment per budget count and connect to the right assingment row id. < New report function >
    this.setState((prevState) => ({
      player: {
        ...prevState.player,
        budget: result.data.budget,
      },
    }));
    if (Board[this.state.player.position].type === 'gate') {
      this.setAskedForBudgetAtGate(true);
    }
    // this.onlyShowModal(
    //     'Additional Budget and Resources',
    //     'If the budget allocated to your project is not enough you can get an extra budget and this will be recorded in your project log.',
    //     'Get Additional Budget',
    // );
  };

  sendCardsToServer = async (
    cardsData,
    stage,
    playerId,
    gameid = playerId,
    continuePlaying = false,
    areChangesMade
  ) => {
    const taskArray = cardsData.map((current) => current.number);
    const orTaskArray = Array(taskArray.length).fill(0);
    // Must use visual slot index (matches taskArray order). After drag/swap, card `.id`
    // often still reflects old slot (react-grid-dnd swap does not rewrite ids) — using
    // current.id - 1 misaligns OR flip flags and inflates flipActions / wrong flipped tasks.
    cardsData.forEach((current, slotIndex) => {
      for (let i = 0; i < this.state.orTasks.length; i++) {
        if (current.number == this.state.orTasks[i]) {
          orTaskArray[slotIndex]++;
        }
      }
    });
    const currentTaskOrder = [...taskArray];
    const currentFlippedSet = currentTaskOrder.filter(
      (_taskNumber, index) => orTaskArray[index] > 0
    );

    const hasTrackingBaseline =
      this.state.hasTurnStarted &&
      this.state.baselineTaskOrder.length > 0;
    const baselineTaskOrder = hasTrackingBaseline
      ? this.state.baselineTaskOrder
      : currentTaskOrder;
    const baselineFlippedSet = hasTrackingBaseline
      ? this.state.baselineFlippedSet
      : currentFlippedSet;
    const baselineFlipSetLookup = new Set(baselineFlippedSet);
    const currentFlipSetLookup = new Set(currentFlippedSet);
    let flipActions = 0;
    for (const taskNumber of currentFlipSetLookup) {
      if (!baselineFlipSetLookup.has(taskNumber)) flipActions++;
    }
    for (const taskNumber of baselineFlipSetLookup) {
      if (!currentFlipSetLookup.has(taskNumber)) flipActions++;
    }
    let reorderActions = 0;
    if (this.state.hasTurnStarted && this.state.manualReorderTouched) {
      const baselineIndexByTaskNumber = {};
      baselineTaskOrder.forEach((taskNum, idx) => {
        baselineIndexByTaskNumber[taskNum] = idx;
      });
      const currentIndexByTaskNumber = {};
      currentTaskOrder.forEach((taskNum, idx) => {
        currentIndexByTaskNumber[taskNum] = idx;
      });
      for (const taskNum of this.state.draggedTaskIdsSinceBaseline) {
        const bi = baselineIndexByTaskNumber[taskNum];
        const ci = currentIndexByTaskNumber[taskNum];
        if (
          bi !== undefined &&
          ci !== undefined &&
          bi !== ci
        ) {
          reorderActions++;
        }
      }
    }
    const arrangementActionCount = this.state.hasTurnStarted
      ? reorderActions + flipActions
      : 0;
    const arrangementActionBreakdown = {
      reorderActions,
      flipActions,
    };
    const areChangesMadeForSave = arrangementActionCount > 0;
    console.log(
      "current task: ",
      cardsData.map((current) => current.number),
      this.state.showIsPaused,
      orTaskArray
    );
    // for (let i = 0; i < this.state.orTasks.length; i++) {  // convert this array to a counter array
    //     orTaskArray[this.state.orTasks[i] - 1]++;         // input [1, 2 ,3] -> [1, 1, 1, 0, 0, 0, 0.....]
    // }

    const data = {
      gameId: gameid,
      userId: playerId,
      taskArray,
      orTaskArray,
      isPaused:
        this.state.player.position == 0 ? true : this.state.showIsPaused,
      areChangesMade: areChangesMadeForSave,
      arrangementActionCount,
      arrangementActionBreakdown,
    };
    // Browser console: avoid implying report count before first turn-start (position 0 pre-play).
    // Authoritative “counted in report” log is server-side after insertArrangeProject checks code=0 exists.
    if (areChangesMadeForSave && this.state.player.position !== 0) {
      const expectedLogDecision = data.isPaused ? 3 : 2;
      console.log("[PMZ project/arranged] sending changes flag (report counts server-side)", {
        areChangesMade: data.areChangesMade,
        isPaused: data.isPaused,
        expectedLogDecision,
        gameId: data.gameId,
        arrangementActionCount: data.arrangementActionCount,
        arrangementActionBreakdown: data.arrangementActionBreakdown,
      });
    }
    await axios
      .post(`${fetchConfig.prefix}/project/arranged`, data)
      .finally(() =>
        this.setState({ tasks: cardsData, tasksButOrTasksNotSaved: cardsData })
      );
    if (continuePlaying) {
      this.setState({ showIsPaused: false, isDisabledPMTasks: false });
    }
    this.setState({
      changesMade: false,
      reorderActionsSinceBaseline: 0,
      manualReorderTouched: false,
      draggedTaskIdsSinceBaseline: [],
      baselineTaskOrder: currentTaskOrder,
      baselineFlippedSet: currentFlippedSet,
    });
  };

  // get data of trivia from server:
  getTriviaData = async () => {
    axios
      .get(
        `${fetchConfig.prefix}/game/get_trivia_questions?gameId=${this.state.player.gameId}&userId=${this.state.player.id}`
      )
      .then((response) => {
        // const triviaData = response.data.map(current => +current.value);
        const triviaData = response.data;
        this.setState({ triviaValues: triviaData });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  exchangeResources = async (
    wishRegular,
    wishSenior,
    wishExpensive,
    deductValue = true,
    resourceObject
  ) => {
    let result;
    const { turnNumber, tasksTimer } = this.state;
    const timeSeconds = this.timeSeconds.current;
    const actionTime = timeSeconds - tasksTimer;
    console.log("our action time", actionTime);
    try {
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        desiredRegular: Number.isNaN(wishRegular) ? 0 : wishRegular,
        desiredSenior: Number.isNaN(wishSenior) ? 0 : wishSenior,
        desiredExpensive: Number.isNaN(wishExpensive) ? 0 : wishExpensive,
        halfPrice: this.state.showIsPaused,
        turnNumber,
        isPaused: this.state.showIsPaused,
        deductValue,
        boughtResources: resourceObject,
        timer: actionTime,
      };

      result = await axios.post(
        `${fetchConfig.prefix}/game/exchange_resources`,
        data
      );
    } catch (e) {
      console.log(e);
    }
    if (result.data === "insufficient funds") {
      if (!this.state.modalToggle) {
        this.onlyShowModal("Cannot execute task", result.data, "OK, Got it");
      }
    } else {
      if (Board[this.state.player.position].type === 'gate') {
        this.setAskedForResourcesAtGate(true);
      }
      if (!this.state.showIsPaused) {
        ++this.state.resourcesForDoublePrice;
      }
      console.log(result.data)
      await this.resourcesForDoublePriceCommentInit(result.data[0].taskRowId);
      this.setState((prevState) => ({
        player: {
          ...prevState.player,
          budget: result.data[0].budget,
          resources: {
            regular: result.data[0].regular,
            executive: result.data[0].senior,
            expensive: result.data[0].expensive,
          },
        },
      }));
      this.sideLogUpdate(false, null, null, false); // update log on successfull purchase
    }
    // this.onlyShowModal(
    //     'Additional budget added',
    //     'please notice it will effect your project report',
    //     'understood',
    // );
  };

  exchangeResourcesTest = async (
    wishRegular,
    wishSenior,
    wishExpensive,
    budgetDifference
  ) => {
    const { turnNumber, tasksTimer } = this.state;
    const timeSeconds = this.timeSeconds.current;
    const actionTime = timeSeconds - tasksTimer;
    console.log("our action time", actionTime);
    let result;
    try {
      const data = {
        gameId: this.state.player.gameId,
        userId: this.state.player.id,
        desiredRegular: this.state.player.resources.regular,
        desiredSenior: this.state.player.resources.executive,
        desiredExpensive: this.state.player.resources.expensive,
        halfPrice: this.state.showIsPaused,
      };

      result = await axios.post(
        `${fetchConfig.prefix}/game/exchange_resources`,
        data
      );
    } catch (e) {
      console.log(e);
    }
    if (result.data === "insufficient funds") {
      if (!this.state.modalToggle) {
        this.onlyShowModal("Cannot execute task", result.data, "OK, Got it");
      }
    } else {
      console.log(result.data)
      await this.resourcesForDoublePriceCommentInit(result.data[0].taskRowId);
      this.setState((prevState) => ({
        player: {
          ...prevState.player,
          budget: result.data[0].budget + budgetDifference,
          resources: {
            regular: result.data[0].regular + wishRegular,
            executive: result.data[0].senior + wishSenior,
            expensive: result.data[0].expensive + wishExpensive,
          },
        },
      }));
    }
    // this.onlyShowModal(
    //     'Additional budget added',
    //     'please notice it will effect your project report',
    //     'understood',
    // );
  };

  commentResourcesAtDoublePrice = async (taskRowId) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent:
        "Resources purchased ad hoc for double their normal value",
      playerPosition: this.state.player.position,
      turnNumber,
      taskRowId,
    };
    axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));
  };

  commentChangedSelection = async (taskRowId) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent: "Changed selection of choice task in turn",
      playerPosition: this.state.player.position,
      taskRowId,
    };
    // setTimeout(() => {
    const commentIt = await axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));

    // }, 750);
  };

  commentTaskExecutedOutOfOrder = async (taskRowId) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent: "Task executed out of order",
      playerPosition: this.state.player.position,
      taskRowId,
    };
    // setTimeout(() => {
    const commentIt = await axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));

    // }, 750);
  };
  commentTaskOnPosition = async (taskRowId, description) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent: description,
      playerPosition: this.state.player.position,
      taskRowId,
    };
    // setTimeout(() => {
    const commentIt = await axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));

    // }, 750);
  };

  commentOrTaskExecuted = async (taskRowId) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent:
        "Alternative task selected (lower cost, less resources, lower value, faster progress)",
      playerPosition: this.state.player.position,
      turnNumber,
      taskRowId,
    };
    // setTimeout(() => {
    const commentIt = await axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));

    // }, 750);
  };
  commentOnRedoTask = async (taskRowId) => {
    const baseUrl = `${fetchConfig.prefix}/game/commentit`;
    const { turnNumber } = this.state;
    const datab = {
      gameId: this.state.player.gameId,
      userId: this.state.player.id,
      commentContent: "Task performed a second time",
      playerPosition: this.state.player.position,
      turnNumber,
      taskRowId,
    };

    const commentIt = await axios
      .get(
        `${baseUrl}?gameId=${datab.gameId}&userId=${datab.userId
        }&comment=${encodeURI(datab.commentContent)}&playerPosition=${datab.playerPosition
        }&taskRowId=${datab.taskRowId}`,
        datab
      )
      .catch((error) => console.log(error));
  };

  getPlayersGrade = async () => {
    let result;
    try {
      result = await axios.get(`${fetchConfig.prefix}/game/get_player_grade`, {
        params: {
          gameId: this.state.player.gameId,
          userId: this.state.player.id,
          project: 1,
        },
      });
    } catch (e) {
      console.log(e);
    }
    return result.data;
  };

  timerFormat = async (seconds) => {
    const gameRunTimeSeconds = `0${Math.floor(seconds % 60)}`.slice(-2);
    const gameRunTimeMinutes = `0${Math.floor((seconds / 60) % 60)}`.slice(-2);
    const gameRunTimeHours = `0${Math.floor((seconds / 3600) % 60)}`.slice(-2);

    const timeFormat = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;

    return timeFormat;
  };

  endGameFunction = async (
    isItTheCurrentGame,
    userUId,
    gameUId,
    endGameReason,
    isRestartGame = false
  ) => {
    let prevGameData;

    const gameRunTime = await this.timerFormat(
      (
        (performance.now() -
          this.gameStartTime.current -
          this.totalTimeoutDuration.current) /
        1000
      ).toFixed(0)
    );
    // const planningTimer = await this.timerFormat(this.state.pauseForPlanningTimer);
    const planningNetMs =
      this.preGamePlanningNetMsRef.current != null
        ? this.preGamePlanningNetMsRef.current
        : Math.max(
            0,
            this.totalPlanningTimeRef.current -
              this.totalTimoutInPlanningDuration.current,
          );
    const planningTimer = await this.timerFormat(
      (planningNetMs / 1000).toFixed(0),
    );
    console.log("Timers: ", gameRunTime, planningTimer);
    // let grade = 0;
    let result;
    let secondResult;
    if (isItTheCurrentGame) {
      try {
        secondResult = await axios.get(`${fetchConfig.prefix}/game/end_game`, {
          params: {
            reason: endGameReason,
            timer: gameRunTime,
            gameId: this.state.player.gameId,
            userId: this.state.player.id,
            planningTimer,
          },
        });
      } catch (e) {
        console.error("error in fetching end_game request, the error is: ", e);
      }
      // try {
      //     result = await axios.get(`${fetchConfig.prefix}/game/user_report`, {
      //         params: {
      //             gameId: this.state.player.gameId,
      //             userId: this.state.player.id,
      //         },
      //     });
      // } catch (e) {
      //     console.log("error in fetching user_report request, the error is: ", e);
      // }
      // const gameLogLastUpdate = await this.gameLogFetch()
      // // grade = await this.getPlayersGrade();
      // this.setState({
      //     gameLog: gameLogLastUpdate,
      // })
      // console.log("Console Log For Develop Check gameLog : ", gameLogLastUpdate);
    } else {
      this.sideLogUpdate(true, userUId, gameUId);
      // try {
      //     result = await axios.get(`${fetchConfig.prefix}/game/user_report`, {
      //         params: {
      //             gameId: gameUId,
      //             userId: userUId,
      //         },
      //     });
      // } catch (e) {
      //     console.log("error in fetching user_report request, the error is: ", e);
      // }
      const obj = {
        prevGameId: gameUId,
        userId: userUId,
      };
      const gameLog = await this.getPlayerLog({
        gameAndUserIdObj: obj,
        lastPlayData: false,
        needssummaryReport: true,
      });
      prevGameData = [];
      Object.keys(gameLog.data).map((current, index) => {
        prevGameData.push(gameLog.data[current]);
      });
    }
    if (isItTheCurrentGame) {
      prevGameData = [...this.state.gameLog];
    }
    // check for an "empty game" (game when player is in position 0/1 and he didn't do any tasks)
    console.log("A", this.state.player.position == 0, this.state.generalTasks, this.state.generalTasks.reduce((sum, x) => sum + x), this.state.tasks, this.state.tasks.filter(x => x.completed).length)
    if ((this.state.player.position == 0 || this.state.player.position == 1) && this.state.generalTasks.reduce((sum, x) => sum + x) == 0 && this.state.tasks.filter(x => x.completed).length == 0) {
      // window.location.reload(true);
      this.setState({
        value: {
          scale: 1,
          translation: { x: 0, y: 0 },
        },
        socketIO: null,
        isMaintanenceModeActive: false,
        openGeneralPmTasks: false,
        gameEventId: 0,
        idlePopUp: false,
        executeGPMTOnMilestone: false,
        firstGateTileId: 0,
        firstMilestoneTileId: 0,
        firstMileStonePassed: true,
        tasksTimer: null,
        gameLogLoading: false,
        needsToDelayExecutePopup: false,
        error: null,
        errorInfo: null,
        sentErrorLog: false,
        showNetworkErrorPopUp: false,
        showBrowserErrorPopUp: false,
        showRestoreGamePopup: false,
        budgetRequest: { count: 0, budget: 2000 },
        resourcesForDoublePrice: 0,
        isContinuedGame: false, // a flag to check if this is a previous game that we are resuming
        prevGameId: null,
        tempUserId: null, // used to temporarily hold the user id before actually logging in
        tempPlayerName: null, // used to temporarily hold player display name before actually logging in
        modalToggle: true,
        playerEmail: "",
        modalTitle: "modals.welcome.info_title",
        modalText: ``,
        modalButton: "modals.welcome.button2",
        modalInfoButton: "modals.welcome.button1",
        showExperationModal: false,
        taskToggle: false,
        resourceToggle: false,
        toggleToolTip: false,
        gameLogToggle: false,
        showTrivia: false,
        generalInfoShow: false,
        isStartTurnMessageShowing: false,
        gameDefinitionsShow: false,
        projectNeedToBeDisabled: false,
        MilestoneModalShow: false,
        delayCardIsTakenInGateControl: true,
        gateTextNeedToChange: false,
        gateSecondControlShow: false,
        secondGateControlNeeded: false,
        openTriviaWhenDelayTaken: false,
        amountResourcesExpensive: [0, 0, 0],
        playerTotalValue: [],
        playerRemainignBudget: [],
        playerRegularResources: [],
        playerSeniorResources: [],
        playerExpensiveResources: [],
        playerTurnNumber: [],
        turnNumber: 1,
        BeginTurnPopUpShow: false,
        AfterMilestonePopUpShow: false,
        afterMilestonChecked: false,
        beginTurnChecked: false,
        tutorialShow: false,
        helpShow: false,
        gameFirstPopUp: false,
        infoTitle: "Gate Info",
        definitionsTitle: "Table",
        tutorialTitle: "Tutorial",
        infoParagraph:
          "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis",
        projectStage: 0,
        card: {
          cardToggle: false,
        },
        milestone: [false, false, false, false, false, false, false],
        turnNeedsToEndInGate: false,
        gate: [false, false, false],
        toggleGate: false,
        gateTasks: [],
        showIsPaused: false,
        disableAdditionalBudgetPopUpSideBar: false,
        generalTasks: [0, 0, 0, 0, 0],
        ExecuteTaskPopUpShow: false,
        milestonefirstpass: true,
        milestonePopUp: [true, true, true, true, true, true, true, true, true],
        NotEnoughResourcesPopUpShow: false,
        checkedPmCount: 0,
        StartGamePopUpShow: false,
        ProjectScopeBackButtonDisabled: false,
        player: {
          id: 0,
          gameId: 0,
          fullName: "",
          canPlayUntil: null,
          name: "", // Temporary, until the login will work
          position: 0,
          budget: 0,
          earnedValue: 0,
          resources: {
            regular: 0,
            executive: 0,
            expensive: 0,
          },
          assistantMode: false,
        },
        playerDifAnimation: {
          budget: 0,
          earnedValue: 0,
          resources: {
            regular: 0,
            executive: 0,
            expensive: 0,
          },
        },
        prevPlayerDifAnimation: {
          budget: 0,
          earnedValue: 0,
          resources: {
            regular: 0,
            executive: 0,
            expensive: 0,
          },
        },
        tasksByNumber: [],
        tasks: [],
        tasksButOrTasksNotSaved: [],
        projectName: "",
        projectObjective: "",
        projectId: 1,
        mapImage: null,
        orTasks: [],
        logSideBar: {
          Constraint: 0,
          Delay: 0,
          Gate: 0,
          General: 0,
          Milestone: 0,
          Planned: 0,
          Risk: 0,
          Unplanned: 0,
        },
        log: [],
        gameLog: [],
        showReport: false,
        shortReport: {
          numOfPlanChanges: 0,
          percentOfPlanning: 27,
          returnPlanTime: "00:00:56",
          actionCounter: {
            Unplanned: 1,
            Risk: 2,
            Constraint: 0,
            Delay: 0,
            gateTasks: 1,
            orTasks: 0,
          },
          remainResources: {
            regular: 7,
            senior: 999, // do not change this number
            expensive: 4,
          },
          remainBudget: 6100,
          addBudget: 6000,
          doubleCost: 600,
          totalResources: 3900,
          totalBudget: 5900,
          totalValue: 11600,
          endGamePosition: Board.length - 1,
          returnGameTIme: "00:03:27",
          realLocation: 0,
          tasksCompleted: 0,
          localTime: "00:02:38",
        },
        playerStatusChange: {
          earnedValue: 0,
          stepsDifference: 0,
          earnedValueDifference: 0,
          priceDifference: 0,
          regular: 0,
          executive: 0,
          expensive: 0,
        },
        triviaValues: [],
        unplannedCards: [],
        maximumUnplannedCards: 0,
        explanationCard: false,
        isDisabledPMTasks: false,
        gateNumber: 1,
        gameDefinitionsStage: 0,
        cardState: false,
        newTurn: false,
        endGameModal: false,
        onePlanedTaskLeft: false,
        dontShowNextCard: false,
        resizePopUpShown: null,
        isZeroSteps: false,
        positionGameLog: [1],
        alreadyBeenAtPositionOne: false,
        isPlanning: false,
        gatePassed: [false, false, false],
        milestonePassed: [false, false, false, false, false, false, false, false],
        updatedCards: [],
        animationVars: {
          isAnimationNeeded: false,
          cameFromSideBar: false,
        },
        prevReportPopUp: false,
        prevReports: [],
        prevGameIdOfSpecificUser: [],
        isItAPreviousReport: false,
        downloadReport: false,
        gameStartTime: new Date().toLocaleString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
        gameStartDate: new Date().toLocaleDateString([], {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        }),
        clearTimer: true,
        needsToStartNewGame: false,
        resetTimer: true,
        keepShowingBeginTurnPopUp: true,
        // timeSeconds: 0,
        isGamePaused: false,
        gameGoals: {
          value: 0,
          position: 0,
          budget: 0,
          steps_more_than: 0,
          steps_less_than: 0,
        },
        finalGrade: {},
        isItAPreviousGame: false,
        isGameGotRestarted: false,
        projectArrayBeforeArrangement: [],
        saveOnGate: false,
        plannedTaskExecutedIndex: 0,
        generalIndexCounter: 0,
        changesMade: false, // checking if changes has been made at project arrangement.
        hasTurnStarted: false,
        baselineTaskOrder: [],
        baselineFlippedSet: [],
        reorderActionsSinceBaseline: 0,
        manualReorderTouched: false,
        draggedTaskIdsSinceBaseline: [],
        previousReportsGameLogData: [],
        gameUIdOfPrevGame: 0,
        disableScreen: false, // global variable that every time there is no reason to click the sidebar it will be true.
        plannedTaskStack: [], // planned tasks that didn't got executed on there time will be inserted to an queue
        completedTasksArray: [],
        orTasksAtPause: [], // for the alternative task change comment
        isConference: false,
        sideLogAnimation: {
          plannedTask: false,
          unplanned: false,
          constraint: false,
          risk: false,
          delay: false,
          milestone: false,
          gate: false,
        },
        isGameStartedForTheFirstTime: false,
        keepShowingIdlePopUp: true,
        isCardCountDownActive: false,
        totalUsed: {
          budgetUsed: 0,
          regular: 0,
          senior: 0,
          expensive: 0,
        },
        needToOpenProjectSheetAfterMilestonePopUp: true,
        assistantJson: "",
        movedToLessValueAtDelayCard: false,
        pressedOkGotIt: false,
        gateRestartCounter: 0,
        movedTaskBeforePredecessorCount: false,
        selectedUnPlannedTask: 0,
        isChoosingFromDelayedCard: false,
        goToStartFromDelay: false,
        gateTestResult: '',
        oneLessStep: false,
        offeredToGoBack: 0,
        offeredToGoToStart: 0,
        oneLessStepTurn: null,
        performedLateTasksAtGateAndAskedFor: {
          budget: false,
          resources: false
        },
        showChangeProjectPopUp: false,
        allMainProjects: [],
        originalPercentage: 100,
      }) // reset state
    } else {
      this.setState((prevState) => ({
        // finalGrade: grade,
        showReport: !isRestartGame,
        // shortReport: result.data,
        isItAPreviousReport: !isItTheCurrentGame,
        previousReportsGameLogData: prevGameData,
        gameLog: prevGameData,
      }));
    }
  };

  toggleReport = (status) => {
    this.setState((prevState) => ({
      showReport: status,
    }));
  };

  logout = () => {
    this.resetGameRuntime();
    this.setState((prevState) => ({
      ...this.getInitialState(),
      socketIO: prevState.socketIO,
      gameEventId: prevState.gameEventId,
      languagesList: prevState.languagesList,
      currentLanguage: prevState.currentLanguage,
      shortCutLanguage: prevState.shortCutLanguage,
      allMainProjects: prevState.allMainProjects,
      isMaintanenceModeActive: prevState.isMaintanenceModeActive,
    }));
  };

  toggleMaintanenceMode = (status) => {
    this.setState({
      isMaintanenceModeActive: status,
    });
  };

  handleLoginPage = () => {
    if (window.innerWidth <= 800) {
      return (
        <MobileMessage />
      );

    }

    if (this.state.isMaintanenceModeActive) {
      return (
        <MaintanenceMode
          toggleMaintanenceMode={this.toggleMaintanenceMode}
        />
      );
    }

    if (this.state.isConference) {
      return (
        <>Conference State is Deprecated</>
      );
    }
    return (
      <>
        {this.state.showExperationModal && (
          <div style={{
            position: "absolute",
            height: '100vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <Modal
              styling={{
                position: "absolute",
                top: "50%",
                left: "50%",
              }}
              modalTitle={this.state.modalTitle}
              modalText={this.state.modalText}
              modalButton={this.state.modalButton}
              modalInfoButton={this.state.modalInfoButton}
              show={this.state.showExperationModal}
              toggleShow={this.toggleExperationModal}
            />
          </div>
        )}
        <div id="resize_container_measurement" style={{ width: '100vw', zIndex: '-1', position: 'absolute', top: '-9999999px' }}></div>
        <NewLoginPage
          onlyShowModal={this.onlyShowModal}
          toggleModal={this.toggleExperationModal}
          handleLogin={this.handleLogin}
          setPlayerEmail={this.setPlayerEmail}
          playerEmail={this.state.playerEmail}
          askRestoreGame={this.askRestoreGame}
          getArrayOfAccountsByEmail={this.getArrayOfAccountsByEmail}
          gameEventId={this.state.gameEventId}
          gameCreationDateTime={{ creationTime: this.state.gameStartTime, creationDate: this.state.gameStartDate }}
          checkZoomMessage={() => this.checkForOversizedBrowser()}
          languagesList={this.state.languagesList}
          currentLanguage={this.state.currentLanguage}
          setCurrentLanguage={this.setCurrentLanguage}
          shortCutLanguage={this.state.shortCutLanguage}
          setInstructorAndAccountId={this.setInstructorAndAccountId}
        ></NewLoginPage>
        {this.state.resizePopUpShown && <ResizePopUp
          browserName={this.getBrowserName()}
          setResizePopup={(state) => this.setResizePopup(state)}
          resizePopUpShown={this.state.resizePopUpShown}
          percentage={this.state.resizePercentage}
          originalPercentage={this.state.originalPercentage}
        />}
      </>
    );
  };

  render() {
    let errorData;
    if (this.state.errorInfo) {
      errorData = {
        gameId: this.state.gameId,
        userId: this.state.userId,
        error: this.state.error.toString(),
        state: JSON.stringify(this.state, function () {  // to avoid "cyclical object" error
          const ancestors = [];
          return function (key, value) {
            if (typeof value !== "object" || value === null) {
              return value;
            }
            // `this` is the object that value is contained in,
            // i.e., its direct parent.
            while (ancestors.length > 0 && ancestors.at(-1) !== this) {
              ancestors.pop();
            }
            if (ancestors.includes(value)) {
              return "[Circular]";
            }
            ancestors.push(value);
            return value;
          };
        }
        ),
      };
      if (!this.state.sentErrorLog) {
        axios.post(`${fetchConfig.prefix}/error/errorLog`, errorData);
        this.setState({
          sentErrorLog: true,
        });
      }
      // Error path
      return (
        <div>
          <h1>Something went wrong.</h1>
          <div style={{ color: "red" }}>
            <h2>{this.state.error && this.state.error.toString()}</h2>
            <br />
            <h4>{this.state.errorInfo.componentStack}</h4>
          </div>
          <br />
          <h1>Please contact an administrator.</h1>
          <h2>Reload the page to restart the game.</h2>
        </div>
      );
    }
    Howler.volume(1.0);
    const position = {
      top: 70,
      left: 25,
    };
    const { colors } = themeStyles;
    const tileTypes = {
      "planned-task": colors.darkGreen,
      "unplanned-task": colors.darkGreen,
      Risk: colors.red,
      "mile-stone": colors.black,
      Constraint: colors.orange,
      gate: colors.darkGray,
      finish: colors.purple,
    };
    const {
      player,
      card,
      modalTitle,
      modalText,
      modalButton,
      projectStage,
      modalInfoButton,
      showReport,
    } = this.state;
    document.body.onmouseup = () => {
      this.limitMovement();
    };
    const currentCard = CardsData[card.cardIndex];
    return player.name === "" ? (
      <>

        {/* <NetworkErrorPopUp show={this.state.showNetworkErrorPopUp} />
                <BrowserErrorPopUp show={this.state.showBrowserErrorPopUp} /> */}
        <RestoreGamePopUp
          show={this.state.showRestoreGamePopup}
          toggleRestoreGamePopup={this.toggleRestoreGamePopup}
          handleLogin={this.handleLogin}
          handleRestoreGame={this.handleRestoreGame}
          userId={this.state.tempUserId}
          playerName={this.state.tempPlayerName}
          prevGameId={this.state.prevGameId}
          gameEventId={this.state.gameEventId}
        />
        {this.handleLoginPage()}

      </>
    ) : (
      <>
        <CreateListener languageShortCode={this.state.shortCutLanguage} setSocket={this.setSocketIO} userId={this.state.player.id} gameId={this.state.player.gameId} />
        {<NetworkErrorPopUp show={this.state.showNetworkErrorPopUp} />}
        {<BrowserErrorPopUp show={this.state.showBrowserErrorPopUp} />}
        {player.name !== "" && this.refreshPopUP()}
        {this.state.isGamePaused &&
          !showReport && ( // if game is paused create div that blocks all the screen
            <BlockElement />
          )}
        {showReport && (
          <Report
            socketIO={this.state.socketIO}
            gameStartTime={this.state.gameStartTime}
            gameStartDate={this.state.gameStartDate}
            projectId={this.state.projectId}
            projectName={this.state.projectName}
            projectObjective={this.state.projectObjective}
            shortReport={this.state.shortReport}
            tasksArray={this.state.tasks}
            regularResources={this.state.playerRegularResources}
            seniorResources={this.state.playerSeniorResources}
            expensiveResources={this.state.playerExpensiveResources}
            turn={this.state.playerActualTurn}
            playerEmail={this.state.playerEmail}
            playersFullName={this.state.player.fullName}
            amountResourcesExpensive={this.state.amountResourcesExpensive}
            turnNumber={this.state.playerTurnNumber}
            logSideBar={this.state.logSideBar}
            totalValue={this.state.playerTotalValue}
            totalBudget={this.state.playerRemainignBudget}
            isPaused={this.state.showIsPaused}
            userId={this.state.player.id}
            toggleCloseReport={this.toggleOpenReportPdf}
            sendUserPreviousGames={this.postUserPreviousGames}
            isItAPreviousReport={this.state.isItAPreviousReport}
            toggleReport={this.toggleReport}
            sideLogUpdateToCurrentOne={this.sideLogUpdate}
            downloadReport={this.state.downloadReport}
            toggleDownloadReport={this.toggleDownloadReport}
            restartGameFunction={this.restartGameFunction}
            logout={this.logout}
            email={this.state.playerEmail}
            playerName={this.state.player.name}
            endGameFunction={this.endGameFunction}
            gameId={this.state.player.gameId}
            gameGoals={this.state.gameGoals}
            tasks={this.state.tasks}
            finalGrade={this.state.finalGrade}
            getReportTest={this.getPlayerLog}
            gameLogData={this.state.gameLog}
            previousReportsGameLogData={this.state.previousReportsGameLogData}
            gameUIdOfPrevGame={this.state.gameUIdOfPrevGame}
            downloadReportFunc={this.previousReportHandler}
            getCommentsTable={this.getCommentsTable}
          />
        )}
        {!showReport &&
          this.state.player.assistantMode &&
          this.state.assistantJson !== "" && (
            <AssistantChat
              assistantJson={this.state.assistantJson}
              gameId={this.state.player.gameId}
              userId={this.state.player.id}
              cardCounter={this.state.logSideBar}
              FlagVars={{
                offeredToGoBack: this.state.offeredToGoBack,
                offeredToGoToStart: this.state.offeredToGoToStart,
                playerPosition: this.state.player.position,
                movedTaskBeforePredecessorCount: this.state.movedTaskBeforePredecessorCount,
                changedProjectOrder: this.changedProjectOrder.current || this.state.tasks.filter((e) => e.isOrFlipped).length > this.lastFlipped.current,
                pressedStartPlaying: this.state.StartGamePopUpShow,
                pressedOkGotIt: this.state.pressedOkGotIt,
                firstProjectPopup: this.projectPopupCount.current === 1,
                cardCounter: this.state.logSideBar,
                onPlannedTask: Board[this.state.player.position].type === "planned-task",
                onStartTile: this.state.player.position === 0,
                TaskFlipChanged: this.state.tasks.filter((e) => e.isOrFlipped).length != this.lastFlipped.current,  // @REPLACE
                playerPositionType: Board[this.state.player.position < 1 ? 0 : this.state.player.position].type,
                orTasks: this.state.tasks.filter((e) => e.isOrFlipped).length,
                startGameShowModal: this.state.modalToggle && this.state.modalTitle === "modals.welcome.info_title",
                isSinglePlayer: true, // for now this is the only game mode
                hasMaxValueGoal: this.state.gameGoals?.value !== 0,
                deductValueAtDelay: this.state.movedToLessValueAtDelayCard,
                reachedThirdMilestone: this.state.player.position >= this.mileStonePositions.current[2],
                finishedSecondMilestone: this.state.player.position > this.mileStonePositions.current[1],
                finished_all_general_tasks: GeneralPMTasks.filter((element, index) =>
                  element.beforeEnd === -1
                    ? this.gatePositions.current.length <= this.state.generalTasks[index] // task that should be performed at every gate
                    : element.beforeEnd <= this.state.generalTasks[index] // general PM tasks
                ).length === this.state.generalTasks.length, // array of finished tasks is equal in length to all of the tasks
                pauseForPlanningPopUpActive: this.state.modalToggle && this.state.modalTitle === "modals.end_of_turn.info_title",
                inGrid: this.state.taskToggle,
                executeTaskWithOpenPredecessor: this.executeTaskWithOpenPredecessor,
                executeTaskWithNotEnoughResources: this.executeTaskWithNotEnoughResources,
                onUnPlannedTask: Board[this.state.player.position].type === "unplanned-task",
                card: this.state.card,
                player: this.state.player,
                resources: this.state.resources,
                isGameGotRestarted: this.state.gateRestartCounter,
                isChoosingFromDelayedCard: this.state.isChoosingFromDelayedCard,
                selectedUnPlannedTaskCarousel: this.state.selectedUnPlannedTask,
                goToStartFromDelay: this.state.goToStartFromDelay,
                playerAfterFirstGate: this.state.player.position > Board.findIndex(item => item.type === 'gate'),
                firstTimeVisitingGate: Board[this.state.player.position].gate?.firstTime,
                gateTestResult: this.state.gateTestResult,
                playerFinishedGame: this.state.modalToggle && this.state.modalTitle === "modals.project_completed.info_title",
                BoardCurrentPositionType: Board[this.state.player.position].type,
                openGeneralPmTasks: this.state.openGeneralPmTasks,
                isPlanning: this.state.isPlanning,
                hasExecuteRemainingTasksAtGateRef: this.hasExecuteRemainingTasksAtGateRef
              }}
              setPressedOkGotIt={this.setPressedOkGotIt}
              setMoveToLessValueAt={this.setMovedToLessValueAtDelayCard}
              assistantSound={assistantSound}
              SoundPlay={this.SoundPlay}
            />
          )}
        {!showReport && (
          <>
            {window.location.host !== "projectmanagementgame.pmzone.com" && <div style={{ display: "none" }}>
              <button id="take-delay" onClick={() => this.handleCard("Delay")}></button>
              <button id="take-unplanned" onClick={() => this.handleCard("unplanned-task")}></button>
              <button id="take-risk" onClick={() => this.handleCard("Risk")}></button>
              <button id="take-constraint" onClick={() => this.handleCard("Constraint")}></button>
            </div>}
            <TestForm
              getUserPreviousGames={this.getUserPreviousGames}
              userId={this.state.player.id}
            />
            {/* <div id="awd" onClick={() => this.handleCard('unplanned-task')}>awd</div> */}
            <ContentSection style={{ position: "absolute" }} isProjectSheetOpen={this.state.taskToggle}>
              {card.cardToggle && (
                <TaskPopUp
                  reachedMaximumAmountOfUnplannedTasks={this.state.maximumUnplannedCards == this.state.unplannedCards.length}
                  taskInfo={card.name}
                  earnedValue={card.earnedValue}
                  price={card.costMoney}
                  steps={card.steps}
                  btnOptionOne={card.firstOption}
                  btnOptionTwo={card.secondOption}
                  taskName={card.type}
                  card={card}
                  cardEffect={card.effect}
                  whiteNum={card.costResourcesNormal}
                  redNum={card.costResourcesSenior}
                  greenNum={card.costResourcesExpensive}
                  topScreenNum={card.id} // 7
                  cardsLiveViewRefGlobal={this.cardsLiveViewRefGlobal}
                  DelayTwoOptions={card.delayOptions}
                  handleCard={this.handleCard}
                  performCard={this.performCard}
                  playerStatus={this.state.player}
                  toggleResources={this.toggleResources}
                  additionalBudget={this.additionalBudget}
                  commentAdditionalBudget={this.commentAdditionalBudget}
                  unplannedCards={this.state.unplannedCards}
                  handleUnplannedCards={this.handleUnplannedCards}
                  removeUnplannedCards={this.removeUnplannedCards}
                  explanationCard={this.state.explanationCard}
                  cardState={this.state.cardState}
                  setCardState={this.setCardState}
                  SoundPlay={this.SoundPlay}
                  soundForFlipAndCards={soundForFlipAndCards}
                  errorSound={errorSound}
                  moneySound={moneySound}
                  additionalBudgetGlobalFunction={this.onlyShowModal}
                  isGamePausedRef={this.isGamePausedRef}
                  setIsCardCountDownActive={this.setIsCardCountDownActive}
                  openStage={this.state.projectStage}
                  toggleProject={this.toggleProject}
                  gameId={this.state.player.gameId}
                  userId={this.state.player.id}
                  cardsLiveView={this.state.tasks}
                  setCardsLiveView={this.setTasks}
                  tasksButOrTasksNotSaved={this.state.tasksButOrTasksNotSaved}
                  setTasksButOrTasksNotSaved={this.setTasksButOrTasksNotSaved}
                  setSelectedCardIs={this.setSelectedCardIs}
                  setIsChoosingFromDelayedCard={this.setIsChoosingFromDelayedCard}
                  setOneLessStep={this.setOneLessStep}
                  oneLessStep={this.state.oneLessStep}
                />
              )}
              <Modal
                toggleGameDefinitions={this.toggleGameDefinitions}
                modalTitle={modalTitle}
                modalText={modalText}
                modalButton={modalButton}
                modalInfoButton={modalInfoButton}
                toggleShow={this.showModal}
                toggleModal={this.toggleModal}
                show={this.state.modalToggle}
                player={this.state.player}
                additionalBudget={this.additionalBudget}
                commentAdditionalBudget={this.commentAdditionalBudget}
                startTurn={this.startTurn}
                isPaused={this.isPaused}
                isPlanning={this.isPlanning}
                showIsPaused={this.state.showIsPaused}
                projectName={this.state.projectName}
                projectObjective={this.state.projectObjective}
                toggleResources={this.toggleResources}
                toggleToolTip={this.toggleToolTip}
                handleCard={this.handleCard}
                toggleProject={this.toggleProject}
                openStage={this.state.projectStage}
                beginTurnChecked={this.state.beginTurnChecked}
                toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                StartTurnMessageDisable={this.StartTurnMessageDisable}
                isStartTurnMessageShowing={this.state.isStartTurnMessageShowing}
                setNewTurn={this.setNewTurn}
                endGameFunction={this.endGameFunction}
                togglePlanYourProjectPopUp={this.togglePlanYourProjectPopUp}
                SoundPlay={this.SoundPlay}
                moneySound={moneySound}
                projectId={this.state.projectId}
              />
              <MilestoneModal
                firstMilestoneTile={this.state.firstMilestoneTileId}
                toggleSideLogAnimation={this.toggleSideLogAnimation}
                toggleMilestoneModal={this.toggleMilestoneModal}
                MilestoneState={this.state.firstMileStonePassed}
                toggleIsFirstMileStonePassed={this.toggleIsFirstMileStonePassed}
                show={this.state.MilestoneModalShow}
                openStage={this.state.projectStage}
                toggleProject={this.toggleProject}
                position={this.state.player.position}
                handleMilestone={this.handleMilestone}
                showbefore={this.toggle}
                toggleAfterMilestonePopUp={this.toggleAfterMilestonePopUp}
                showAfterModal={this.state.AfterMilestonePopUpShow}
                toggleMilestonCkeckbox={this.toggleMilestonCkeckbox}
                afterMilestonChecked={this.state.afterMilestonChecked}
                endTurn={this.endTurn}
                handleCard={this.handleCard}
                ProjectScopeDisable={this.ProjectScopeDisable}
                isDisabledPMTasks={this.state.isDisabledPMTasks}
                SoundPlay={this.SoundPlay}
                soundForFlipAndCards={soundForFlipAndCards}
                toggleIsAnimationNeeded={this.toggleIsAnimationNeeded}
                lastMilestone={this.getLastMilestoneTileId}
                Board={Board}
                toggleExecutePopUp={this.toggleExecutePopUp}
                needsToDelayExecutePopup={this.state.needsToDelayExecutePopup}
                toggleNeedsToDelayExecutePopup={
                  this.toggleNeedsToDelayExecutePopup
                }
                isPaused={this.isPaused}
                toggleExecuteGPMTOnMilestone={this.toggleExecuteGPMTOnMilestone}
                needToOpenProjectSheetAfterMilestonePopUp={
                  this.state.needToOpenProjectSheetAfterMilestonePopUp
                }
                toggleOpenSheetAfterPopUp={this.toggleOpenSheetAfterPopUp}
              />
              <AfterMilestonePopUp
                show={this.state.AfterMilestonePopUpShow}
                playerStatus={this.state.playerStatusChange}
                player={this.state.player}
                walkingAlgorithm={this.walkingAlgorithm}
                toggleAfterMilestonePopUp={this.toggleAfterMilestonePopUp}
                performCard={this.performCard}
                handleProgress={this.handleProgress}
                performPlannedTask={this.performPlannedTask}
                tasks={this.state.tasks}
                toggleMilestonCkeckbox={this.toggleMilestonCkeckbox}
                afterMilestonChecked={this.state.afterMilestonChecked}
                SoundPlay={this.SoundPlay}
                lastMilestone={this.getLastMilestoneTileId}
              />
              <BeginTurnPopUp
                show={this.state.BeginTurnPopUpShow}
                playerStatus={this.state.playerStatusChange}
                player={this.state.player}
                walkingAlgorithm={this.walkingAlgorithm}
                toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                performCard={this.performCard}
                handleProgress={this.handleProgress}
                performPlannedTask={this.performPlannedTask}
                tasks={this.state.tasks}
                playerCurrentPosition={this.state.player.position}
                toggleProject={this.toggleProject}
                beginTurnChecked={this.state.beginTurnChecked}
                toggleBeginTurnCkeckbox={this.toggleBeginTurnCkeckbox}
                startTurn={this.startTurn}
                StartTurnMessageDisable={this.StartTurnMessageDisable}
                isStartTurnMessageShowing={this.state.isStartTurnMessageShowing}
                isPaused={this.isPaused}
                SoundPlay={this.SoundPlay}
                setNewTurn={this.setNewTurn}
                setKeepShowing={this.toggleKeepShowingBeginTurnPopUp}
                keepShowing={this.state.keepShowingBeginTurnPopUp}
                currentTile={Board[this.state.player.position]?.type}
              />
              <ChangeProjectPopUp
                show={this.state.showChangeProjectPopUp}
                changeProject={this.toggleChangeProject}
                allMainProjects={this.state.allMainProjects}
                restartGameWithNewProject={this.restartGameWithNewProject}
                currentProjectId={this.state.projectId}
              />
              <ExecuteTaskPopUp
                show={this.state.ExecuteTaskPopUpShow}
                playerStatus={this.state.playerStatusChange}
                player={this.state.player}
                walkingAlgorithm={this.walkingAlgorithm}
                toggleExecutePopUp={this.toggleExecutePopUp}
                performCard={this.performCard}
                handleProgress={this.handleProgress}
                performPlannedTask={this.performPlannedTask}
                tasks={this.state.tasks}
                toggleProject={this.toggleProject}
                SoundPlay={this.SoundPlay}
                toggleProjectSound={toggleProjectSound}
                toggleIsAnimationNeeded={this.toggleIsAnimationNeeded}
                taskScopeState={this.state.taskToggle}
              />
              <IdleTimer
                endGameFunction={this.endGameFunction}
                gameId={this.state.player.gameId}
                userId={this.state.player.id}
                playerPosition={this.state.player.position}
                isGamePaused={this.state.isGamePaused}
                showReport={showReport}
                toggleIsGamePaused={this.toggleIsGamePaused}
                setKeepShowing={this.setKeepShowingIdlePopUp}
                keepShowing={this.state.keepShowingIdlePopUp}
                isCardCountDownActive={this.state.isCardCountDownActive}
              />
              <PrevReportPopUp
                show={this.state.prevReportPopUp}
                toggleOpenReportPdf={this.toggleOpenReportPdf}
                endGameFunction={this.endGameFunction}
                getUserPreviousGames={this.getUserPreviousGames}
                userId={this.state.player.id}
                gameId={this.state.player.gameId}
                prevReports={this.state.prevReports}
                toggleShow={this.togglePrevReportPopUp}
                prevGameIds={this.state.prevGameIdOfSpecificUser}
                getUserPreviousGameId={this.getUserPreviousGameId}
                openPrevReportForScreenShot={this.openPrevReportForScreenShot}
                toggleDownloadReport={this.toggleDownloadReport}
                setGameUIdOfPrevGame={this.setGameUIdOfPrevGame}
                getReportTest={this.getPlayerLog}
              />
              <PlanYourProjectPopUp
                show={this.state.gameFirstPopUp}
                togglePlanYourProjectPopUp={this.togglePlanYourProjectPopUp}
                toggleShow={this.showModal}
                toggleModal={this.toggleModal}
                SoundPlay={this.SoundPlay}
                setPressedOkGotIt={this.setPressedOkGotIt}
              />
              <StartGamePopUp
                show={this.state.StartGamePopUpShow}
                playerStatus={this.state.playerStatusChange}
                player={this.state.player}
                toggleStartGamePopUp={this.toggleStartGamePopUp}
                performCard={this.performCard}
                handleProgress={this.handleProgress}
                performPlannedTask={this.performPlannedTask}
                tasks={this.state.tasks}
                startTurn={this.startTurn}
                toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                toggleProject={this.toggleProject}
                BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                playerCurrentPosition={this.state.player.position}
                SoundPlay={this.SoundPlay}
                playerId={this.state.player.id}
                gameId={this.state.player.gameId}
                sendCardsToServer={this.sendCardsToServer}
                updatedCards={this.state.updatedCards}
                notUpdatedCards={this.state.tasksButOrTasksNotSaved}
                changesMade={this.state.changesMade}
                setChangesMade={this.setChangesMade}
                projectScopeDisabled={this.ProjectScopeDisable}
                disableExecuteBtn={this.toggleProjectNeedToBeDisabled}
                setIsGameStarted={this.setIsGameStarted}
                lastFlipped={this.lastFlipped}
              />
              <NotEnoughResourcesPopUp
                showThisModal={this.state.NotEnoughResourcesPopUpShow}
                playerStatus={this.state.playerStatusChange}
                player={this.state.player}
                walkingAlgorithm={this.walkingAlgorithm}
                toggleNotEnoughResourcesPopUp={this.toggleNotEnoughResourcesPopUp}
                checkedPmCount={this.state.checkedPmCount}
                performCard={this.performCard}
                handleProgress={this.handleProgress}
                performPlannedTask={this.performPlannedTask}
                tasks={this.state.tasks}
                toggleResources={this.toggleResources}
                toggleProject={this.toggleProject}
                additionalBudget={this.additionalBudget}
                commentAdditionalBudget={this.commentAdditionalBudget}
                handleCard={this.handleCard}
                openStage={this.state.projectStage}
                onlyShowModal={this.onlyShowModal}
                toggleModal={this.toggleModal}
                toggleProjectNeedToBeDisabled={this.toggleProjectNeedToBeDisabled}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          setShowOpenProjectSheetAfterBack={this.setShowOpenProjectSheetAfterBack}
                        />
            </ContentSection>
            <TopBar
              playerName={player.name}
              canPlayUntil={player.canPlayUntil}
              timeSeconds={this.timeSeconds.current}
              prevReportPopUp={this.state.prevReportPopUp}
              togglePopUp={this.togglePrevReportPopUp}
              clearTimer={this.state.clearTimer}
              toggleClearTimer={this.toggleClearTimer}
              setTimeSeconds={this.setTimerSeconds}
              hasBeenMadeRestartGame={this.state.needsToStartNewGame}
              toggleResetTimer={this.toggleResetTimer}
              resetTimer={this.state.resetTimer}
              setHasBeenMadeRestartGame={this.toggleNeedsToStartNewGame}
              toggleIsGamePaused={this.toggleIsGamePaused}
              isGamePausedRef={this.isGamePausedRef}
              isGamePaused={this.state.isGamePaused}
              gameId={this.state.player.gameId}
              userId={this.state.player.id}
              localTimerOfPreviousGame={this.state.localTimerOfPreviousGame}
              setLocalTimerOfPreviousGame={this.setLocalTimerOfPreviousGame}
              pauseForPlanningTimer={this.pauseForPlanningTimer.current}
              planningTimerBaselineRev={this.state.planningTimerBaselineRev}
              updatePlanningTimer={this.updatePlanningTimer}
              isGameStarted={this.state.isGameStartedForTheFirstTime}
              gameStartTime={this.gameStartTime}
              totalTimeoutDuration={this.totalTimeoutDuration}
              languagesList={this.state.languagesList}
              currentLanguage={this.state.currentLanguage}
              setCurrentLanguage={this.setCurrentLanguage}
              shortCutLanguage={this.state.shortCutLanguage}
            />
          </>
        )
        }
        {
          !showReport &&
          (this.state.taskToggle ? (
            <Tasks
              socketIO={this.state.socketIO}
              setMovedTaskBeforePredecessorCount={this.setMovedTaskBeforePredecessorCount}
              firstProjectPopup={this.projectPopupCount.current === 1}
              changedProjectOrder={this.changedProjectOrder}
              setPressedOkGotIt={this.setPressedOkGotIt}
              isPlanning={this.state.isPlanning}
              newTurn={this.state.newTurn}
              toggleProject={this.toggleProject}
              markReturnedToBoardFromProject={this.setShowOpenProjectSheetAfterBack}
              toggleStartPlaying={this.toggleStartGamePopUp}
              taskShow={this.state.taskToggle}
              performPlannedTask={this.performPlannedTask}
              playerStatus={this.state.player}
              openStage={projectStage}
              setOpenGeneralPmTasks={this.setOpenGeneralPmTasks}
              openGeneralPmTasks={this.state.openGeneralPmTasks}
              commentAltTasks={this.commentAltTask}
              lastFlipped={this.lastFlipped}
              checkedTask={this.state.checkedTask}
              setCheckedTask={this.setCheckedTask}
              taskToggle={this.state.taskToggle}
              ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
              playerPosition={
                Board[
                  this.state.player.position < 1
                    ? 0
                    : this.state.player.position
                ].type
              }
              tasks={this.state.tasks}
              cardsLiveView={this.state.tasks}
              setCardsLiveView={this.setTasks}
              ProjectInfo={{
                projectId: this.state.projectId,
                projectName: this.state.projectName,
                projectObjective: this.state.projectObjective,
              }}
              log={this.state.gameLog}
              // log={this.state.log}
              initializePlayer={this.initializePlayerOnBoard}
              sendCardsToServer={this.sendCardsToServer}
              getTriviaData={this.getTriviaData}
              playerCurrentPosition={this.state.player.position}
              generalTask={this.state.generalTasks}
              playerId={this.state.player.id}
              gameId={this.state.player.gameId}
              imageData={this.state.mapImage}
              showModal={this.onlyShowModal}
              orTasks={this.state.orTasks}
              orTaskChangeHandler={this.handleOrTaskChange}
              showIsPaused={this.state.showIsPaused}
              isPaused={this.isPaused}
              startTurn={this.startTurn}
              playerInfo={{
                earned: player.earnedValue,
                budget: player.budget,
              }}
              sources={{
                white: player.resources.regular,
                red: player.resources.executive,
                green: player.resources.expensive,
              }}
              ProjectScopeDisable={this.ProjectScopeDisable}
              isDisabledPMTasks={this.state.isDisabledPMTasks}
              toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
              isStartTurnMessageShowing={this.state.isStartTurnMessageShowing}
              BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
              firstPopUpShowing={this.state.gameFirstPopUp}
              isNewTurn={this.state.newTurn}
              setNewTurn={this.setNewTurn}
              SoundPlay={this.SoundPlay}
              playerStatusChange={this.state.playerStatusChange}
              soundForFlipAndCards={soundForFlipAndCards}
              setUpdatedCards={this.setUpdatedCards}
              different={this.state.playerDifAnimation}
              isCardOpen={this.state.card.cardToggle}
              toggleIsAnimationNeeded={this.toggleIsAnimationNeeded}
              animationVars={this.state.animationVars}
              disableExecuteBtnFunc={this.toggleProjectNeedToBeDisabled}
              disableExecuteBtn={this.state.projectNeedToBeDisabled}
              value={this.state.value}
              playerName={this.state.player.name}
              handleProgress={this.handleProgress}
              StartTurnMessageDisable={this.StartTurnMessageDisable}
              updateOrTaskFlip={this.updateOrTaskFlip}
              setChangesMade={this.setChangesMade}
              bumpReorderAction={this.bumpReorderAction}
              markManualReorderTouched={this.markManualReorderTouched}
              markTaskDragged={this.markTaskDragged}
              changesMade={this.state.changesMade}
              currentTileType={Board[this.state.player.position]?.type}
              projectScopePopUps={{
                budgetAndResources: this.state.NotEnoughResourcesPopUpShow,
                prevReport: this.state.prevReportPopUp,
                planYourProject: this.state.gameFirstPopUp,
                startPlaying: this.state.StartGamePopUpShow,
                modalToggle: this.state.modalToggle,
              }}
              toggleDisableScreen={this.toggleDisableScreen}
              ProjectScopeBackButtonDisabled={
                this.state.ProjectScopeBackButtonDisabled
              }
              toggleExecuteGPMTOnMilestone={this.toggleExecuteGPMTOnMilestone}
              setTasks={(value) => {
                this.setState({ tasks: value });
              }}
              cardsLiveViewRefGlobal={this.cardsLiveViewRefGlobal}
              setOneLessStep={this.setOneLessStep}
              oneLessStep={this.state.oneLessStep}
            />
          ) : (
            <MainContainer>
              {/* {console.log("aa", this.state.disableScreen, this.state.modalToggle, this.state.toggleGate, this.state.BeginTurnPopUpShow, !this.state.showIsPaused)} */}
              {(this.state.MilestoneModalShow ||
                this.state.disableScreen ||
                this.state.showTrivia ||
                this.state.modalToggle ||
                this.state.toggleGate ||
                this.state.ExecuteTaskPopUpShow ||
                this.state.BeginTurnPopUpShow) &&
                !this.state.showIsPaused && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: "25",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                )}
              {this.state.modalTitle === "modals.welcome.info_title" &&
                this.state.modalToggle ? (
                <div
                  style={{
                    position: "absolute",
                    zIndex: "99",
                    height: "100%",
                    width: "100%",
                  }}
                />
              ) : null}
              <LeftSideIcons
                handleRestartMap={this.handleRestartMap}
                toggleInfo={this.toggleInfo}
                onChange={(value) => this.handleRestartMap({ value })}
                quitGameModal={this.quitGameModal}
              />
              <ContentSection className="map" isProjectSheetOpen={this.state.taskToggle}>
                {this.state.toggleGate && (
                  <Gates
                    projectId={this.state.projectId}
                    changeProject={this.changeProject}
                    plannedTaskStack={this.state.plannedTaskStack}
                    setPlannedTaskStack={this.setPlannedTaskStack}
                    socketIO={this.state.socketIO}
                    advanceOfferedToGoBack={this.advanceOfferedToGoBack}
                    sideLogUpdate={this.sideLogUpdate}
                    toggleSideLogAnimation={this.toggleSideLogAnimation}
                    setTasksCounter={this.setTasksCounter}
                    generalCounter={this.state.generalIndexCounter}
                    timeSeconds={this.timeSeconds}
                    tasksTimer={this.state.tasksTimer}
                    setTasksTimer={this.setTasksTimer}
                    saveGame={this.saveGame}
                    toggleSaveOnGate={this.toggleSaveOnGate}
                    isPlanning={this.isPlanning}
                    additionalBudget={this.additionalBudget}
                    commentAdditionalBudget={this.commentAdditionalBudget}
                    toggleResources={this.toggleResources}
                    toggleGate={this.toggleGate}
                    toggleEndOfTurnModal={this.toggleModal}
                    gateTasks={this.state.gateTasks}
                    playerStatus={this.state.player}
                    walkingAlgorithm={this.walkingAlgorithm}
                    handlePlayerStatus={this.handlePlayerStatus}
                    endTurn={this.endTurn}
                    handleCard={this.handleCard}
                    initializePlayer={this.initializePlayerOnBoard}
                    tasks={this.state.tasks}
                    orTasks={this.state.orTasks}
                    generalTasks={this.state.generalTasks}
                    unplannedCards={this.state.unplannedCards}
                    playerCurrentPosition={this.state.player.position}
                    playerCurrentId={this.state.player.id}
                    toggleSecondGateNeeded={this.toggleSecondGateNeeded}
                    handleGateNumber={this.handleGateNumber}
                    actualGate={this.state.gateNumber}
                    toggleProject={this.toggleProject}
                    secondGateControlNeeded={this.state.secondGateControlNeeded}
                    onlyShowModal={this.onlyShowModal}
                    triviaToggle={this.triviaToggle}
                    getTriviaData={this.getTriviaData}
                    SoundPlay={this.SoundPlay}
                    soundForFlipAndCards={soundForFlipAndCards}
                    toggleDelayCardAtFirstGateControl={
                      this.toggleDelayCardAtFirstGateControl
                    }
                    toggleTriviaNotOpenIfDelay={this.toggleTriviaNotOpenIfDelay}
                    delayCardIsTakenInGateControl={
                      this.state.delayCardIsTakenInGateControl
                    }
                    gateTextNeedToChange={this.state.gateTextNeedToChange}
                    toggleGateTextNeedToChange={this.toggleGateTextNeedToChange}
                    endGameFunction={this.endGameFunction}
                    upcomingGate={this.getUpcomingGateTileId}
                    handleLogin={this.handleLogin}
                    email={this.state.playerEmail}
                    playerName={this.state.player.name}
                    restartGameFunction={this.restartGameFunction}
                    toggleReport={this.toggleReport}
                    toggleNeedsToStartNewGame={this.toggleNeedsToStartNewGame}
                    playersFullName={this.state.player.fullName}
                    gameStartTime={this.state.gameStartTime}
                    gameGoals={this.state.gameGoals}
                    logSideBar={this.state.logSideBar}
                    amountResourcesExpensive={this.state.amountResourcesExpensive}
                    shortReport={this.state.shortReport}
                    turn={this.state.turnNumber}
                    toggleProjectNeedToBeDisabled={
                      this.toggleProjectNeedToBeDisabled
                    }
                    backButtonDisableToggle={
                      this.toggleProjectScopeBackButtonDisabled
                    }
                    tasksToggle={this.setTasksPopupClose}
                    getReportTest={this.getPlayerLog}
                    originTask={this.state.tasksByNumber} // original order of tasks as mentioned in the project DB.
                    pauseForPlanningTimer={this.pauseForPlanningTimer.current}
                    timerFormat={this.timerFormat}
                    getPlayerLog={this.getPlayerLog}
                    projectScopeDisabled={this.ProjectScopeDisable}
                    toggleRestartHasBeenMadeNow={this.toggleRestartHasBeenMadeNow}
                    setGateTestResult={this.setGateTestResult}
                    gateTestResult={this.state.gateTestResult}
                    setOneLessStep={this.setOneLessStep}
                    hasExecuteRemainingTasksAtGateRef={this.hasExecuteRemainingTasksAtGateRef}
                    additionalBudgetCommentsInit={this.additionalBudgetCommentsInit}
                    resourcesForDoublePriceCommentInit={this.resourcesForDoublePriceCommentInit}
                    askedForAdditionalInGate={this.state.performedLateTasksAtGateAndAskedFor}
                    setAskedForBudgetAtGate={this.setAskedForBudgetAtGate}
                    setAskedForResourcesAtGate={this.setAskedForResourcesAtGate}
                  />
                )}
                <ResourcesPopUp
                  resourcesShow={this.state.resourceToggle}
                  toggleResources={this.toggleResources}
                  resources={player.resources}
                  // prices={{ white: 200, red: 400, green: 1000 }}
                  // pricesExchange={{ white: 100, red: 200, green: 500 }}
                  exchangeResources={this.exchangeResources}
                  data={{
                    earned: player.earnedValue,
                    budget: player.budget,
                    resources: player.resources,
                  }}
                  showIsPaused={this.state.showIsPaused}
                  isDisabledPMTasks={this.state.isDisabledPMTasks}
                  toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                  isStartTurnMessageShowing={
                    this.state.isStartTurnMessageShowing
                  }
                  BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                  exchangeResourcesTest={this.exchangeResourcesTest}
                  setResourcesInTheTurn={this.setResourcesInTheTurn}
                  amountResourcesExpensive={this.state.amountResourcesExpensive}
                  commentResourcesAtDoublePrice={
                    this.commentResourcesAtDoublePrice
                  }
                  moneySound={moneySound}
                  SoundPlay={this.SoundPlay}
                />
                <ToolTipPopUp
                  toggleToolTip={this.toggleToolTip}
                  showToolTip={this.state.toolTipToggle}
                />
                <GameLog
                  showGameLog={this.state.gameLogToggle}
                  gameLogToggle={this.gameLogToggle}
                  data={this.state.gameLog}
                  position={this.state.player.position}
                  positionGameLog={this.state.positionGameLog}
                  getLastMilestoneTileId={this.goToLastMilestoneOrGate}
                  gameLogLoading={this.state.gameLogLoading}
                  tasksArray={this.state.tasksByNumber}
                  totalUsed={this.state.totalUsed}
                // getReportTest={this.check}
                />
                <Trivia
                  showTrivia={this.state.showTrivia}
                  triviaToggle={this.triviaToggle}
                  data={this.state.checkBox}
                  playerId={this.state.player.id}
                  gameId={this.state.player.gameId}
                  triviaValues={this.state.triviaValues}
                  endTurn={this.endTurn}
                  turnNeedsToEndInGate={this.state.turnNeedsToEndInGate}
                  turnEndsInGateToggle={this.turnEndsInGateToggle}
                  walkingAlgorithm={this.walkingAlgorithm}
                  playerStatus={this.state.player}
                  startTurn={this.startTurn}
                  SoundPlay={this.SoundPlay}
                  soundForFlipAndCards={soundForFlipAndCards}
                  fetchConfig={fetchConfig}
                  isZoomed={this.state.resizePopUpShown != null}
                />
                <GeneralInfoGateControl
                  generalInfoShow={this.state.generalInfoShow}
                  toggleInfo={this.toggleInfo}
                  title={this.state.infoTitle}
                  paragraph={this.state.infoParagraph}
                  toggleGameDefinitions={this.toggleGameDefinitions}
                  gameDefinitionsStage={this.state.gameDefinitionsStage}
                  handleDefinitionsStage={this.handleDefinitionsStage}
                />
                <GameDefinitions
                  gameDefinitionsShow={this.state.gameDefinitionsShow}
                  toggleGameDefinitions={this.toggleGameDefinitions}
                  title={this.state.definitionsTitle}
                  paragraph={this.state.infoParagraph}
                />
                <Tutorial
                  tutorialShow={this.state.tutorialShow}
                  toggleTutorial={this.toggleTutorial}
                  title={this.state.tutorialTitle}
                  paragraph={this.state.infoParagraph}
                />
                <Help
                  show={this.state.helpShow}
                  toggleHelp={this.toggleHelp}
                />
                <MapInteractionCSS
                  value={this.state.value}
                  onChange={(value) => this.setState({ value })}
                >
                  {Board.map((current, index, array) => {
                    let reverse = false; // sets the gradient to be reversed
                    if (current.id === 0) {
                      return (
                        <Tile
                          startTurn={this.startTurn}
                          key={current.id}
                          currentLanguage={this.state.currentLanguage}
                          number={current.id}
                          type={current.type}
                          player={player.position}
                          position={this.state.player.position}
                          playerName={player.name}
                          top={`${position.top}vh`}
                          left={`${position.left - 10}vw`}
                          handleProgress={this.handleProgress}
                          isPaused={this.isPaused}
                          showIsPaused={this.state.showIsPaused}
                          toggleProject={this.toggleProject}
                          openStage={this.state.projectStage}
                          StartTurnMessageDisable={this.StartTurnMessageDisable}
                          isStartTurnMessageShowing={
                            this.state.isStartTurnMessageShowing
                          }
                          toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                          BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                          setNewTurn={this.setNewTurn}
                          SoundPlay={this.SoundPlay}
                          toggleProjectSound={toggleProjectSound}
                          isNewTurn={this.state.newTurn}
                          currentTileType={
                            Board[this.state.player.position]?.type
                          }
                          toggleExecuteGPMTOnMilestone={
                            this.toggleExecuteGPMTOnMilestone
                          }
                          executeGPMTOnMilestone={
                            this.state.executeGPMTOnMilestone
                          }
                          ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                      );
                    }
                    if (current.id === 1) {
                      return (
                        <div key={current.id}>
                          {" "}
                          <Tile
                            startTurn={this.startTurn}
                            key={current.id}
                            number={current.id}
                            type={current.type}
                            player={player.position}
                            playerName={player.name}
                            top={`${position.top}vh`}
                            left={`${position.left}vw`}
                            handleProgress={this.handleProgress}
                            isPaused={this.isPaused}
                            showIsPaused={this.state.showIsPaused}
                            toggleProject={this.toggleProject}
                            openStage={this.state.projectStage}
                            StartTurnMessageDisable={
                              this.StartTurnMessageDisable
                            }
                            isStartTurnMessageShowing={
                              this.state.isStartTurnMessageShowing
                            }
                            toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                            BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                            setNewTurn={this.setNewTurn}
                            SoundPlay={this.SoundPlay}
                            toggleProjectSound={toggleProjectSound}
                            isNewTurn={this.state.newTurn}
                            currentTileType={
                              Board[this.state.player.position]?.type
                            }
                            toggleExecuteGPMTOnMilestone={
                              this.toggleExecuteGPMTOnMilestone
                            }
                            executeGPMTOnMilestone={
                              this.state.executeGPMTOnMilestone
                            }
                            ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                          <RightLine
                            style={{
                              top: `${position.top + 4}vh`,
                              left: `${position.left - 7}vw`,
                            }}
                            previousCardColor={tileTypes[array[index - 0].type]}
                            currentCardColor={tileTypes[array[index].type]}
                            reverse={reverse}
                          />
                        </div>
                      );
                    }
                    if (current.id === Board.length) {
                      return (
                        <div key={current.id}>
                          <Tile
                            startTurn={this.startTurn}
                            key={current.id}
                            number={current.id}
                            type={current.type}
                            player={player.position}
                            position={this.state.player.position}
                            playerName={player.name}
                            top={`${position.top}vh`}
                            left={`${position.left - 10}vw`}
                            handleProgress={this.handleProgress}
                            isPaused={this.isPaused}
                            showIsPaused={this.state.showIsPaused}
                            toggleProject={this.toggleProject}
                            openStage={this.state.projectStage}
                            StartTurnMessageDisable={
                              this.StartTurnMessageDisable
                            }
                            isStartTurnMessageShowing={
                              this.state.isStartTurnMessageShowing
                            }
                            toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                            BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                            setNewTurn={this.setNewTurn}
                            SoundPlay={this.SoundPlay}
                            toggleProjectSound={toggleProjectSound}
                            isNewTurn={this.state.newTurn}
                            toggleExecuteGPMTOnMilestone={
                              this.toggleExecuteGPMTOnMilestone
                            }
                            executeGPMTOnMilestone={
                              this.state.executeGPMTOnMilestone
                            }
                            ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                          <RightLine
                            style={{
                              top: `${position.top + 4}vh`,
                              left: `${position.left - 7}vw`,
                            }}
                            previousCardColor={tileTypes[array[index - 1].type]}
                            currentCardColor={tileTypes[array[index].type]}
                            reverse={reverse}
                            currentTileType={
                              Board[this.state.player.position]?.type
                            }
                          />
                        </div>
                      );
                    }
                    switch (current.id % 8) {
                      default:
                      case 0:
                      case 1:
                      case 4:
                      case 5:
                        position.top -= 18;

                        return (
                          <div key={current.id}>
                            <UpLine
                              style={{
                                top: `${position.top + 7}vh`,
                                left: `${position.left + 2}vw`,
                              }}
                              previousCardColor={
                                tileTypes[array[index - 1].type]
                              }
                              currentCardColor={tileTypes[array[index].type]}
                            />
                            <Tile
                              startTurn={this.startTurn}
                              key={current.id}
                              number={current.id}
                              type={current.type}
                              player={player.position}
                              playerName={player.name}
                              top={`${position.top}vh`}
                              left={`${position.left}vw`}
                              handleProgress={this.handleProgress}
                              isPaused={this.isPaused}
                              showIsPaused={this.state.showIsPaused}
                              toggleProject={this.toggleProject}
                              openStage={this.state.projectStage}
                              StartTurnMessageDisable={
                                this.StartTurnMessageDisable
                              }
                              isStartTurnMessageShowing={
                                this.state.isStartTurnMessageShowing
                              }
                              toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                              BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                              setNewTurn={this.setNewTurn}
                              SoundPlay={this.SoundPlay}
                              toggleProjectSound={toggleProjectSound}
                              isNewTurn={this.state.newTurn}
                              currentTileType={
                                Board[this.state.player.position]?.type
                              }
                              toggleExecuteGPMTOnMilestone={
                                this.toggleExecuteGPMTOnMilestone
                              }
                              executeGPMTOnMilestone={
                                this.state.executeGPMTOnMilestone
                              }
                              ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                          </div>
                        );
                      case 2:
                      case 3:
                        position.left += 10;

                        reverse = true;
                        return (
                          <div key={current.id}>
                            <RightLine
                              style={{
                                top: `${position.top + 4}vh`,
                                left: `${position.left - 7}vw`,
                              }}
                              previousCardColor={
                                tileTypes[array[index - 1].type]
                              }
                              currentCardColor={tileTypes[array[index].type]}
                              reverse={reverse}
                            />
                            <Tile
                              startTurn={this.startTurn}
                              key={current.id}
                              number={current.id}
                              type={current.type}
                              player={player.position}
                              playerName={player.name}
                              top={`${position.top}vh`}
                              left={`${position.left}vw`}
                              handleProgress={this.handleProgress}
                              isPaused={this.isPaused}
                              showIsPaused={this.state.showIsPaused}
                              toggleProject={this.toggleProject}
                              openStage={this.state.projectStage}
                              StartTurnMessageDisable={
                                this.StartTurnMessageDisable
                              }
                              isStartTurnMessageShowing={
                                this.state.isStartTurnMessageShowing
                              }
                              toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                              BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                              setNewTurn={this.setNewTurn}
                              SoundPlay={this.SoundPlay}
                              toggleProjectSound={toggleProjectSound}
                              isNewTurn={this.state.newTurn}
                              currentTileType={
                                Board[this.state.player.position]?.type
                              }
                              toggleExecuteGPMTOnMilestone={
                                this.toggleExecuteGPMTOnMilestone
                              }
                              executeGPMTOnMilestone={
                                this.state.executeGPMTOnMilestone
                              }
                              ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                          </div>
                        );
                      case 6:
                      case 7:
                        position.left -= 10;
                        return (
                          <div key={current.id}>
                            <RightLine
                              style={{
                                top: `${position.top + 4}vh`,
                                left: `${position.left + 3}vw`,
                              }}
                              previousCardColor={
                                tileTypes[array[index - 1].type]
                              }
                              currentCardColor={tileTypes[array[index].type]}
                              reverse={reverse}
                            />
                            <Tile
                              startTurn={this.startTurn}
                              key={current.id}
                              number={current.id}
                              type={current.type}
                              player={player.position}
                              playerName={player.name}
                              top={`${position.top}vh`}
                              left={`${position.left}vw`}
                              handleProgress={this.handleProgress}
                              isPaused={this.isPaused}
                              showIsPaused={this.state.showIsPaused}
                              toggleProject={this.toggleProject}
                              openStage={this.state.projectStage}
                              StartTurnMessageDisable={
                                this.StartTurnMessageDisable
                              }
                              isStartTurnMessageShowing={
                                this.state.isStartTurnMessageShowing
                              }
                              toggleBeginTurnPopUp={this.toggleBeginTurnPopUp}
                              BeginTurnPopUpShow={this.state.BeginTurnPopUpShow}
                              setNewTurn={this.setNewTurn}
                              SoundPlay={this.SoundPlay}
                              toggleProjectSound={toggleProjectSound}
                              isNewTurn={this.state.newTurn}
                              currentTileType={
                                Board[this.state.player.position]?.type
                              }
                              toggleExecuteGPMTOnMilestone={
                                this.toggleExecuteGPMTOnMilestone
                              }
                              executeGPMTOnMilestone={
                                this.state.executeGPMTOnMilestone
                              }
                              ProjectScopeDisable={this.ProjectScopeDisable}
                          toggleDisableScreen={this.toggleDisableScreen}
                          checkedTask={this.state.checkedTask}
                          taskToggle={this.state.taskToggle}
                          ExecuteTaskPopUpShow={this.state.ExecuteTaskPopUpShow}
                          showOpenProjectSheetAfterBack={this.state.showOpenProjectSheetAfterBack}
                        />
                          </div>
                        );
                    }
                  })}
                </MapInteractionCSS>
              </ContentSection>
              <SideBar
                sideLogAnimation={this.state.sideLogAnimation}
                toggleToolTip={this.toggleToolTip}
                projectId={this.state.projectId}
                data={{
                  earned: player.earnedValue,
                  budget: player.budget,
                }}
                sources={{
                  white: player.resources.regular,
                  red: player.resources.executive,
                  green: player.resources.expensive,
                }}
                bottom={{
                  constrains: 3,
                  milestone: 5,
                  plannedTasks: 1,
                  plannedTasksTotal: 15,
                  unplannedRisks: 0,
                  delayed: 1,
                  gate: 1,
                  risksAndDelays: 3,
                  DelayCardsTaken: 2,
                }}
                gameUid={this.state.player.id}
                logSideBar={this.state.logSideBar}
                additionalBudget={this.additionalBudget}
                commentAdditionalBudget={this.commentAdditionalBudget}
                toggleProject={this.toggleProject}
                projectScopeDisabled={this.ProjectScopeDisable}
                toggleResources={this.toggleResources}
                openStage={this.state.projectStage}
                gameLogToggle={this.gameLogToggle}
                toggleModal={this.toggleModal}
                toggleInfo={this.toggleInfo}
                toggleGameDefinitions={this.toggleGameDefinitions}
                setDisableBudget={this.setDisableBudget}
                show={this.state.modalToggle}
                toggleTutorial={this.toggleTutorial}
                isDisabledPMTasks={this.state.isDisabledPMTasks}
                gameDefinitionsStage={this.state.gameDefinitionsStage}
                handleDefinitionsStage={this.handleDefinitionsStage}
                isCardOpen={this.state.card.cardToggle}
                SoundPlay={this.SoundPlay}
                playerStatus={this.state.playerStatusChange}
                toggleProjectSound={toggleProjectSound}
                goTo={this.goTo}
                different={this.state.playerDifAnimation}
                projectNeedToBeDisabled={this.state.projectNeedToBeDisabled}
                toggleIsAnimationNeeded={this.toggleIsAnimationNeeded}
                animationVars={this.state.animationVars}
                prevDifferent={this.state.prevPlayerDifAnimation}
                currentTile={Board[this.state.player.position]}
                gameId={this.state.player.gameId}
                changeProject={this.toggleChangeProject}
                toggleHelp={this.toggleHelp}
                toggleAdditionalBudget={this.openAdditionalBudgetPopUp}
              />
            </MainContainer >
          ))
        }
      </>
    );
  }
}

export default App;
